/* tslint:disable */
/* eslint-disable */
/**
 * Rehab Planner API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AccountResponse
 */
export interface AccountResponse {
    /**
     * 
     * @type {string}
     * @memberof AccountResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AccountResponse
     */
    'name': string;
    /**
     * 
     * @type {Array<UserPermissionsResponse>}
     * @memberof AccountResponse
     */
    'userPermissions': Array<UserPermissionsResponse>;
    /**
     * 
     * @type {Array<InterventionTemplateResponse>}
     * @memberof AccountResponse
     */
    'interventionTemplates': Array<InterventionTemplateResponse>;
    /**
     * 
     * @type {Array<TreatmentPlanTemplateResponse>}
     * @memberof AccountResponse
     */
    'treatmentPlanTemplates': Array<TreatmentPlanTemplateResponse>;
    /**
     * 
     * @type {Array<PatientRoomPropertyResponse>}
     * @memberof AccountResponse
     */
    'patientRoomProperties': Array<PatientRoomPropertyResponse>;
    /**
     * 
     * @type {Array<InterventionRoomPropertyResponse>}
     * @memberof AccountResponse
     */
    'interventionRoomProperties': Array<InterventionRoomPropertyResponse>;
}
/**
 * 
 * @export
 * @interface AllowedDay
 */
export interface AllowedDay {
    /**
     * 
     * @type {string}
     * @memberof AllowedDay
     */
    'day'?: AllowedDayDayEnum;
    /**
     * 
     * @type {Array<TimeWindow>}
     * @memberof AllowedDay
     */
    'timeWindows'?: Array<TimeWindow>;
}

export const AllowedDayDayEnum = {
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY'
} as const;

export type AllowedDayDayEnum = typeof AllowedDayDayEnum[keyof typeof AllowedDayDayEnum];

/**
 * 
 * @export
 * @interface AssignedPatientResponse
 */
export interface AssignedPatientResponse {
    /**
     * True when this seat is held by a shadow patient; patientId then carries the shadow\'s own ID, not a patient reference
     * @type {boolean}
     * @memberof AssignedPatientResponse
     */
    'shadow': boolean;
    /**
     * 
     * @type {string}
     * @memberof AssignedPatientResponse
     */
    'patientId': string;
    /**
     * 
     * @type {boolean}
     * @memberof AssignedPatientResponse
     */
    'completed': boolean;
    /**
     * 
     * @type {string}
     * @memberof AssignedPatientResponse
     */
    'completedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof AssignedPatientResponse
     */
    'reimbursementOverride'?: number;
    /**
     * Why the group\'s default reimbursement was overridden. Present only when reimbursementOverride is; null means the group default applies and needs no reason.
     * @type {string}
     * @memberof AssignedPatientResponse
     */
    'reimbursementNote'?: string;
}
/**
 * 
 * @export
 * @interface AssignedTreatmentPlanSummaryResponse
 */
export interface AssignedTreatmentPlanSummaryResponse {
    /**
     * 
     * @type {string}
     * @memberof AssignedTreatmentPlanSummaryResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AssignedTreatmentPlanSummaryResponse
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof AssignedTreatmentPlanSummaryResponse
     */
    'year': number;
    /**
     * 
     * @type {number}
     * @memberof AssignedTreatmentPlanSummaryResponse
     */
    'startWeek': number;
    /**
     * 
     * @type {number}
     * @memberof AssignedTreatmentPlanSummaryResponse
     */
    'endWeek': number;
}
/**
 * 
 * @export
 * @interface AuditLogEntryResponse
 */
export interface AuditLogEntryResponse {
    /**
     * 
     * @type {string}
     * @memberof AuditLogEntryResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogEntryResponse
     */
    'authorId': string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogEntryResponse
     */
    'authorName': string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogEntryResponse
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface BookingRequest
 */
export interface BookingRequest {
    /**
     * 
     * @type {string}
     * @memberof BookingRequest
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingRequest
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface BookingResponse
 */
export interface BookingResponse {
    /**
     * 
     * @type {string}
     * @memberof BookingResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BookingResponse
     */
    'locationId': string;
    /**
     * 
     * @type {string}
     * @memberof BookingResponse
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingResponse
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface BookingTime
 */
export interface BookingTime {
    /**
     * 
     * @type {string}
     * @memberof BookingTime
     */
    'kind': string;
}
/**
 * 
 * @export
 * @interface Break
 */
export interface Break {
    /**
     * 
     * @type {string}
     * @memberof Break
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof Break
     */
    'durationMinutes'?: number;
    /**
     * 
     * @type {string}
     * @memberof Break
     */
    'windowStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof Break
     */
    'windowEnd'?: string;
}
/**
 * 
 * @export
 * @interface ClosedDayBookingRequest
 */
export interface ClosedDayBookingRequest extends BookingRequest {
    /**
     * 
     * @type {ClosedDayBookingRequestAllOfTime}
     * @memberof ClosedDayBookingRequest
     */
    'time': ClosedDayBookingRequestAllOfTime;
}
/**
 * @type ClosedDayBookingRequestAllOfTime
 * @export
 */
export type ClosedDayBookingRequestAllOfTime = RecurringOccurrences | SingleOccurrence;

/**
 * 
 * @export
 * @interface ClosedDayBookingResponse
 */
export interface ClosedDayBookingResponse extends BookingResponse {
    /**
     * 
     * @type {ClosedDayBookingResponseAllOfTime}
     * @memberof ClosedDayBookingResponse
     */
    'time': ClosedDayBookingResponseAllOfTime;
}
/**
 * @type ClosedDayBookingResponseAllOfTime
 * @export
 */
export type ClosedDayBookingResponseAllOfTime = RecurringOccurrences | SingleOccurrence;

/**
 * 
 * @export
 * @interface Config
 */
export interface Config {
    /**
     * 
     * @type {number}
     * @memberof Config
     */
    'slotGranularityMinutes'?: number;
    /**
     * 
     * @type {number}
     * @memberof Config
     */
    'patientSessionGapMinutes'?: number;
    /**
     * 
     * @type {number}
     * @memberof Config
     */
    'preferredTransitionMinutes'?: number;
}
/**
 * 
 * @export
 * @interface CreateInterventionRoomPropertyRequest
 */
export interface CreateInterventionRoomPropertyRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateInterventionRoomPropertyRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateInterventionRoomPropertyRequest
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface CreateInterventionRoomRequest
 */
export interface CreateInterventionRoomRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateInterventionRoomRequest
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof CreateInterventionRoomRequest
     */
    'capacityLimit'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateInterventionRoomRequest
     */
    'interventionRoomPropertyIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateInterventionTemplateRequest
 */
export interface CreateInterventionTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateInterventionTemplateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateInterventionTemplateRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInterventionTemplateRequest
     */
    'color'?: string;
    /**
     * 
     * @type {InterventionIcon}
     * @memberof CreateInterventionTemplateRequest
     */
    'icon'?: InterventionIcon;
    /**
     * 
     * @type {number}
     * @memberof CreateInterventionTemplateRequest
     */
    'durationMinutes'?: number;
    /**
     * 
     * @type {SessionType}
     * @memberof CreateInterventionTemplateRequest
     */
    'sessionType': SessionType;
    /**
     * 
     * @type {Array<MandatoryStaffCompetenceRequirement>}
     * @memberof CreateInterventionTemplateRequest
     */
    'mandatoryStaffCompetenceRequirements'?: Array<MandatoryStaffCompetenceRequirement>;
    /**
     * 
     * @type {Array<FlexStaffCompetenceRequirement>}
     * @memberof CreateInterventionTemplateRequest
     */
    'flexStaffCompetenceRequirements'?: Array<FlexStaffCompetenceRequirement>;
    /**
     * 
     * @type {Array<AllowedDay>}
     * @memberof CreateInterventionTemplateRequest
     */
    'allowedDays'?: Array<AllowedDay>;
    /**
     * 
     * @type {Array<InterventionRoomProperty>}
     * @memberof CreateInterventionTemplateRequest
     */
    'roomRequirements'?: Array<InterventionRoomProperty>;
}


/**
 * 
 * @export
 * @interface CreateLocationPermissionsRequest
 */
export interface CreateLocationPermissionsRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateLocationPermissionsRequest
     */
    'locationId': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLocationPermissionsRequest
     */
    'read'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLocationPermissionsRequest
     */
    'write'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLocationPermissionsRequest
     */
    'patientBooker'?: boolean;
}
/**
 * 
 * @export
 * @interface CreatePatientRoomPropertyRequest
 */
export interface CreatePatientRoomPropertyRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePatientRoomPropertyRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientRoomPropertyRequest
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface CreatePatientRoomRequest
 */
export interface CreatePatientRoomRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePatientRoomRequest
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePatientRoomRequest
     */
    'patientRoomPropertyIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateStaffProfessionRequest
 */
export interface CreateStaffProfessionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateStaffProfessionRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateStaffProfessionRequest
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateStaffProfessionRequest
     */
    'showInKpi'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateStaffRequest
 */
export interface CreateStaffRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateStaffRequest
     */
    'fullName': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateStaffRequest
     */
    'staffProfessionIds': Array<string>;
    /**
     * 
     * @type {WeeklyAvailability}
     * @memberof CreateStaffRequest
     */
    'availability': WeeklyAvailability;
    /**
     * 
     * @type {string}
     * @memberof CreateStaffRequest
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreateStaffRequest
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface CreateTreatmentPlanTemplateRequest
 */
export interface CreateTreatmentPlanTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTreatmentPlanTemplateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTreatmentPlanTemplateRequest
     */
    'strokeColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTreatmentPlanTemplateRequest
     */
    'fillColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTreatmentPlanTemplateRequest
     */
    'highlightColor'?: string;
    /**
     * 
     * @type {InterventionIcon}
     * @memberof CreateTreatmentPlanTemplateRequest
     */
    'icon'?: InterventionIcon;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTreatmentPlanTemplateRequest
     */
    'locationIds'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTreatmentPlanTemplateRequest
     */
    'global'?: boolean;
    /**
     * 
     * @type {Array<TreatmentWeekTemplateRequest>}
     * @memberof CreateTreatmentPlanTemplateRequest
     */
    'weeks'?: Array<TreatmentWeekTemplateRequest>;
}


/**
 * 
 * @export
 * @interface CreateUserRequest
 */
export interface CreateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    'lastName': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserRequest
     */
    'accountAdmin'?: boolean;
    /**
     * 
     * @type {Array<CreateLocationPermissionsRequest>}
     * @memberof CreateUserRequest
     */
    'locationPermissions': Array<CreateLocationPermissionsRequest>;
}
/**
 * 
 * @export
 * @interface CurrentAssignment
 */
export interface CurrentAssignment {
    /**
     * 
     * @type {string}
     * @memberof CurrentAssignment
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentAssignment
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentAssignment
     */
    'endTime'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CurrentAssignment
     */
    'staffIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CurrentAssignment
     */
    'roomId'?: string;
}
/**
 * 
 * @export
 * @interface DateWindow
 */
export interface DateWindow {
    /**
     * 
     * @type {string}
     * @memberof DateWindow
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DateWindow
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DateWindow
     */
    'endTime'?: string;
}
/**
 * 
 * @export
 * @interface EconomicsBatchRequest
 */
export interface EconomicsBatchRequest {
    /**
     * 
     * @type {Array<EconomicsChangeEntry>}
     * @memberof EconomicsBatchRequest
     */
    'changes': Array<EconomicsChangeEntry>;
}
/**
 * 
 * @export
 * @interface EconomicsChangeEntry
 */
export interface EconomicsChangeEntry {
    /**
     * 
     * @type {string}
     * @memberof EconomicsChangeEntry
     */
    'treatmentPlanId': string;
    /**
     * 
     * @type {string}
     * @memberof EconomicsChangeEntry
     */
    'interventionGroupId': string;
    /**
     * 
     * @type {string}
     * @memberof EconomicsChangeEntry
     */
    'patientId': string;
    /**
     * 
     * @type {boolean}
     * @memberof EconomicsChangeEntry
     */
    'completed': boolean;
    /**
     * 
     * @type {number}
     * @memberof EconomicsChangeEntry
     */
    'reimbursementOverride'?: number;
    /**
     * 
     * @type {string}
     * @memberof EconomicsChangeEntry
     */
    'note'?: string;
}
/**
 * 
 * @export
 * @interface ExistingUnlockedAssignment
 */
export interface ExistingUnlockedAssignment {
    /**
     * 
     * @type {string}
     * @memberof ExistingUnlockedAssignment
     */
    'interventionId'?: string;
    /**
     * 
     * @type {CurrentAssignment}
     * @memberof ExistingUnlockedAssignment
     */
    'currentAssignment'?: CurrentAssignment;
}
/**
 * 
 * @export
 * @interface FlexStaffCompetenceRequirement
 */
export interface FlexStaffCompetenceRequirement {
    /**
     * 
     * @type {string}
     * @memberof FlexStaffCompetenceRequirement
     */
    'staffProfessionId'?: string;
    /**
     * 
     * @type {number}
     * @memberof FlexStaffCompetenceRequirement
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface FlexiblePlacement
 */
export interface FlexiblePlacement {
    /**
     * 
     * @type {string}
     * @memberof FlexiblePlacement
     */
    'windowStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlexiblePlacement
     */
    'windowEnd'?: string;
    /**
     * 
     * @type {Recurrence}
     * @memberof FlexiblePlacement
     */
    'recurrence'?: Recurrence;
    /**
     * 
     * @type {TimeWindow}
     * @memberof FlexiblePlacement
     */
    'timeOfDayWindow'?: TimeWindow;
    /**
     * 
     * @type {Array<string>}
     * @memberof FlexiblePlacement
     */
    'exceptionDates'?: Array<string>;
}
/**
 * @type GetBooking200Response
 * @export
 */
export type GetBooking200Response = ClosedDayBookingResponse | PatientBookingResponse | ReservedStaffTimeResponse | RoomBookingResponse | StaffBookingResponse;

/**
 * 
 * @export
 * @interface GlobalAdminResponse
 */
export interface GlobalAdminResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GlobalAdminResponse
     */
    'globalAdmin'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const GroupBarSize = {
    Small: 'SMALL',
    Medium: 'MEDIUM',
    Large: 'LARGE'
} as const;

export type GroupBarSize = typeof GroupBarSize[keyof typeof GroupBarSize];


/**
 * 
 * @export
 * @interface Horizon
 */
export interface Horizon {
    /**
     * 
     * @type {string}
     * @memberof Horizon
     */
    'centreId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Horizon
     */
    'horizonStartDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Horizon
     */
    'horizonEndDate'?: string;
    /**
     * 
     * @type {{ [key: string]: TimeWindow; }}
     * @memberof Horizon
     */
    'centreOpeningHours'?: { [key: string]: TimeWindow; };
    /**
     * 
     * @type {Array<DateWindow>}
     * @memberof Horizon
     */
    'centreClosures'?: Array<DateWindow>;
    /**
     * 
     * @type {Config}
     * @memberof Horizon
     */
    'config'?: Config;
}
/**
 * 
 * @export
 * @interface Intervention
 */
export interface Intervention {
    /**
     * 
     * @type {string}
     * @memberof Intervention
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Intervention
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Intervention
     */
    'planId'?: string;
    /**
     * 
     * @type {number}
     * @memberof Intervention
     */
    'durationMinutes'?: number;
    /**
     * 
     * @type {string}
     * @memberof Intervention
     */
    'sessionType'?: InterventionSessionTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof Intervention
     */
    'patientIds'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof Intervention
     */
    'capacity'?: number;
    /**
     * 
     * @type {Array<MandatoryStaffCompetenceRequirement>}
     * @memberof Intervention
     */
    'mandatoryStaffCompetenceRequirements'?: Array<MandatoryStaffCompetenceRequirement>;
    /**
     * 
     * @type {Array<FlexStaffCompetenceRequirement>}
     * @memberof Intervention
     */
    'flexStaffCompetenceRequirements'?: Array<FlexStaffCompetenceRequirement>;
    /**
     * 
     * @type {Array<DateWindow>}
     * @memberof Intervention
     */
    'allowedIntervals'?: Array<DateWindow>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Intervention
     */
    'allowedRoomIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Intervention
     */
    'requiredRoomPropertyId'?: string;
    /**
     * 
     * @type {Array<PlacementRule>}
     * @memberof Intervention
     */
    'placementRules'?: Array<PlacementRule>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Intervention
     */
    'preferredStaffIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Intervention
     */
    'fixedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Intervention
     */
    'fixedStartTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof Intervention
     */
    'fixedEndTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof Intervention
     */
    'fixedRoomId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Intervention
     */
    'fixedStaffIds'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof Intervention
     */
    'fullyLocked'?: boolean;
}

export const InterventionSessionTypeEnum = {
    Individual: 'INDIVIDUAL',
    Group: 'GROUP',
    Internal: 'INTERNAL'
} as const;

export type InterventionSessionTypeEnum = typeof InterventionSessionTypeEnum[keyof typeof InterventionSessionTypeEnum];

/**
 * 
 * @export
 * @interface InterventionDto
 */
export interface InterventionDto {
    /**
     * 
     * @type {string}
     * @memberof InterventionDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof InterventionDto
     */
    'interventionTemplateId': string;
    /**
     * 
     * @type {string}
     * @memberof InterventionDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof InterventionDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof InterventionDto
     */
    'color'?: string;
    /**
     * 
     * @type {InterventionIcon}
     * @memberof InterventionDto
     */
    'icon'?: InterventionIcon;
    /**
     * 
     * @type {number}
     * @memberof InterventionDto
     */
    'durationMinutes'?: number;
    /**
     * 
     * @type {SessionType}
     * @memberof InterventionDto
     */
    'sessionType'?: SessionType;
    /**
     * 
     * @type {Array<MandatoryStaffCompetenceRequirement>}
     * @memberof InterventionDto
     */
    'mandatoryStaffCompetenceRequirements'?: Array<MandatoryStaffCompetenceRequirement>;
    /**
     * 
     * @type {Array<FlexStaffCompetenceRequirement>}
     * @memberof InterventionDto
     */
    'flexStaffCompetenceRequirements'?: Array<FlexStaffCompetenceRequirement>;
    /**
     * 
     * @type {Array<AllowedDay>}
     * @memberof InterventionDto
     */
    'allowedDays'?: Array<AllowedDay>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InterventionDto
     */
    'roomRequirementIds'?: Array<string>;
}


/**
 * 
 * @export
 * @interface InterventionGroupDto
 */
export interface InterventionGroupDto {
    /**
     * 
     * @type {string}
     * @memberof InterventionGroupDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof InterventionGroupDto
     */
    'name'?: string;
    /**
     * 
     * @type {InterventionIcon}
     * @memberof InterventionGroupDto
     */
    'icon'?: InterventionIcon;
    /**
     * 
     * @type {number}
     * @memberof InterventionGroupDto
     */
    'order'?: number;
    /**
     * 
     * @type {GroupBarSize}
     * @memberof InterventionGroupDto
     */
    'barSize'?: GroupBarSize;
    /**
     * 
     * @type {number}
     * @memberof InterventionGroupDto
     */
    'reimbursementAmount'?: number;
    /**
     * 
     * @type {PatientLocationType}
     * @memberof InterventionGroupDto
     */
    'patientType'?: PatientLocationType;
    /**
     * 
     * @type {number}
     * @memberof InterventionGroupDto
     */
    'capacity'?: number;
    /**
     * 
     * @type {Array<InterventionDto>}
     * @memberof InterventionGroupDto
     */
    'interventions': Array<InterventionDto>;
    /**
     * 
     * @type {Array<PlacementRule>}
     * @memberof InterventionGroupDto
     */
    'placementRules'?: Array<PlacementRule>;
    /**
     * Server-owned seat state (real patients and shadow patients); ignored on requests
     * @type {Array<AssignedPatientResponse>}
     * @memberof InterventionGroupDto
     */
    'assignedPatients'?: Array<AssignedPatientResponse>;
}


/**
 * 
 * @export
 * @interface InterventionGroupIdsRequest
 */
export interface InterventionGroupIdsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof InterventionGroupIdsRequest
     */
    'interventionGroupIds': Array<string>;
}
/**
 * 
 * @export
 * @interface InterventionGroupTemplateRequest
 */
export interface InterventionGroupTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof InterventionGroupTemplateRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof InterventionGroupTemplateRequest
     */
    'name': string;
    /**
     * 
     * @type {InterventionIcon}
     * @memberof InterventionGroupTemplateRequest
     */
    'icon'?: InterventionIcon;
    /**
     * 
     * @type {number}
     * @memberof InterventionGroupTemplateRequest
     */
    'order'?: number;
    /**
     * 
     * @type {GroupBarSize}
     * @memberof InterventionGroupTemplateRequest
     */
    'barSize': GroupBarSize;
    /**
     * 
     * @type {number}
     * @memberof InterventionGroupTemplateRequest
     */
    'reimbursementAmount'?: number;
    /**
     * 
     * @type {PatientLocationType}
     * @memberof InterventionGroupTemplateRequest
     */
    'patientType'?: PatientLocationType;
    /**
     * 
     * @type {Array<InterventionTemplateRequest>}
     * @memberof InterventionGroupTemplateRequest
     */
    'interventions'?: Array<InterventionTemplateRequest>;
    /**
     * 
     * @type {Array<PlacementRule>}
     * @memberof InterventionGroupTemplateRequest
     */
    'placementRules'?: Array<PlacementRule>;
}


/**
 * 
 * @export
 * @interface InterventionGroupTemplateResponse
 */
export interface InterventionGroupTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof InterventionGroupTemplateResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof InterventionGroupTemplateResponse
     */
    'name': string;
    /**
     * 
     * @type {InterventionIcon}
     * @memberof InterventionGroupTemplateResponse
     */
    'icon'?: InterventionIcon;
    /**
     * 
     * @type {number}
     * @memberof InterventionGroupTemplateResponse
     */
    'order': number;
    /**
     * 
     * @type {GroupBarSize}
     * @memberof InterventionGroupTemplateResponse
     */
    'barSize': GroupBarSize;
    /**
     * 
     * @type {number}
     * @memberof InterventionGroupTemplateResponse
     */
    'reimbursementAmount'?: number;
    /**
     * 
     * @type {PatientLocationType}
     * @memberof InterventionGroupTemplateResponse
     */
    'patientType': PatientLocationType;
    /**
     * 
     * @type {Array<InterventionTemplateResponse>}
     * @memberof InterventionGroupTemplateResponse
     */
    'interventions': Array<InterventionTemplateResponse>;
    /**
     * 
     * @type {Array<PlacementRule>}
     * @memberof InterventionGroupTemplateResponse
     */
    'placementRules': Array<PlacementRule>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const InterventionIcon = {
    Physiotherapy: 'PHYSIOTHERAPY',
    Hydrotherapy: 'HYDROTHERAPY',
    Psychology: 'PSYCHOLOGY',
    OccupationalTherapy: 'OCCUPATIONAL_THERAPY',
    GroupExercise: 'GROUP_EXERCISE',
    IndividualExercise: 'INDIVIDUAL_EXERCISE',
    Education: 'EDUCATION',
    SocialCounseling: 'SOCIAL_COUNSELING',
    Nursing: 'NURSING',
    MedicalConsultation: 'MEDICAL_CONSULTATION',
    Nutrition: 'NUTRITION',
    Assessment: 'ASSESSMENT',
    OnlineSession: 'ONLINE_SESSION',
    PainManagement: 'PAIN_MANAGEMENT',
    FatigueManagement: 'FATIGUE_MANAGEMENT',
    WorkplaceRehab: 'WORKPLACE_REHAB',
    Mindfulness: 'MINDFULNESS',
    Sports: 'SPORTS',
    Creativity: 'CREATIVITY',
    Other: 'OTHER'
} as const;

export type InterventionIcon = typeof InterventionIcon[keyof typeof InterventionIcon];


/**
 * 
 * @export
 * @interface InterventionRoomProperty
 */
export interface InterventionRoomProperty {
    /**
     * 
     * @type {string}
     * @memberof InterventionRoomProperty
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof InterventionRoomProperty
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof InterventionRoomProperty
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface InterventionRoomPropertyResponse
 */
export interface InterventionRoomPropertyResponse {
    /**
     * 
     * @type {string}
     * @memberof InterventionRoomPropertyResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof InterventionRoomPropertyResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof InterventionRoomPropertyResponse
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface InterventionRoomResponse
 */
export interface InterventionRoomResponse {
    /**
     * 
     * @type {string}
     * @memberof InterventionRoomResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof InterventionRoomResponse
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof InterventionRoomResponse
     */
    'capacityLimit'?: number;
    /**
     * 
     * @type {Array<InterventionRoomPropertyResponse>}
     * @memberof InterventionRoomResponse
     */
    'interventionRoomProperties': Array<InterventionRoomPropertyResponse>;
}
/**
 * 
 * @export
 * @interface InterventionTemplateRequest
 */
export interface InterventionTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof InterventionTemplateRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof InterventionTemplateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof InterventionTemplateRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof InterventionTemplateRequest
     */
    'color'?: string;
    /**
     * 
     * @type {InterventionIcon}
     * @memberof InterventionTemplateRequest
     */
    'icon'?: InterventionIcon;
    /**
     * 
     * @type {number}
     * @memberof InterventionTemplateRequest
     */
    'durationMinutes'?: number;
    /**
     * 
     * @type {SessionType}
     * @memberof InterventionTemplateRequest
     */
    'sessionType': SessionType;
    /**
     * 
     * @type {Array<MandatoryStaffCompetenceRequirement>}
     * @memberof InterventionTemplateRequest
     */
    'mandatoryStaffCompetenceRequirements'?: Array<MandatoryStaffCompetenceRequirement>;
    /**
     * 
     * @type {Array<FlexStaffCompetenceRequirement>}
     * @memberof InterventionTemplateRequest
     */
    'flexStaffCompetenceRequirements'?: Array<FlexStaffCompetenceRequirement>;
    /**
     * 
     * @type {Array<AllowedDay>}
     * @memberof InterventionTemplateRequest
     */
    'allowedDays'?: Array<AllowedDay>;
    /**
     * 
     * @type {Array<InterventionRoomProperty>}
     * @memberof InterventionTemplateRequest
     */
    'roomRequirements'?: Array<InterventionRoomProperty>;
}


/**
 * 
 * @export
 * @interface InterventionTemplateResponse
 */
export interface InterventionTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof InterventionTemplateResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof InterventionTemplateResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof InterventionTemplateResponse
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof InterventionTemplateResponse
     */
    'color'?: string;
    /**
     * 
     * @type {InterventionIcon}
     * @memberof InterventionTemplateResponse
     */
    'icon'?: InterventionIcon;
    /**
     * 
     * @type {number}
     * @memberof InterventionTemplateResponse
     */
    'durationMinutes': number;
    /**
     * 
     * @type {SessionType}
     * @memberof InterventionTemplateResponse
     */
    'sessionType': SessionType;
    /**
     * 
     * @type {Array<MandatoryStaffCompetenceRequirement>}
     * @memberof InterventionTemplateResponse
     */
    'mandatoryStaffCompetenceRequirements': Array<MandatoryStaffCompetenceRequirement>;
    /**
     * 
     * @type {Array<FlexStaffCompetenceRequirement>}
     * @memberof InterventionTemplateResponse
     */
    'flexStaffCompetenceRequirements': Array<FlexStaffCompetenceRequirement>;
    /**
     * 
     * @type {Array<AllowedDay>}
     * @memberof InterventionTemplateResponse
     */
    'allowedDays'?: Array<AllowedDay>;
    /**
     * 
     * @type {Array<InterventionRoomProperty>}
     * @memberof InterventionTemplateResponse
     */
    'roomRequirements': Array<InterventionRoomProperty>;
}


/**
 * 
 * @export
 * @interface LocationPermissionsResponse
 */
export interface LocationPermissionsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof LocationPermissionsResponse
     */
    'read': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LocationPermissionsResponse
     */
    'write': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LocationPermissionsResponse
     */
    'patientBooker': boolean;
}
/**
 * 
 * @export
 * @interface LocationResponse
 */
export interface LocationResponse {
    /**
     * 
     * @type {string}
     * @memberof LocationResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LocationResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof LocationResponse
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof LocationResponse
     */
    'address': string;
}
/**
 * 
 * @export
 * @interface LockResponse
 */
export interface LockResponse {
    /**
     * 
     * @type {string}
     * @memberof LockResponse
     */
    'status': LockResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof LockResponse
     */
    'lockedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof LockResponse
     */
    'expiresAt'?: string;
}

export const LockResponseStatusEnum = {
    Acquired: 'ACQUIRED',
    Renewed: 'RENEWED',
    HeldByOther: 'HELD_BY_OTHER',
    NotFound: 'NOT_FOUND'
} as const;

export type LockResponseStatusEnum = typeof LockResponseStatusEnum[keyof typeof LockResponseStatusEnum];

/**
 * 
 * @export
 * @interface LockStatusResponse
 */
export interface LockStatusResponse {
    /**
     * 
     * @type {UserName}
     * @memberof LockStatusResponse
     */
    'lockedByName'?: UserName;
    /**
     * 
     * @type {string}
     * @memberof LockStatusResponse
     */
    'expiresAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof LockStatusResponse
     */
    'lockedByCurrentUser': boolean;
}
/**
 * 
 * @export
 * @interface MandatoryStaffCompetenceRequirement
 */
export interface MandatoryStaffCompetenceRequirement {
    /**
     * 
     * @type {Array<string>}
     * @memberof MandatoryStaffCompetenceRequirement
     */
    'staffProfessionIds'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof MandatoryStaffCompetenceRequirement
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof MandatoryStaffCompetenceRequirement
     */
    'preProcessingMinutes'?: number;
    /**
     * 
     * @type {number}
     * @memberof MandatoryStaffCompetenceRequirement
     */
    'postProcessingMinutes'?: number;
}
/**
 * 
 * @export
 * @interface OperatorStat
 */
export interface OperatorStat {
    /**
     * 
     * @type {string}
     * @memberof OperatorStat
     */
    'operatorName'?: string;
    /**
     * 
     * @type {number}
     * @memberof OperatorStat
     */
    'invocationCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof OperatorStat
     */
    'improvementCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof OperatorStat
     */
    'finalWeight'?: number;
}
/**
 * 
 * @export
 * @interface Patient
 */
export interface Patient {
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'displayName'?: string;
    /**
     * 
     * @type {{ [key: string]: TimeWindow; }}
     * @memberof Patient
     */
    'lunchBreaks'?: { [key: string]: TimeWindow; };
}
/**
 * 
 * @export
 * @interface PatientBookingRequest
 */
export interface PatientBookingRequest extends BookingRequest {
    /**
     * 
     * @type {PatientBookingType}
     * @memberof PatientBookingRequest
     */
    'patientBookingType': PatientBookingType;
    /**
     * 
     * @type {Set<string>}
     * @memberof PatientBookingRequest
     */
    'patientIds': Set<string>;
    /**
     * 
     * @type {PatientBookingRequestAllOfTime}
     * @memberof PatientBookingRequest
     */
    'time': PatientBookingRequestAllOfTime;
}


/**
 * @type PatientBookingRequestAllOfTime
 * @export
 */
export type PatientBookingRequestAllOfTime = RecurringOccurrences | SingleOccurrence;

/**
 * 
 * @export
 * @interface PatientBookingResponse
 */
export interface PatientBookingResponse extends BookingResponse {
    /**
     * 
     * @type {PatientBookingType}
     * @memberof PatientBookingResponse
     */
    'patientBookingType': PatientBookingType;
    /**
     * 
     * @type {Set<string>}
     * @memberof PatientBookingResponse
     */
    'patientIds': Set<string>;
    /**
     * 
     * @type {PatientBookingResponseAllOfTime}
     * @memberof PatientBookingResponse
     */
    'time': PatientBookingResponseAllOfTime;
}


/**
 * @type PatientBookingResponseAllOfTime
 * @export
 */
export type PatientBookingResponseAllOfTime = RecurringOccurrences | SingleOccurrence;

/**
 * 
 * @export
 * @enum {string}
 */

export const PatientBookingType = {
    Specific: 'SPECIFIC',
    AllAdmitted: 'ALL_ADMITTED',
    AllNonAdmitted: 'ALL_NON_ADMITTED'
} as const;

export type PatientBookingType = typeof PatientBookingType[keyof typeof PatientBookingType];


/**
 * 
 * @export
 * @interface PatientDrawerResponse
 */
export interface PatientDrawerResponse {
    /**
     * 
     * @type {PatientResponse}
     * @memberof PatientDrawerResponse
     */
    'profile': PatientResponse;
    /**
     * 
     * @type {Array<PatientTreatmentPlanDetailsResponse>}
     * @memberof PatientDrawerResponse
     */
    'treatmentPlans': Array<PatientTreatmentPlanDetailsResponse>;
    /**
     * 
     * @type {Array<AuditLogEntryResponse>}
     * @memberof PatientDrawerResponse
     */
    'auditLog': Array<AuditLogEntryResponse>;
}
/**
 * 
 * @export
 * @interface PatientIdsRequest
 */
export interface PatientIdsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof PatientIdsRequest
     */
    'patientIds': Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PatientLocationType = {
    Home: 'HOME',
    Admitted: 'ADMITTED'
} as const;

export type PatientLocationType = typeof PatientLocationType[keyof typeof PatientLocationType];


/**
 * 
 * @export
 * @interface PatientRequest
 */
export interface PatientRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PatientRequest
     */
    'cprNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PatientRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientRequest
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientRequest
     */
    'note'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatientRequest
     */
    'patientRoomNeedIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PatientResponse
 */
export interface PatientResponse {
    /**
     * 
     * @type {string}
     * @memberof PatientResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PatientResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PatientResponse
     */
    'cprNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PatientResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientResponse
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientResponse
     */
    'note'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatientResponse
     */
    'patientRoomNeedIds': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PatientResponse
     */
    'deleted': boolean;
}
/**
 * 
 * @export
 * @interface PatientRoomPropertyResponse
 */
export interface PatientRoomPropertyResponse {
    /**
     * 
     * @type {string}
     * @memberof PatientRoomPropertyResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PatientRoomPropertyResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PatientRoomPropertyResponse
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface PatientRoomPropertyUsageResponse
 */
export interface PatientRoomPropertyUsageResponse {
    /**
     * 
     * @type {string}
     * @memberof PatientRoomPropertyUsageResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PatientRoomPropertyUsageResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PatientRoomPropertyUsageResponse
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientRoomPropertyUsageResponse
     */
    'patientRoomCount': number;
}
/**
 * 
 * @export
 * @interface PatientRoomResponse
 */
export interface PatientRoomResponse {
    /**
     * 
     * @type {string}
     * @memberof PatientRoomResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PatientRoomResponse
     */
    'description': string;
    /**
     * 
     * @type {Array<PatientRoomPropertyResponse>}
     * @memberof PatientRoomResponse
     */
    'patientRoomProperties': Array<PatientRoomPropertyResponse>;
}
/**
 * 
 * @export
 * @interface PatientTreatmentPlanDetailsResponse
 */
export interface PatientTreatmentPlanDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof PatientTreatmentPlanDetailsResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PatientTreatmentPlanDetailsResponse
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof PatientTreatmentPlanDetailsResponse
     */
    'year': number;
    /**
     * 
     * @type {number}
     * @memberof PatientTreatmentPlanDetailsResponse
     */
    'startWeek': number;
    /**
     * 
     * @type {number}
     * @memberof PatientTreatmentPlanDetailsResponse
     */
    'endWeek': number;
    /**
     * 
     * @type {string}
     * @memberof PatientTreatmentPlanDetailsResponse
     */
    'strokeColor': string;
    /**
     * 
     * @type {Array<PatientTreatmentPlanGroupResponse>}
     * @memberof PatientTreatmentPlanDetailsResponse
     */
    'interventionGroups': Array<PatientTreatmentPlanGroupResponse>;
}
/**
 * 
 * @export
 * @interface PatientTreatmentPlanGroupResponse
 */
export interface PatientTreatmentPlanGroupResponse {
    /**
     * 
     * @type {string}
     * @memberof PatientTreatmentPlanGroupResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PatientTreatmentPlanGroupResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PatientTreatmentPlanGroupResponse
     */
    'icon'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientTreatmentPlanGroupResponse
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof PatientTreatmentPlanGroupResponse
     */
    'endDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientTreatmentPlanGroupResponse
     */
    'assigned': boolean;
}
/**
 * 
 * @export
 * @interface PhaseDiagnostics
 */
export interface PhaseDiagnostics {
    /**
     * 
     * @type {string}
     * @memberof PhaseDiagnostics
     */
    'phaseName'?: string;
    /**
     * 
     * @type {number}
     * @memberof PhaseDiagnostics
     */
    'startIteration'?: number;
    /**
     * 
     * @type {number}
     * @memberof PhaseDiagnostics
     */
    'endIteration'?: number;
    /**
     * 
     * @type {number}
     * @memberof PhaseDiagnostics
     */
    'computeTimeMs'?: number;
}
/**
 * 
 * @export
 * @interface PlacementRule
 */
export interface PlacementRule {
    /**
     * 
     * @type {string}
     * @memberof PlacementRule
     */
    'sourceInterventionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlacementRule
     */
    'targetInterventionId'?: string;
    /**
     * 
     * @type {PlacementRuleType}
     * @memberof PlacementRule
     */
    'type'?: PlacementRuleType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PlacementRuleType = {
    First: 'FIRST',
    Last: 'LAST',
    Before: 'BEFORE',
    After: 'AFTER',
    ImmediatelyBefore: 'IMMEDIATELY_BEFORE',
    ImmediatelyAfter: 'IMMEDIATELY_AFTER'
} as const;

export type PlacementRuleType = typeof PlacementRuleType[keyof typeof PlacementRuleType];


/**
 * 
 * @export
 * @interface ProposedAssignment
 */
export interface ProposedAssignment {
    /**
     * 
     * @type {string}
     * @memberof ProposedAssignment
     */
    'assignedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposedAssignment
     */
    'assignedStartTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposedAssignment
     */
    'assignedRoomId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposedAssignment
     */
    'plannedInterventionId'?: string;
    /**
     * 
     * @type {Array<StaffOccupancy>}
     * @memberof ProposedAssignment
     */
    'staffOccupancies'?: Array<StaffOccupancy>;
    /**
     * 
     * @type {Set<string>}
     * @memberof ProposedAssignment
     */
    'preferenceGaps'?: Set<ProposedAssignmentPreferenceGapsEnum>;
}

export const ProposedAssignmentPreferenceGapsEnum = {
    UnscheduledCount: 'UNSCHEDULED_COUNT',
    PreferredStaff: 'PREFERRED_STAFF'
} as const;

export type ProposedAssignmentPreferenceGapsEnum = typeof ProposedAssignmentPreferenceGapsEnum[keyof typeof ProposedAssignmentPreferenceGapsEnum];

/**
 * 
 * @export
 * @interface Recurrence
 */
export interface Recurrence {
    /**
     * 
     * @type {Set<string>}
     * @memberof Recurrence
     */
    'daysOfWeek'?: Set<RecurrenceDaysOfWeekEnum>;
    /**
     * 
     * @type {number}
     * @memberof Recurrence
     */
    'intervalWeeks'?: number;
}

export const RecurrenceDaysOfWeekEnum = {
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY'
} as const;

export type RecurrenceDaysOfWeekEnum = typeof RecurrenceDaysOfWeekEnum[keyof typeof RecurrenceDaysOfWeekEnum];

/**
 * 
 * @export
 * @interface RecurringOccurrences
 */
export interface RecurringOccurrences extends BookingTime {
    /**
     * 
     * @type {string}
     * @memberof RecurringOccurrences
     */
    'occurrenceStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecurringOccurrences
     */
    'occurrenceEnd'?: string;
    /**
     * 
     * @type {TimeWindow}
     * @memberof RecurringOccurrences
     */
    'timeWindow'?: TimeWindow;
    /**
     * 
     * @type {Recurrence}
     * @memberof RecurringOccurrences
     */
    'recurrence'?: Recurrence;
    /**
     * 
     * @type {Array<string>}
     * @memberof RecurringOccurrences
     */
    'exceptionDates'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ReservedStaffTimeRequest
 */
export interface ReservedStaffTimeRequest extends BookingRequest {
    /**
     * 
     * @type {string}
     * @memberof ReservedStaffTimeRequest
     */
    'staffId': string;
    /**
     * 
     * @type {number}
     * @memberof ReservedStaffTimeRequest
     */
    'durationMinutes'?: number;
    /**
     * 
     * @type {FlexiblePlacement}
     * @memberof ReservedStaffTimeRequest
     */
    'placement': FlexiblePlacement;
}
/**
 * 
 * @export
 * @interface ReservedStaffTimeResponse
 */
export interface ReservedStaffTimeResponse extends BookingResponse {
    /**
     * 
     * @type {string}
     * @memberof ReservedStaffTimeResponse
     */
    'staffId': string;
    /**
     * 
     * @type {number}
     * @memberof ReservedStaffTimeResponse
     */
    'durationMinutes': number;
    /**
     * 
     * @type {FlexiblePlacement}
     * @memberof ReservedStaffTimeResponse
     */
    'placement': FlexiblePlacement;
}
/**
 * 
 * @export
 * @interface Room
 */
export interface Room {
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    'displayName'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Room
     */
    'roomPropertyIds'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof Room
     */
    'capacity'?: number;
}
/**
 * 
 * @export
 * @interface RoomBookingRequest
 */
export interface RoomBookingRequest extends BookingRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomBookingRequest
     */
    'roomId': string;
    /**
     * 
     * @type {RoomBookingRequestAllOfTime}
     * @memberof RoomBookingRequest
     */
    'time': RoomBookingRequestAllOfTime;
    /**
     * 
     * @type {Array<MandatoryStaffCompetenceRequirement>}
     * @memberof RoomBookingRequest
     */
    'mandatoryStaffCompetenceRequirements': Array<MandatoryStaffCompetenceRequirement>;
    /**
     * 
     * @type {Array<FlexStaffCompetenceRequirement>}
     * @memberof RoomBookingRequest
     */
    'flexStaffCompetenceRequirements': Array<FlexStaffCompetenceRequirement>;
}
/**
 * @type RoomBookingRequestAllOfTime
 * @export
 */
export type RoomBookingRequestAllOfTime = RecurringOccurrences | SingleOccurrence;

/**
 * 
 * @export
 * @interface RoomBookingResponse
 */
export interface RoomBookingResponse extends BookingResponse {
    /**
     * 
     * @type {string}
     * @memberof RoomBookingResponse
     */
    'roomId': string;
    /**
     * 
     * @type {RoomBookingResponseAllOfTime}
     * @memberof RoomBookingResponse
     */
    'time': RoomBookingResponseAllOfTime;
    /**
     * 
     * @type {Array<MandatoryStaffCompetenceRequirement>}
     * @memberof RoomBookingResponse
     */
    'mandatoryStaffCompetenceRequirements': Array<MandatoryStaffCompetenceRequirement>;
    /**
     * 
     * @type {Array<FlexStaffCompetenceRequirement>}
     * @memberof RoomBookingResponse
     */
    'flexStaffCompetenceRequirements': Array<FlexStaffCompetenceRequirement>;
}
/**
 * @type RoomBookingResponseAllOfTime
 * @export
 */
export type RoomBookingResponseAllOfTime = RecurringOccurrences | SingleOccurrence;

/**
 * 
 * @export
 * @interface SatisfactionIssue
 */
export interface SatisfactionIssue {
    /**
     * 
     * @type {string}
     * @memberof SatisfactionIssue
     */
    'interventionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SatisfactionIssue
     */
    'criterionGap'?: SatisfactionIssueCriterionGapEnum;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SatisfactionIssue
     */
    'context'?: { [key: string]: string; };
}

export const SatisfactionIssueCriterionGapEnum = {
    UnscheduledCount: 'UNSCHEDULED_COUNT',
    PreferredStaff: 'PREFERRED_STAFF'
} as const;

export type SatisfactionIssueCriterionGapEnum = typeof SatisfactionIssueCriterionGapEnum[keyof typeof SatisfactionIssueCriterionGapEnum];

/**
 * 
 * @export
 * @interface ScenarioResponse
 */
export interface ScenarioResponse {
    /**
     * 
     * @type {string}
     * @memberof ScenarioResponse
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof ScenarioResponse
     */
    'year': number;
}
/**
 * 
 * @export
 * @interface SchedulingInput
 */
export interface SchedulingInput {
    /**
     * 
     * @type {Horizon}
     * @memberof SchedulingInput
     */
    'horizon'?: Horizon;
    /**
     * 
     * @type {Array<Room>}
     * @memberof SchedulingInput
     */
    'rooms'?: Array<Room>;
    /**
     * 
     * @type {Array<Staff>}
     * @memberof SchedulingInput
     */
    'staff'?: Array<Staff>;
    /**
     * 
     * @type {Array<Patient>}
     * @memberof SchedulingInput
     */
    'patients'?: Array<Patient>;
    /**
     * 
     * @type {Array<Intervention>}
     * @memberof SchedulingInput
     */
    'interventions'?: Array<Intervention>;
    /**
     * 
     * @type {Array<ExistingUnlockedAssignment>}
     * @memberof SchedulingInput
     */
    'existingUnlockedAssignments'?: Array<ExistingUnlockedAssignment>;
}
/**
 * 
 * @export
 * @interface SchedulingJobResponse
 */
export interface SchedulingJobResponse {
    /**
     * 
     * @type {string}
     * @memberof SchedulingJobResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SchedulingJobResponse
     */
    'scenarioId': string;
    /**
     * 
     * @type {number}
     * @memberof SchedulingJobResponse
     */
    'weekNumber': number;
    /**
     * 
     * @type {string}
     * @memberof SchedulingJobResponse
     */
    'status': SchedulingJobResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SchedulingJobResponse
     */
    'triggerType': SchedulingJobResponseTriggerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SchedulingJobResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SchedulingJobResponse
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulingJobResponse
     */
    'claimedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulingJobResponse
     */
    'finishedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof SchedulingJobResponse
     */
    'attempts': number;
    /**
     * 
     * @type {string}
     * @memberof SchedulingJobResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulingJobResponse
     */
    'supersededBy'?: string;
}

export const SchedulingJobResponseStatusEnum = {
    Waiting: 'WAITING',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Cancelled: 'CANCELLED'
} as const;

export type SchedulingJobResponseStatusEnum = typeof SchedulingJobResponseStatusEnum[keyof typeof SchedulingJobResponseStatusEnum];
export const SchedulingJobResponseTriggerTypeEnum = {
    User: 'USER',
    BookingChange: 'BOOKING_CHANGE'
} as const;

export type SchedulingJobResponseTriggerTypeEnum = typeof SchedulingJobResponseTriggerTypeEnum[keyof typeof SchedulingJobResponseTriggerTypeEnum];

/**
 * 
 * @export
 * @interface SchedulingJobResultResponse
 */
export interface SchedulingJobResultResponse {
    /**
     * 
     * @type {string}
     * @memberof SchedulingJobResultResponse
     */
    'jobId': string;
    /**
     * 
     * @type {string}
     * @memberof SchedulingJobResultResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SchedulingJobResultResponse
     */
    'finishedAt': string;
    /**
     * 
     * @type {SchedulingResult}
     * @memberof SchedulingJobResultResponse
     */
    'result': SchedulingResult;
}
/**
 * 
 * @export
 * @interface SchedulingJobWeekStatusResponse
 */
export interface SchedulingJobWeekStatusResponse {
    /**
     * 
     * @type {number}
     * @memberof SchedulingJobWeekStatusResponse
     */
    'weekNumber': number;
    /**
     * 
     * @type {string}
     * @memberof SchedulingJobWeekStatusResponse
     */
    'status': SchedulingJobWeekStatusResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SchedulingJobWeekStatusResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SchedulingJobWeekStatusResponse
     */
    'finishedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulingJobWeekStatusResponse
     */
    'errorMessage'?: string;
}

export const SchedulingJobWeekStatusResponseStatusEnum = {
    Waiting: 'WAITING',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Cancelled: 'CANCELLED'
} as const;

export type SchedulingJobWeekStatusResponseStatusEnum = typeof SchedulingJobWeekStatusResponseStatusEnum[keyof typeof SchedulingJobWeekStatusResponseStatusEnum];

/**
 * 
 * @export
 * @interface SchedulingResult
 */
export interface SchedulingResult {
    /**
     * 
     * @type {SchedulingInput}
     * @memberof SchedulingResult
     */
    'input'?: SchedulingInput;
    /**
     * 
     * @type {Array<ProposedAssignment>}
     * @memberof SchedulingResult
     */
    'plan'?: Array<ProposedAssignment>;
    /**
     * 
     * @type {Array<SatisfactionIssue>}
     * @memberof SchedulingResult
     */
    'issues'?: Array<SatisfactionIssue>;
    /**
     * 
     * @type {Array<number>}
     * @memberof SchedulingResult
     */
    'objectiveScore'?: Array<number>;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof SchedulingResult
     */
    'criterionTotals'?: { [key: string]: number; };
    /**
     * 
     * @type {SolverDiagnostics}
     * @memberof SchedulingResult
     */
    'diagnostics'?: SolverDiagnostics;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SessionType = {
    Individual: 'INDIVIDUAL',
    Group: 'GROUP',
    Internal: 'INTERNAL'
} as const;

export type SessionType = typeof SessionType[keyof typeof SessionType];


/**
 * 
 * @export
 * @interface SingleOccurrence
 */
export interface SingleOccurrence extends BookingTime {
    /**
     * 
     * @type {string}
     * @memberof SingleOccurrence
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleOccurrence
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface SolverDiagnostics
 */
export interface SolverDiagnostics {
    /**
     * 
     * @type {number}
     * @memberof SolverDiagnostics
     */
    'totalIterations'?: number;
    /**
     * 
     * @type {number}
     * @memberof SolverDiagnostics
     */
    'totalComputeTimeMs'?: number;
    /**
     * 
     * @type {string}
     * @memberof SolverDiagnostics
     */
    'terminationReason'?: SolverDiagnosticsTerminationReasonEnum;
    /**
     * 
     * @type {number}
     * @memberof SolverDiagnostics
     */
    'bestFoundAtIteration'?: number;
    /**
     * 
     * @type {number}
     * @memberof SolverDiagnostics
     */
    'bestFoundComputeTimeMs'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof SolverDiagnostics
     */
    'bestObjectiveScore'?: Array<number>;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof SolverDiagnostics
     */
    'bestCriterionTotals'?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof SolverDiagnostics
     */
    'acceptedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SolverDiagnostics
     */
    'rejectedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SolverDiagnostics
     */
    'newGlobalBestCount'?: number;
    /**
     * 
     * @type {Array<PhaseDiagnostics>}
     * @memberof SolverDiagnostics
     */
    'phases'?: Array<PhaseDiagnostics>;
    /**
     * 
     * @type {Array<OperatorStat>}
     * @memberof SolverDiagnostics
     */
    'operatorStats'?: Array<OperatorStat>;
    /**
     * 
     * @type {Array<TrajectoryPoint>}
     * @memberof SolverDiagnostics
     */
    'trajectory'?: Array<TrajectoryPoint>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SolverDiagnostics
     */
    'validationWarnings'?: Array<string>;
    /**
     * 
     * @type {Array<UnscheduledDiagnostic>}
     * @memberof SolverDiagnostics
     */
    'unscheduledDiagnostics'?: Array<UnscheduledDiagnostic>;
}

export const SolverDiagnosticsTerminationReasonEnum = {
    Completed: 'COMPLETED',
    IterationLimit: 'ITERATION_LIMIT',
    DurationLimit: 'DURATION_LIMIT',
    NoImprovement: 'NO_IMPROVEMENT',
    Cancelled: 'CANCELLED'
} as const;

export type SolverDiagnosticsTerminationReasonEnum = typeof SolverDiagnosticsTerminationReasonEnum[keyof typeof SolverDiagnosticsTerminationReasonEnum];

/**
 * 
 * @export
 * @interface Staff
 */
export interface Staff {
    /**
     * 
     * @type {string}
     * @memberof Staff
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Staff
     */
    'displayName'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Staff
     */
    'staffProfessionIds'?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: TimeWindow; }}
     * @memberof Staff
     */
    'workingHours'?: { [key: string]: TimeWindow; };
    /**
     * 
     * @type {Array<string>}
     * @memberof Staff
     */
    'holidayDates'?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<Break>; }}
     * @memberof Staff
     */
    'breaks'?: { [key: string]: Array<Break>; };
}
/**
 * 
 * @export
 * @interface StaffBookingRequest
 */
export interface StaffBookingRequest extends BookingRequest {
    /**
     * 
     * @type {Set<string>}
     * @memberof StaffBookingRequest
     */
    'staffIds': Set<string>;
    /**
     * 
     * @type {boolean}
     * @memberof StaffBookingRequest
     */
    'appliesToAllStaff'?: boolean;
    /**
     * 
     * @type {StaffBookingRequestAllOfTime}
     * @memberof StaffBookingRequest
     */
    'time': StaffBookingRequestAllOfTime;
}
/**
 * @type StaffBookingRequestAllOfTime
 * @export
 */
export type StaffBookingRequestAllOfTime = RecurringOccurrences | SingleOccurrence;

/**
 * 
 * @export
 * @interface StaffBookingResponse
 */
export interface StaffBookingResponse extends BookingResponse {
    /**
     * 
     * @type {Set<string>}
     * @memberof StaffBookingResponse
     */
    'staffIds': Set<string>;
    /**
     * 
     * @type {boolean}
     * @memberof StaffBookingResponse
     */
    'appliesToAllStaff': boolean;
    /**
     * 
     * @type {StaffBookingResponseAllOfTime}
     * @memberof StaffBookingResponse
     */
    'time': StaffBookingResponseAllOfTime;
}
/**
 * @type StaffBookingResponseAllOfTime
 * @export
 */
export type StaffBookingResponseAllOfTime = RecurringOccurrences | SingleOccurrence;

/**
 * 
 * @export
 * @interface StaffOccupancy
 */
export interface StaffOccupancy {
    /**
     * 
     * @type {string}
     * @memberof StaffOccupancy
     */
    'staffId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StaffOccupancy
     */
    'preparationStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof StaffOccupancy
     */
    'interventionStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof StaffOccupancy
     */
    'interventionEnd'?: string;
    /**
     * 
     * @type {string}
     * @memberof StaffOccupancy
     */
    'postProcessingEnd'?: string;
}
/**
 * 
 * @export
 * @interface StaffProfessionResponse
 */
export interface StaffProfessionResponse {
    /**
     * 
     * @type {string}
     * @memberof StaffProfessionResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof StaffProfessionResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof StaffProfessionResponse
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StaffProfessionResponse
     */
    'showInKpi': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StaffProfessionResponse
     */
    'archived': boolean;
}
/**
 * 
 * @export
 * @interface StaffResponse
 */
export interface StaffResponse {
    /**
     * 
     * @type {string}
     * @memberof StaffResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof StaffResponse
     */
    'fullName': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StaffResponse
     */
    'staffProfessionIds': Array<string>;
    /**
     * 
     * @type {WeeklyAvailability}
     * @memberof StaffResponse
     */
    'availability': WeeklyAvailability;
    /**
     * 
     * @type {string}
     * @memberof StaffResponse
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof StaffResponse
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface TimeWindow
 */
export interface TimeWindow {
    /**
     * 
     * @type {string}
     * @memberof TimeWindow
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimeWindow
     */
    'end'?: string;
}
/**
 * 
 * @export
 * @interface TrajectoryPoint
 */
export interface TrajectoryPoint {
    /**
     * 
     * @type {number}
     * @memberof TrajectoryPoint
     */
    'iteration'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrajectoryPoint
     */
    'computeTimeMs'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof TrajectoryPoint
     */
    'objectiveScore'?: Array<number>;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof TrajectoryPoint
     */
    'criterionTotals'?: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface TreatmentPlanDto
 */
export interface TreatmentPlanDto {
    /**
     * 
     * @type {string}
     * @memberof TreatmentPlanDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TreatmentPlanDto
     */
    'treatmentPlanTemplateId': string;
    /**
     * 
     * @type {string}
     * @memberof TreatmentPlanDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TreatmentPlanDto
     */
    'strokeColor': string;
    /**
     * 
     * @type {string}
     * @memberof TreatmentPlanDto
     */
    'fillColor': string;
    /**
     * 
     * @type {string}
     * @memberof TreatmentPlanDto
     */
    'highlightColor': string;
    /**
     * 
     * @type {InterventionIcon}
     * @memberof TreatmentPlanDto
     */
    'icon'?: InterventionIcon;
    /**
     * 
     * @type {Array<TreatmentWeekDto>}
     * @memberof TreatmentPlanDto
     */
    'weeks': Array<TreatmentWeekDto>;
}


/**
 * 
 * @export
 * @interface TreatmentPlanTemplateResponse
 */
export interface TreatmentPlanTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof TreatmentPlanTemplateResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TreatmentPlanTemplateResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TreatmentPlanTemplateResponse
     */
    'strokeColor': string;
    /**
     * 
     * @type {string}
     * @memberof TreatmentPlanTemplateResponse
     */
    'fillColor': string;
    /**
     * 
     * @type {string}
     * @memberof TreatmentPlanTemplateResponse
     */
    'highlightColor': string;
    /**
     * 
     * @type {InterventionIcon}
     * @memberof TreatmentPlanTemplateResponse
     */
    'icon'?: InterventionIcon;
    /**
     * 
     * @type {Array<string>}
     * @memberof TreatmentPlanTemplateResponse
     */
    'locationIds': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof TreatmentPlanTemplateResponse
     */
    'global': boolean;
    /**
     * 
     * @type {Array<TreatmentWeekTemplateResponse>}
     * @memberof TreatmentPlanTemplateResponse
     */
    'weeks': Array<TreatmentWeekTemplateResponse>;
}


/**
 * 
 * @export
 * @interface TreatmentWeekDto
 */
export interface TreatmentWeekDto {
    /**
     * 
     * @type {number}
     * @memberof TreatmentWeekDto
     */
    'weekNumber'?: number;
    /**
     * 
     * @type {Array<InterventionGroupDto>}
     * @memberof TreatmentWeekDto
     */
    'groups': Array<InterventionGroupDto>;
}
/**
 * 
 * @export
 * @interface TreatmentWeekTemplateRequest
 */
export interface TreatmentWeekTemplateRequest {
    /**
     * 
     * @type {number}
     * @memberof TreatmentWeekTemplateRequest
     */
    'weekNumber'?: number;
    /**
     * 
     * @type {Array<InterventionGroupTemplateRequest>}
     * @memberof TreatmentWeekTemplateRequest
     */
    'groups'?: Array<InterventionGroupTemplateRequest>;
}
/**
 * 
 * @export
 * @interface TreatmentWeekTemplateResponse
 */
export interface TreatmentWeekTemplateResponse {
    /**
     * 
     * @type {number}
     * @memberof TreatmentWeekTemplateResponse
     */
    'weekNumber': number;
    /**
     * 
     * @type {Array<InterventionGroupTemplateResponse>}
     * @memberof TreatmentWeekTemplateResponse
     */
    'groups': Array<InterventionGroupTemplateResponse>;
}
/**
 * 
 * @export
 * @interface UnscheduledDiagnostic
 */
export interface UnscheduledDiagnostic {
    /**
     * 
     * @type {string}
     * @memberof UnscheduledDiagnostic
     */
    'interventionId'?: string;
    /**
     * 
     * @type {number}
     * @memberof UnscheduledDiagnostic
     */
    'feasibleCandidateCount'?: number;
}
/**
 * @type UpdateBookingRequest
 * @export
 */
export type UpdateBookingRequest = ClosedDayBookingRequest | PatientBookingRequest | ReservedStaffTimeRequest | RoomBookingRequest | StaffBookingRequest;

/**
 * 
 * @export
 * @interface UpdateInterventionRoomPropertyRequest
 */
export interface UpdateInterventionRoomPropertyRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateInterventionRoomPropertyRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInterventionRoomPropertyRequest
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface UpdateInterventionRoomRequest
 */
export interface UpdateInterventionRoomRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateInterventionRoomRequest
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateInterventionRoomRequest
     */
    'capacityLimit'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateInterventionRoomRequest
     */
    'interventionRoomPropertyIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateInterventionTemplateRequest
 */
export interface UpdateInterventionTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateInterventionTemplateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInterventionTemplateRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInterventionTemplateRequest
     */
    'color'?: string;
    /**
     * 
     * @type {InterventionIcon}
     * @memberof UpdateInterventionTemplateRequest
     */
    'icon'?: InterventionIcon;
    /**
     * 
     * @type {number}
     * @memberof UpdateInterventionTemplateRequest
     */
    'durationMinutes'?: number;
    /**
     * 
     * @type {SessionType}
     * @memberof UpdateInterventionTemplateRequest
     */
    'sessionType': SessionType;
    /**
     * 
     * @type {Array<MandatoryStaffCompetenceRequirement>}
     * @memberof UpdateInterventionTemplateRequest
     */
    'mandatoryStaffCompetenceRequirements'?: Array<MandatoryStaffCompetenceRequirement>;
    /**
     * 
     * @type {Array<FlexStaffCompetenceRequirement>}
     * @memberof UpdateInterventionTemplateRequest
     */
    'flexStaffCompetenceRequirements'?: Array<FlexStaffCompetenceRequirement>;
    /**
     * 
     * @type {Array<AllowedDay>}
     * @memberof UpdateInterventionTemplateRequest
     */
    'allowedDays'?: Array<AllowedDay>;
    /**
     * 
     * @type {Array<InterventionRoomProperty>}
     * @memberof UpdateInterventionTemplateRequest
     */
    'roomRequirements'?: Array<InterventionRoomProperty>;
}


/**
 * 
 * @export
 * @interface UpdatePatientRoomPropertyRequest
 */
export interface UpdatePatientRoomPropertyRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePatientRoomPropertyRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePatientRoomPropertyRequest
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface UpdatePatientRoomRequest
 */
export interface UpdatePatientRoomRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePatientRoomRequest
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdatePatientRoomRequest
     */
    'patientRoomPropertyIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateStaffProfessionRequest
 */
export interface UpdateStaffProfessionRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateStaffProfessionRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStaffProfessionRequest
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateStaffProfessionRequest
     */
    'showInKpi'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateStaffRequest
 */
export interface UpdateStaffRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateStaffRequest
     */
    'fullName': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateStaffRequest
     */
    'staffProfessionIds': Array<string>;
    /**
     * 
     * @type {WeeklyAvailability}
     * @memberof UpdateStaffRequest
     */
    'availability': WeeklyAvailability;
    /**
     * 
     * @type {string}
     * @memberof UpdateStaffRequest
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStaffRequest
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface UpdateTreatmentPlanTemplateRequest
 */
export interface UpdateTreatmentPlanTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateTreatmentPlanTemplateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTreatmentPlanTemplateRequest
     */
    'strokeColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTreatmentPlanTemplateRequest
     */
    'fillColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTreatmentPlanTemplateRequest
     */
    'highlightColor'?: string;
    /**
     * 
     * @type {InterventionIcon}
     * @memberof UpdateTreatmentPlanTemplateRequest
     */
    'icon'?: InterventionIcon;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTreatmentPlanTemplateRequest
     */
    'locationIds'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTreatmentPlanTemplateRequest
     */
    'global'?: boolean;
    /**
     * 
     * @type {Array<TreatmentWeekTemplateRequest>}
     * @memberof UpdateTreatmentPlanTemplateRequest
     */
    'weeks'?: Array<TreatmentWeekTemplateRequest>;
}


/**
 * 
 * @export
 * @interface UpdateTreatmentPlansRequest
 */
export interface UpdateTreatmentPlansRequest {
    /**
     * 
     * @type {Array<TreatmentPlanDto>}
     * @memberof UpdateTreatmentPlansRequest
     */
    'treatmentPlans': Array<TreatmentPlanDto>;
}
/**
 * 
 * @export
 * @interface UpdateUserRequest
 */
export interface UpdateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    'lastName': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserRequest
     */
    'accountAdmin'?: boolean;
    /**
     * 
     * @type {Array<CreateLocationPermissionsRequest>}
     * @memberof UpdateUserRequest
     */
    'locationPermissions': Array<CreateLocationPermissionsRequest>;
}
/**
 * 
 * @export
 * @interface UserDetailResponse
 */
export interface UserDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof UserDetailResponse
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof UserDetailResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserDetailResponse
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof UserDetailResponse
     */
    'lastName': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserDetailResponse
     */
    'accountAdmin': boolean;
    /**
     * 
     * @type {Array<UserLocationPermissionsResponse>}
     * @memberof UserDetailResponse
     */
    'locationPermissions': Array<UserLocationPermissionsResponse>;
}
/**
 * 
 * @export
 * @interface UserLocationPermissionsResponse
 */
export interface UserLocationPermissionsResponse {
    /**
     * 
     * @type {string}
     * @memberof UserLocationPermissionsResponse
     */
    'locationId': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserLocationPermissionsResponse
     */
    'read': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserLocationPermissionsResponse
     */
    'write': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserLocationPermissionsResponse
     */
    'patientBooker': boolean;
}
/**
 * 
 * @export
 * @interface UserName
 */
export interface UserName {
    /**
     * 
     * @type {string}
     * @memberof UserName
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserName
     */
    'lastName'?: string;
}
/**
 * 
 * @export
 * @interface UserPermissionsResponse
 */
export interface UserPermissionsResponse {
    /**
     * 
     * @type {string}
     * @memberof UserPermissionsResponse
     */
    'userId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserPermissionsResponse
     */
    'locationsWrite': boolean;
    /**
     * 
     * @type {Array<LocationPermissionsResponse>}
     * @memberof UserPermissionsResponse
     */
    'locationPermissions': Array<LocationPermissionsResponse>;
}
/**
 * 
 * @export
 * @interface UserResponse
 */
export interface UserResponse {
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'lastName': string;
}
/**
 * 
 * @export
 * @interface WeekDateRangeResponse
 */
export interface WeekDateRangeResponse {
    /**
     * 
     * @type {number}
     * @memberof WeekDateRangeResponse
     */
    'weekNumber': number;
    /**
     * 
     * @type {string}
     * @memberof WeekDateRangeResponse
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof WeekDateRangeResponse
     */
    'endDate': string;
}
/**
 * 
 * @export
 * @interface WeeklyAvailability
 */
export interface WeeklyAvailability {
    /**
     * 
     * @type {{ [key: string]: WorkDay; }}
     * @memberof WeeklyAvailability
     */
    'weekSchedule'?: { [key: string]: WorkDay; };
}
/**
 * 
 * @export
 * @interface WorkDay
 */
export interface WorkDay {
    /**
     * 
     * @type {string}
     * @memberof WorkDay
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDay
     */
    'endTime'?: string;
}
/**
 * 
 * @export
 * @interface YearPlanResponse
 */
export interface YearPlanResponse {
    /**
     * 
     * @type {Array<TreatmentPlanDto>}
     * @memberof YearPlanResponse
     */
    'treatmentPlans': Array<TreatmentPlanDto>;
    /**
     * 
     * @type {Array<WeekDateRangeResponse>}
     * @memberof YearPlanResponse
     */
    'weeks': Array<WeekDateRangeResponse>;
    /**
     * 
     * @type {string}
     * @memberof YearPlanResponse
     */
    'lastModifiedDate': string;
}

/**
 * AccountControllerApi - axios parameter creator
 * @export
 */
export const AccountControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountControllerApi - functional programming interface
 * @export
 */
export const AccountControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.getAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccountControllerApi - factory interface
 * @export
 */
export const AccountControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount(options?: RawAxiosRequestConfig): AxiosPromise<AccountResponse> {
            return localVarFp.getAccount(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountControllerApi - interface
 * @export
 * @interface AccountControllerApi
 */
export interface AccountControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApiInterface
     */
    getAccount(options?: RawAxiosRequestConfig): AxiosPromise<AccountResponse>;

}

/**
 * AccountControllerApi - object-oriented interface
 * @export
 * @class AccountControllerApi
 * @extends {BaseAPI}
 */
export class AccountControllerApi extends BaseAPI implements AccountControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public getAccount(options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).getAccount(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BookingControllerApi - axios parameter creator
 * @export
 */
export const BookingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {UpdateBookingRequest} updateBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBooking: async (locationId: string, updateBookingRequest: UpdateBookingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('createBooking', 'locationId', locationId)
            // verify required parameter 'updateBookingRequest' is not null or undefined
            assertParamExists('createBooking', 'updateBookingRequest', updateBookingRequest)
            const localVarPath = `/api/location/{locationId}/booking`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBookingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBooking: async (locationId: string, bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deleteBooking', 'locationId', locationId)
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('deleteBooking', 'bookingId', bookingId)
            const localVarPath = `/api/location/{locationId}/booking/{bookingId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBooking: async (locationId: string, bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getBooking', 'locationId', locationId)
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('getBooking', 'bookingId', bookingId)
            const localVarPath = `/api/location/{locationId}/booking/{bookingId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBookings: async (locationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('listBookings', 'locationId', locationId)
            const localVarPath = `/api/location/{locationId}/booking`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} bookingId 
         * @param {UpdateBookingRequest} updateBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBooking: async (locationId: string, bookingId: string, updateBookingRequest: UpdateBookingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('updateBooking', 'locationId', locationId)
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('updateBooking', 'bookingId', bookingId)
            // verify required parameter 'updateBookingRequest' is not null or undefined
            assertParamExists('updateBooking', 'updateBookingRequest', updateBookingRequest)
            const localVarPath = `/api/location/{locationId}/booking/{bookingId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBookingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BookingControllerApi - functional programming interface
 * @export
 */
export const BookingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BookingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {UpdateBookingRequest} updateBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBooking(locationId: string, updateBookingRequest: UpdateBookingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBooking200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBooking(locationId, updateBookingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingControllerApi.createBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBooking(locationId: string, bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBooking(locationId, bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingControllerApi.deleteBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBooking(locationId: string, bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBooking200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBooking(locationId, bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingControllerApi.getBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBookings(locationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetBooking200Response>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBookings(locationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingControllerApi.listBookings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} bookingId 
         * @param {UpdateBookingRequest} updateBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBooking(locationId: string, bookingId: string, updateBookingRequest: UpdateBookingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBooking200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBooking(locationId, bookingId, updateBookingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingControllerApi.updateBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BookingControllerApi - factory interface
 * @export
 */
export const BookingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BookingControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {BookingControllerApiCreateBookingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBooking(requestParameters: BookingControllerApiCreateBookingRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBooking200Response> {
            return localVarFp.createBooking(requestParameters.locationId, requestParameters.updateBookingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingControllerApiDeleteBookingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBooking(requestParameters: BookingControllerApiDeleteBookingRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteBooking(requestParameters.locationId, requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingControllerApiGetBookingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBooking(requestParameters: BookingControllerApiGetBookingRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBooking200Response> {
            return localVarFp.getBooking(requestParameters.locationId, requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingControllerApiListBookingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBookings(requestParameters: BookingControllerApiListBookingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetBooking200Response>> {
            return localVarFp.listBookings(requestParameters.locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingControllerApiUpdateBookingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBooking(requestParameters: BookingControllerApiUpdateBookingRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBooking200Response> {
            return localVarFp.updateBooking(requestParameters.locationId, requestParameters.bookingId, requestParameters.updateBookingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BookingControllerApi - interface
 * @export
 * @interface BookingControllerApi
 */
export interface BookingControllerApiInterface {
    /**
     * 
     * @param {BookingControllerApiCreateBookingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingControllerApiInterface
     */
    createBooking(requestParameters: BookingControllerApiCreateBookingRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBooking200Response>;

    /**
     * 
     * @param {BookingControllerApiDeleteBookingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingControllerApiInterface
     */
    deleteBooking(requestParameters: BookingControllerApiDeleteBookingRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {BookingControllerApiGetBookingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingControllerApiInterface
     */
    getBooking(requestParameters: BookingControllerApiGetBookingRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBooking200Response>;

    /**
     * 
     * @param {BookingControllerApiListBookingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingControllerApiInterface
     */
    listBookings(requestParameters: BookingControllerApiListBookingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetBooking200Response>>;

    /**
     * 
     * @param {BookingControllerApiUpdateBookingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingControllerApiInterface
     */
    updateBooking(requestParameters: BookingControllerApiUpdateBookingRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBooking200Response>;

}

/**
 * Request parameters for createBooking operation in BookingControllerApi.
 * @export
 * @interface BookingControllerApiCreateBookingRequest
 */
export interface BookingControllerApiCreateBookingRequest {
    /**
     * 
     * @type {string}
     * @memberof BookingControllerApiCreateBooking
     */
    readonly locationId: string

    /**
     * 
     * @type {UpdateBookingRequest}
     * @memberof BookingControllerApiCreateBooking
     */
    readonly updateBookingRequest: UpdateBookingRequest
}

/**
 * Request parameters for deleteBooking operation in BookingControllerApi.
 * @export
 * @interface BookingControllerApiDeleteBookingRequest
 */
export interface BookingControllerApiDeleteBookingRequest {
    /**
     * 
     * @type {string}
     * @memberof BookingControllerApiDeleteBooking
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof BookingControllerApiDeleteBooking
     */
    readonly bookingId: string
}

/**
 * Request parameters for getBooking operation in BookingControllerApi.
 * @export
 * @interface BookingControllerApiGetBookingRequest
 */
export interface BookingControllerApiGetBookingRequest {
    /**
     * 
     * @type {string}
     * @memberof BookingControllerApiGetBooking
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof BookingControllerApiGetBooking
     */
    readonly bookingId: string
}

/**
 * Request parameters for listBookings operation in BookingControllerApi.
 * @export
 * @interface BookingControllerApiListBookingsRequest
 */
export interface BookingControllerApiListBookingsRequest {
    /**
     * 
     * @type {string}
     * @memberof BookingControllerApiListBookings
     */
    readonly locationId: string
}

/**
 * Request parameters for updateBooking operation in BookingControllerApi.
 * @export
 * @interface BookingControllerApiUpdateBookingRequest
 */
export interface BookingControllerApiUpdateBookingRequest {
    /**
     * 
     * @type {string}
     * @memberof BookingControllerApiUpdateBooking
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof BookingControllerApiUpdateBooking
     */
    readonly bookingId: string

    /**
     * 
     * @type {UpdateBookingRequest}
     * @memberof BookingControllerApiUpdateBooking
     */
    readonly updateBookingRequest: UpdateBookingRequest
}

/**
 * BookingControllerApi - object-oriented interface
 * @export
 * @class BookingControllerApi
 * @extends {BaseAPI}
 */
export class BookingControllerApi extends BaseAPI implements BookingControllerApiInterface {
    /**
     * 
     * @param {BookingControllerApiCreateBookingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingControllerApi
     */
    public createBooking(requestParameters: BookingControllerApiCreateBookingRequest, options?: RawAxiosRequestConfig) {
        return BookingControllerApiFp(this.configuration).createBooking(requestParameters.locationId, requestParameters.updateBookingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingControllerApiDeleteBookingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingControllerApi
     */
    public deleteBooking(requestParameters: BookingControllerApiDeleteBookingRequest, options?: RawAxiosRequestConfig) {
        return BookingControllerApiFp(this.configuration).deleteBooking(requestParameters.locationId, requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingControllerApiGetBookingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingControllerApi
     */
    public getBooking(requestParameters: BookingControllerApiGetBookingRequest, options?: RawAxiosRequestConfig) {
        return BookingControllerApiFp(this.configuration).getBooking(requestParameters.locationId, requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingControllerApiListBookingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingControllerApi
     */
    public listBookings(requestParameters: BookingControllerApiListBookingsRequest, options?: RawAxiosRequestConfig) {
        return BookingControllerApiFp(this.configuration).listBookings(requestParameters.locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingControllerApiUpdateBookingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingControllerApi
     */
    public updateBooking(requestParameters: BookingControllerApiUpdateBookingRequest, options?: RawAxiosRequestConfig) {
        return BookingControllerApiFp(this.configuration).updateBooking(requestParameters.locationId, requestParameters.bookingId, requestParameters.updateBookingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EconomicsControllerApi - axios parameter creator
 * @export
 */
export const EconomicsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {EconomicsBatchRequest} economicsBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchUpdateEconomics: async (locationId: string, scenarioId: string, economicsBatchRequest: EconomicsBatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('batchUpdateEconomics', 'locationId', locationId)
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('batchUpdateEconomics', 'scenarioId', scenarioId)
            // verify required parameter 'economicsBatchRequest' is not null or undefined
            assertParamExists('batchUpdateEconomics', 'economicsBatchRequest', economicsBatchRequest)
            const localVarPath = `/api/location/{locationId}/scenario/{scenarioId}/yearplan/economics/batch`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"scenarioId"}}`, encodeURIComponent(String(scenarioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(economicsBatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EconomicsControllerApi - functional programming interface
 * @export
 */
export const EconomicsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EconomicsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {EconomicsBatchRequest} economicsBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async batchUpdateEconomics(locationId: string, scenarioId: string, economicsBatchRequest: EconomicsBatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.batchUpdateEconomics(locationId, scenarioId, economicsBatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EconomicsControllerApi.batchUpdateEconomics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EconomicsControllerApi - factory interface
 * @export
 */
export const EconomicsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EconomicsControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {EconomicsControllerApiBatchUpdateEconomicsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchUpdateEconomics(requestParameters: EconomicsControllerApiBatchUpdateEconomicsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.batchUpdateEconomics(requestParameters.locationId, requestParameters.scenarioId, requestParameters.economicsBatchRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EconomicsControllerApi - interface
 * @export
 * @interface EconomicsControllerApi
 */
export interface EconomicsControllerApiInterface {
    /**
     * 
     * @param {EconomicsControllerApiBatchUpdateEconomicsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EconomicsControllerApiInterface
     */
    batchUpdateEconomics(requestParameters: EconomicsControllerApiBatchUpdateEconomicsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for batchUpdateEconomics operation in EconomicsControllerApi.
 * @export
 * @interface EconomicsControllerApiBatchUpdateEconomicsRequest
 */
export interface EconomicsControllerApiBatchUpdateEconomicsRequest {
    /**
     * 
     * @type {string}
     * @memberof EconomicsControllerApiBatchUpdateEconomics
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof EconomicsControllerApiBatchUpdateEconomics
     */
    readonly scenarioId: string

    /**
     * 
     * @type {EconomicsBatchRequest}
     * @memberof EconomicsControllerApiBatchUpdateEconomics
     */
    readonly economicsBatchRequest: EconomicsBatchRequest
}

/**
 * EconomicsControllerApi - object-oriented interface
 * @export
 * @class EconomicsControllerApi
 * @extends {BaseAPI}
 */
export class EconomicsControllerApi extends BaseAPI implements EconomicsControllerApiInterface {
    /**
     * 
     * @param {EconomicsControllerApiBatchUpdateEconomicsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EconomicsControllerApi
     */
    public batchUpdateEconomics(requestParameters: EconomicsControllerApiBatchUpdateEconomicsRequest, options?: RawAxiosRequestConfig) {
        return EconomicsControllerApiFp(this.configuration).batchUpdateEconomics(requestParameters.locationId, requestParameters.scenarioId, requestParameters.economicsBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InterventionRoomControllerApi - axios parameter creator
 * @export
 */
export const InterventionRoomControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {CreateInterventionRoomRequest} createInterventionRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInterventionRoom: async (locationId: string, createInterventionRoomRequest: CreateInterventionRoomRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('createInterventionRoom', 'locationId', locationId)
            // verify required parameter 'createInterventionRoomRequest' is not null or undefined
            assertParamExists('createInterventionRoom', 'createInterventionRoomRequest', createInterventionRoomRequest)
            const localVarPath = `/api/location/{locationId}/intervention-rooms`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInterventionRoomRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} interventionRoomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInterventionRoom: async (locationId: string, interventionRoomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deleteInterventionRoom', 'locationId', locationId)
            // verify required parameter 'interventionRoomId' is not null or undefined
            assertParamExists('deleteInterventionRoom', 'interventionRoomId', interventionRoomId)
            const localVarPath = `/api/location/{locationId}/intervention-rooms/{interventionRoomId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"interventionRoomId"}}`, encodeURIComponent(String(interventionRoomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInterventionRooms: async (locationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('listInterventionRooms', 'locationId', locationId)
            const localVarPath = `/api/location/{locationId}/intervention-rooms`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} interventionRoomId 
         * @param {UpdateInterventionRoomRequest} updateInterventionRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInterventionRoom: async (locationId: string, interventionRoomId: string, updateInterventionRoomRequest: UpdateInterventionRoomRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('updateInterventionRoom', 'locationId', locationId)
            // verify required parameter 'interventionRoomId' is not null or undefined
            assertParamExists('updateInterventionRoom', 'interventionRoomId', interventionRoomId)
            // verify required parameter 'updateInterventionRoomRequest' is not null or undefined
            assertParamExists('updateInterventionRoom', 'updateInterventionRoomRequest', updateInterventionRoomRequest)
            const localVarPath = `/api/location/{locationId}/intervention-rooms/{interventionRoomId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"interventionRoomId"}}`, encodeURIComponent(String(interventionRoomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInterventionRoomRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InterventionRoomControllerApi - functional programming interface
 * @export
 */
export const InterventionRoomControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InterventionRoomControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {CreateInterventionRoomRequest} createInterventionRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInterventionRoom(locationId: string, createInterventionRoomRequest: CreateInterventionRoomRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterventionRoomResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInterventionRoom(locationId, createInterventionRoomRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterventionRoomControllerApi.createInterventionRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} interventionRoomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInterventionRoom(locationId: string, interventionRoomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInterventionRoom(locationId, interventionRoomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterventionRoomControllerApi.deleteInterventionRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInterventionRooms(locationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InterventionRoomResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInterventionRooms(locationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterventionRoomControllerApi.listInterventionRooms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} interventionRoomId 
         * @param {UpdateInterventionRoomRequest} updateInterventionRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInterventionRoom(locationId: string, interventionRoomId: string, updateInterventionRoomRequest: UpdateInterventionRoomRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterventionRoomResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInterventionRoom(locationId, interventionRoomId, updateInterventionRoomRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterventionRoomControllerApi.updateInterventionRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InterventionRoomControllerApi - factory interface
 * @export
 */
export const InterventionRoomControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InterventionRoomControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {InterventionRoomControllerApiCreateInterventionRoomRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInterventionRoom(requestParameters: InterventionRoomControllerApiCreateInterventionRoomRequest, options?: RawAxiosRequestConfig): AxiosPromise<InterventionRoomResponse> {
            return localVarFp.createInterventionRoom(requestParameters.locationId, requestParameters.createInterventionRoomRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterventionRoomControllerApiDeleteInterventionRoomRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInterventionRoom(requestParameters: InterventionRoomControllerApiDeleteInterventionRoomRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteInterventionRoom(requestParameters.locationId, requestParameters.interventionRoomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterventionRoomControllerApiListInterventionRoomsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInterventionRooms(requestParameters: InterventionRoomControllerApiListInterventionRoomsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<InterventionRoomResponse>> {
            return localVarFp.listInterventionRooms(requestParameters.locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterventionRoomControllerApiUpdateInterventionRoomRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInterventionRoom(requestParameters: InterventionRoomControllerApiUpdateInterventionRoomRequest, options?: RawAxiosRequestConfig): AxiosPromise<InterventionRoomResponse> {
            return localVarFp.updateInterventionRoom(requestParameters.locationId, requestParameters.interventionRoomId, requestParameters.updateInterventionRoomRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InterventionRoomControllerApi - interface
 * @export
 * @interface InterventionRoomControllerApi
 */
export interface InterventionRoomControllerApiInterface {
    /**
     * 
     * @param {InterventionRoomControllerApiCreateInterventionRoomRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionRoomControllerApiInterface
     */
    createInterventionRoom(requestParameters: InterventionRoomControllerApiCreateInterventionRoomRequest, options?: RawAxiosRequestConfig): AxiosPromise<InterventionRoomResponse>;

    /**
     * 
     * @param {InterventionRoomControllerApiDeleteInterventionRoomRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionRoomControllerApiInterface
     */
    deleteInterventionRoom(requestParameters: InterventionRoomControllerApiDeleteInterventionRoomRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {InterventionRoomControllerApiListInterventionRoomsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionRoomControllerApiInterface
     */
    listInterventionRooms(requestParameters: InterventionRoomControllerApiListInterventionRoomsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<InterventionRoomResponse>>;

    /**
     * 
     * @param {InterventionRoomControllerApiUpdateInterventionRoomRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionRoomControllerApiInterface
     */
    updateInterventionRoom(requestParameters: InterventionRoomControllerApiUpdateInterventionRoomRequest, options?: RawAxiosRequestConfig): AxiosPromise<InterventionRoomResponse>;

}

/**
 * Request parameters for createInterventionRoom operation in InterventionRoomControllerApi.
 * @export
 * @interface InterventionRoomControllerApiCreateInterventionRoomRequest
 */
export interface InterventionRoomControllerApiCreateInterventionRoomRequest {
    /**
     * 
     * @type {string}
     * @memberof InterventionRoomControllerApiCreateInterventionRoom
     */
    readonly locationId: string

    /**
     * 
     * @type {CreateInterventionRoomRequest}
     * @memberof InterventionRoomControllerApiCreateInterventionRoom
     */
    readonly createInterventionRoomRequest: CreateInterventionRoomRequest
}

/**
 * Request parameters for deleteInterventionRoom operation in InterventionRoomControllerApi.
 * @export
 * @interface InterventionRoomControllerApiDeleteInterventionRoomRequest
 */
export interface InterventionRoomControllerApiDeleteInterventionRoomRequest {
    /**
     * 
     * @type {string}
     * @memberof InterventionRoomControllerApiDeleteInterventionRoom
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof InterventionRoomControllerApiDeleteInterventionRoom
     */
    readonly interventionRoomId: string
}

/**
 * Request parameters for listInterventionRooms operation in InterventionRoomControllerApi.
 * @export
 * @interface InterventionRoomControllerApiListInterventionRoomsRequest
 */
export interface InterventionRoomControllerApiListInterventionRoomsRequest {
    /**
     * 
     * @type {string}
     * @memberof InterventionRoomControllerApiListInterventionRooms
     */
    readonly locationId: string
}

/**
 * Request parameters for updateInterventionRoom operation in InterventionRoomControllerApi.
 * @export
 * @interface InterventionRoomControllerApiUpdateInterventionRoomRequest
 */
export interface InterventionRoomControllerApiUpdateInterventionRoomRequest {
    /**
     * 
     * @type {string}
     * @memberof InterventionRoomControllerApiUpdateInterventionRoom
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof InterventionRoomControllerApiUpdateInterventionRoom
     */
    readonly interventionRoomId: string

    /**
     * 
     * @type {UpdateInterventionRoomRequest}
     * @memberof InterventionRoomControllerApiUpdateInterventionRoom
     */
    readonly updateInterventionRoomRequest: UpdateInterventionRoomRequest
}

/**
 * InterventionRoomControllerApi - object-oriented interface
 * @export
 * @class InterventionRoomControllerApi
 * @extends {BaseAPI}
 */
export class InterventionRoomControllerApi extends BaseAPI implements InterventionRoomControllerApiInterface {
    /**
     * 
     * @param {InterventionRoomControllerApiCreateInterventionRoomRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionRoomControllerApi
     */
    public createInterventionRoom(requestParameters: InterventionRoomControllerApiCreateInterventionRoomRequest, options?: RawAxiosRequestConfig) {
        return InterventionRoomControllerApiFp(this.configuration).createInterventionRoom(requestParameters.locationId, requestParameters.createInterventionRoomRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterventionRoomControllerApiDeleteInterventionRoomRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionRoomControllerApi
     */
    public deleteInterventionRoom(requestParameters: InterventionRoomControllerApiDeleteInterventionRoomRequest, options?: RawAxiosRequestConfig) {
        return InterventionRoomControllerApiFp(this.configuration).deleteInterventionRoom(requestParameters.locationId, requestParameters.interventionRoomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterventionRoomControllerApiListInterventionRoomsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionRoomControllerApi
     */
    public listInterventionRooms(requestParameters: InterventionRoomControllerApiListInterventionRoomsRequest, options?: RawAxiosRequestConfig) {
        return InterventionRoomControllerApiFp(this.configuration).listInterventionRooms(requestParameters.locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterventionRoomControllerApiUpdateInterventionRoomRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionRoomControllerApi
     */
    public updateInterventionRoom(requestParameters: InterventionRoomControllerApiUpdateInterventionRoomRequest, options?: RawAxiosRequestConfig) {
        return InterventionRoomControllerApiFp(this.configuration).updateInterventionRoom(requestParameters.locationId, requestParameters.interventionRoomId, requestParameters.updateInterventionRoomRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InterventionRoomPropertyControllerApi - axios parameter creator
 * @export
 */
export const InterventionRoomPropertyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateInterventionRoomPropertyRequest} createInterventionRoomPropertyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInterventionRoomProperty: async (createInterventionRoomPropertyRequest: CreateInterventionRoomPropertyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createInterventionRoomPropertyRequest' is not null or undefined
            assertParamExists('createInterventionRoomProperty', 'createInterventionRoomPropertyRequest', createInterventionRoomPropertyRequest)
            const localVarPath = `/api/account/intervention-room-properties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInterventionRoomPropertyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInterventionRoomProperty: async (propertyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('deleteInterventionRoomProperty', 'propertyId', propertyId)
            const localVarPath = `/api/account/intervention-room-properties/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInterventionRoomProperties: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/intervention-room-properties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} propertyId 
         * @param {UpdateInterventionRoomPropertyRequest} updateInterventionRoomPropertyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInterventionRoomProperty: async (propertyId: string, updateInterventionRoomPropertyRequest: UpdateInterventionRoomPropertyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('updateInterventionRoomProperty', 'propertyId', propertyId)
            // verify required parameter 'updateInterventionRoomPropertyRequest' is not null or undefined
            assertParamExists('updateInterventionRoomProperty', 'updateInterventionRoomPropertyRequest', updateInterventionRoomPropertyRequest)
            const localVarPath = `/api/account/intervention-room-properties/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInterventionRoomPropertyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InterventionRoomPropertyControllerApi - functional programming interface
 * @export
 */
export const InterventionRoomPropertyControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InterventionRoomPropertyControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateInterventionRoomPropertyRequest} createInterventionRoomPropertyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInterventionRoomProperty(createInterventionRoomPropertyRequest: CreateInterventionRoomPropertyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterventionRoomPropertyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInterventionRoomProperty(createInterventionRoomPropertyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterventionRoomPropertyControllerApi.createInterventionRoomProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInterventionRoomProperty(propertyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInterventionRoomProperty(propertyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterventionRoomPropertyControllerApi.deleteInterventionRoomProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInterventionRoomProperties(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InterventionRoomPropertyResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInterventionRoomProperties(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterventionRoomPropertyControllerApi.listInterventionRoomProperties']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} propertyId 
         * @param {UpdateInterventionRoomPropertyRequest} updateInterventionRoomPropertyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInterventionRoomProperty(propertyId: string, updateInterventionRoomPropertyRequest: UpdateInterventionRoomPropertyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterventionRoomPropertyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInterventionRoomProperty(propertyId, updateInterventionRoomPropertyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterventionRoomPropertyControllerApi.updateInterventionRoomProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InterventionRoomPropertyControllerApi - factory interface
 * @export
 */
export const InterventionRoomPropertyControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InterventionRoomPropertyControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {InterventionRoomPropertyControllerApiCreateInterventionRoomPropertyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInterventionRoomProperty(requestParameters: InterventionRoomPropertyControllerApiCreateInterventionRoomPropertyRequest, options?: RawAxiosRequestConfig): AxiosPromise<InterventionRoomPropertyResponse> {
            return localVarFp.createInterventionRoomProperty(requestParameters.createInterventionRoomPropertyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterventionRoomPropertyControllerApiDeleteInterventionRoomPropertyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInterventionRoomProperty(requestParameters: InterventionRoomPropertyControllerApiDeleteInterventionRoomPropertyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteInterventionRoomProperty(requestParameters.propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInterventionRoomProperties(options?: RawAxiosRequestConfig): AxiosPromise<Array<InterventionRoomPropertyResponse>> {
            return localVarFp.listInterventionRoomProperties(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterventionRoomPropertyControllerApiUpdateInterventionRoomPropertyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInterventionRoomProperty(requestParameters: InterventionRoomPropertyControllerApiUpdateInterventionRoomPropertyRequest, options?: RawAxiosRequestConfig): AxiosPromise<InterventionRoomPropertyResponse> {
            return localVarFp.updateInterventionRoomProperty(requestParameters.propertyId, requestParameters.updateInterventionRoomPropertyRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InterventionRoomPropertyControllerApi - interface
 * @export
 * @interface InterventionRoomPropertyControllerApi
 */
export interface InterventionRoomPropertyControllerApiInterface {
    /**
     * 
     * @param {InterventionRoomPropertyControllerApiCreateInterventionRoomPropertyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionRoomPropertyControllerApiInterface
     */
    createInterventionRoomProperty(requestParameters: InterventionRoomPropertyControllerApiCreateInterventionRoomPropertyRequest, options?: RawAxiosRequestConfig): AxiosPromise<InterventionRoomPropertyResponse>;

    /**
     * 
     * @param {InterventionRoomPropertyControllerApiDeleteInterventionRoomPropertyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionRoomPropertyControllerApiInterface
     */
    deleteInterventionRoomProperty(requestParameters: InterventionRoomPropertyControllerApiDeleteInterventionRoomPropertyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionRoomPropertyControllerApiInterface
     */
    listInterventionRoomProperties(options?: RawAxiosRequestConfig): AxiosPromise<Array<InterventionRoomPropertyResponse>>;

    /**
     * 
     * @param {InterventionRoomPropertyControllerApiUpdateInterventionRoomPropertyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionRoomPropertyControllerApiInterface
     */
    updateInterventionRoomProperty(requestParameters: InterventionRoomPropertyControllerApiUpdateInterventionRoomPropertyRequest, options?: RawAxiosRequestConfig): AxiosPromise<InterventionRoomPropertyResponse>;

}

/**
 * Request parameters for createInterventionRoomProperty operation in InterventionRoomPropertyControllerApi.
 * @export
 * @interface InterventionRoomPropertyControllerApiCreateInterventionRoomPropertyRequest
 */
export interface InterventionRoomPropertyControllerApiCreateInterventionRoomPropertyRequest {
    /**
     * 
     * @type {CreateInterventionRoomPropertyRequest}
     * @memberof InterventionRoomPropertyControllerApiCreateInterventionRoomProperty
     */
    readonly createInterventionRoomPropertyRequest: CreateInterventionRoomPropertyRequest
}

/**
 * Request parameters for deleteInterventionRoomProperty operation in InterventionRoomPropertyControllerApi.
 * @export
 * @interface InterventionRoomPropertyControllerApiDeleteInterventionRoomPropertyRequest
 */
export interface InterventionRoomPropertyControllerApiDeleteInterventionRoomPropertyRequest {
    /**
     * 
     * @type {string}
     * @memberof InterventionRoomPropertyControllerApiDeleteInterventionRoomProperty
     */
    readonly propertyId: string
}

/**
 * Request parameters for updateInterventionRoomProperty operation in InterventionRoomPropertyControllerApi.
 * @export
 * @interface InterventionRoomPropertyControllerApiUpdateInterventionRoomPropertyRequest
 */
export interface InterventionRoomPropertyControllerApiUpdateInterventionRoomPropertyRequest {
    /**
     * 
     * @type {string}
     * @memberof InterventionRoomPropertyControllerApiUpdateInterventionRoomProperty
     */
    readonly propertyId: string

    /**
     * 
     * @type {UpdateInterventionRoomPropertyRequest}
     * @memberof InterventionRoomPropertyControllerApiUpdateInterventionRoomProperty
     */
    readonly updateInterventionRoomPropertyRequest: UpdateInterventionRoomPropertyRequest
}

/**
 * InterventionRoomPropertyControllerApi - object-oriented interface
 * @export
 * @class InterventionRoomPropertyControllerApi
 * @extends {BaseAPI}
 */
export class InterventionRoomPropertyControllerApi extends BaseAPI implements InterventionRoomPropertyControllerApiInterface {
    /**
     * 
     * @param {InterventionRoomPropertyControllerApiCreateInterventionRoomPropertyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionRoomPropertyControllerApi
     */
    public createInterventionRoomProperty(requestParameters: InterventionRoomPropertyControllerApiCreateInterventionRoomPropertyRequest, options?: RawAxiosRequestConfig) {
        return InterventionRoomPropertyControllerApiFp(this.configuration).createInterventionRoomProperty(requestParameters.createInterventionRoomPropertyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterventionRoomPropertyControllerApiDeleteInterventionRoomPropertyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionRoomPropertyControllerApi
     */
    public deleteInterventionRoomProperty(requestParameters: InterventionRoomPropertyControllerApiDeleteInterventionRoomPropertyRequest, options?: RawAxiosRequestConfig) {
        return InterventionRoomPropertyControllerApiFp(this.configuration).deleteInterventionRoomProperty(requestParameters.propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionRoomPropertyControllerApi
     */
    public listInterventionRoomProperties(options?: RawAxiosRequestConfig) {
        return InterventionRoomPropertyControllerApiFp(this.configuration).listInterventionRoomProperties(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterventionRoomPropertyControllerApiUpdateInterventionRoomPropertyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionRoomPropertyControllerApi
     */
    public updateInterventionRoomProperty(requestParameters: InterventionRoomPropertyControllerApiUpdateInterventionRoomPropertyRequest, options?: RawAxiosRequestConfig) {
        return InterventionRoomPropertyControllerApiFp(this.configuration).updateInterventionRoomProperty(requestParameters.propertyId, requestParameters.updateInterventionRoomPropertyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InterventionTemplateControllerApi - axios parameter creator
 * @export
 */
export const InterventionTemplateControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateInterventionTemplateRequest} createInterventionTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInterventionTemplate: async (createInterventionTemplateRequest: CreateInterventionTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createInterventionTemplateRequest' is not null or undefined
            assertParamExists('createInterventionTemplate', 'createInterventionTemplateRequest', createInterventionTemplateRequest)
            const localVarPath = `/api/account/intervention-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInterventionTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interventionTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInterventionTemplate: async (interventionTemplateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interventionTemplateId' is not null or undefined
            assertParamExists('deleteInterventionTemplate', 'interventionTemplateId', interventionTemplateId)
            const localVarPath = `/api/account/intervention-templates/{interventionTemplateId}`
                .replace(`{${"interventionTemplateId"}}`, encodeURIComponent(String(interventionTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInterventionTemplates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/intervention-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interventionTemplateId 
         * @param {UpdateInterventionTemplateRequest} updateInterventionTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInterventionTemplate: async (interventionTemplateId: string, updateInterventionTemplateRequest: UpdateInterventionTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interventionTemplateId' is not null or undefined
            assertParamExists('updateInterventionTemplate', 'interventionTemplateId', interventionTemplateId)
            // verify required parameter 'updateInterventionTemplateRequest' is not null or undefined
            assertParamExists('updateInterventionTemplate', 'updateInterventionTemplateRequest', updateInterventionTemplateRequest)
            const localVarPath = `/api/account/intervention-templates/{interventionTemplateId}`
                .replace(`{${"interventionTemplateId"}}`, encodeURIComponent(String(interventionTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInterventionTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InterventionTemplateControllerApi - functional programming interface
 * @export
 */
export const InterventionTemplateControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InterventionTemplateControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateInterventionTemplateRequest} createInterventionTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInterventionTemplate(createInterventionTemplateRequest: CreateInterventionTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterventionTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInterventionTemplate(createInterventionTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterventionTemplateControllerApi.createInterventionTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interventionTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInterventionTemplate(interventionTemplateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInterventionTemplate(interventionTemplateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterventionTemplateControllerApi.deleteInterventionTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInterventionTemplates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InterventionTemplateResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInterventionTemplates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterventionTemplateControllerApi.listInterventionTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interventionTemplateId 
         * @param {UpdateInterventionTemplateRequest} updateInterventionTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInterventionTemplate(interventionTemplateId: string, updateInterventionTemplateRequest: UpdateInterventionTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterventionTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInterventionTemplate(interventionTemplateId, updateInterventionTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterventionTemplateControllerApi.updateInterventionTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InterventionTemplateControllerApi - factory interface
 * @export
 */
export const InterventionTemplateControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InterventionTemplateControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {InterventionTemplateControllerApiCreateInterventionTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInterventionTemplate(requestParameters: InterventionTemplateControllerApiCreateInterventionTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<InterventionTemplateResponse> {
            return localVarFp.createInterventionTemplate(requestParameters.createInterventionTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterventionTemplateControllerApiDeleteInterventionTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInterventionTemplate(requestParameters: InterventionTemplateControllerApiDeleteInterventionTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteInterventionTemplate(requestParameters.interventionTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInterventionTemplates(options?: RawAxiosRequestConfig): AxiosPromise<Array<InterventionTemplateResponse>> {
            return localVarFp.listInterventionTemplates(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterventionTemplateControllerApiUpdateInterventionTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInterventionTemplate(requestParameters: InterventionTemplateControllerApiUpdateInterventionTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<InterventionTemplateResponse> {
            return localVarFp.updateInterventionTemplate(requestParameters.interventionTemplateId, requestParameters.updateInterventionTemplateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InterventionTemplateControllerApi - interface
 * @export
 * @interface InterventionTemplateControllerApi
 */
export interface InterventionTemplateControllerApiInterface {
    /**
     * 
     * @param {InterventionTemplateControllerApiCreateInterventionTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionTemplateControllerApiInterface
     */
    createInterventionTemplate(requestParameters: InterventionTemplateControllerApiCreateInterventionTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<InterventionTemplateResponse>;

    /**
     * 
     * @param {InterventionTemplateControllerApiDeleteInterventionTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionTemplateControllerApiInterface
     */
    deleteInterventionTemplate(requestParameters: InterventionTemplateControllerApiDeleteInterventionTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionTemplateControllerApiInterface
     */
    listInterventionTemplates(options?: RawAxiosRequestConfig): AxiosPromise<Array<InterventionTemplateResponse>>;

    /**
     * 
     * @param {InterventionTemplateControllerApiUpdateInterventionTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionTemplateControllerApiInterface
     */
    updateInterventionTemplate(requestParameters: InterventionTemplateControllerApiUpdateInterventionTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<InterventionTemplateResponse>;

}

/**
 * Request parameters for createInterventionTemplate operation in InterventionTemplateControllerApi.
 * @export
 * @interface InterventionTemplateControllerApiCreateInterventionTemplateRequest
 */
export interface InterventionTemplateControllerApiCreateInterventionTemplateRequest {
    /**
     * 
     * @type {CreateInterventionTemplateRequest}
     * @memberof InterventionTemplateControllerApiCreateInterventionTemplate
     */
    readonly createInterventionTemplateRequest: CreateInterventionTemplateRequest
}

/**
 * Request parameters for deleteInterventionTemplate operation in InterventionTemplateControllerApi.
 * @export
 * @interface InterventionTemplateControllerApiDeleteInterventionTemplateRequest
 */
export interface InterventionTemplateControllerApiDeleteInterventionTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof InterventionTemplateControllerApiDeleteInterventionTemplate
     */
    readonly interventionTemplateId: string
}

/**
 * Request parameters for updateInterventionTemplate operation in InterventionTemplateControllerApi.
 * @export
 * @interface InterventionTemplateControllerApiUpdateInterventionTemplateRequest
 */
export interface InterventionTemplateControllerApiUpdateInterventionTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof InterventionTemplateControllerApiUpdateInterventionTemplate
     */
    readonly interventionTemplateId: string

    /**
     * 
     * @type {UpdateInterventionTemplateRequest}
     * @memberof InterventionTemplateControllerApiUpdateInterventionTemplate
     */
    readonly updateInterventionTemplateRequest: UpdateInterventionTemplateRequest
}

/**
 * InterventionTemplateControllerApi - object-oriented interface
 * @export
 * @class InterventionTemplateControllerApi
 * @extends {BaseAPI}
 */
export class InterventionTemplateControllerApi extends BaseAPI implements InterventionTemplateControllerApiInterface {
    /**
     * 
     * @param {InterventionTemplateControllerApiCreateInterventionTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionTemplateControllerApi
     */
    public createInterventionTemplate(requestParameters: InterventionTemplateControllerApiCreateInterventionTemplateRequest, options?: RawAxiosRequestConfig) {
        return InterventionTemplateControllerApiFp(this.configuration).createInterventionTemplate(requestParameters.createInterventionTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterventionTemplateControllerApiDeleteInterventionTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionTemplateControllerApi
     */
    public deleteInterventionTemplate(requestParameters: InterventionTemplateControllerApiDeleteInterventionTemplateRequest, options?: RawAxiosRequestConfig) {
        return InterventionTemplateControllerApiFp(this.configuration).deleteInterventionTemplate(requestParameters.interventionTemplateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionTemplateControllerApi
     */
    public listInterventionTemplates(options?: RawAxiosRequestConfig) {
        return InterventionTemplateControllerApiFp(this.configuration).listInterventionTemplates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterventionTemplateControllerApiUpdateInterventionTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterventionTemplateControllerApi
     */
    public updateInterventionTemplate(requestParameters: InterventionTemplateControllerApiUpdateInterventionTemplateRequest, options?: RawAxiosRequestConfig) {
        return InterventionTemplateControllerApiFp(this.configuration).updateInterventionTemplate(requestParameters.interventionTemplateId, requestParameters.updateInterventionTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LocationControllerApi - axios parameter creator
 * @export
 */
export const LocationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/location/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationControllerApi - functional programming interface
 * @export
 */
export const LocationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLocations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLocations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationControllerApi.createLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationControllerApi.getLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocationControllerApi - factory interface
 * @export
 */
export const LocationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocations(options?: RawAxiosRequestConfig): AxiosPromise<LocationResponse> {
            return localVarFp.createLocations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations(options?: RawAxiosRequestConfig): AxiosPromise<Array<LocationResponse>> {
            return localVarFp.getLocations(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationControllerApi - interface
 * @export
 * @interface LocationControllerApi
 */
export interface LocationControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationControllerApiInterface
     */
    createLocations(options?: RawAxiosRequestConfig): AxiosPromise<LocationResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationControllerApiInterface
     */
    getLocations(options?: RawAxiosRequestConfig): AxiosPromise<Array<LocationResponse>>;

}

/**
 * LocationControllerApi - object-oriented interface
 * @export
 * @class LocationControllerApi
 * @extends {BaseAPI}
 */
export class LocationControllerApi extends BaseAPI implements LocationControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationControllerApi
     */
    public createLocations(options?: RawAxiosRequestConfig) {
        return LocationControllerApiFp(this.configuration).createLocations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationControllerApi
     */
    public getLocations(options?: RawAxiosRequestConfig) {
        return LocationControllerApiFp(this.configuration).getLocations(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientAssignmentControllerApi - axios parameter creator
 * @export
 */
export const PatientAssignmentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {string} treatmentPlanId 
         * @param {string} interventionGroupId 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignPatientToGroup: async (locationId: string, scenarioId: string, treatmentPlanId: string, interventionGroupId: string, patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('assignPatientToGroup', 'locationId', locationId)
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('assignPatientToGroup', 'scenarioId', scenarioId)
            // verify required parameter 'treatmentPlanId' is not null or undefined
            assertParamExists('assignPatientToGroup', 'treatmentPlanId', treatmentPlanId)
            // verify required parameter 'interventionGroupId' is not null or undefined
            assertParamExists('assignPatientToGroup', 'interventionGroupId', interventionGroupId)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('assignPatientToGroup', 'patientId', patientId)
            const localVarPath = `/api/location/{locationId}/scenario/{scenarioId}/yearplan/treatment-plans/{treatmentPlanId}/intervention-groups/{interventionGroupId}/patients/{patientId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"scenarioId"}}`, encodeURIComponent(String(scenarioId)))
                .replace(`{${"treatmentPlanId"}}`, encodeURIComponent(String(treatmentPlanId)))
                .replace(`{${"interventionGroupId"}}`, encodeURIComponent(String(interventionGroupId)))
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {string} treatmentPlanId 
         * @param {string} patientId 
         * @param {InterventionGroupIdsRequest} interventionGroupIdsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignPatientToGroups: async (locationId: string, scenarioId: string, treatmentPlanId: string, patientId: string, interventionGroupIdsRequest: InterventionGroupIdsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('assignPatientToGroups', 'locationId', locationId)
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('assignPatientToGroups', 'scenarioId', scenarioId)
            // verify required parameter 'treatmentPlanId' is not null or undefined
            assertParamExists('assignPatientToGroups', 'treatmentPlanId', treatmentPlanId)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('assignPatientToGroups', 'patientId', patientId)
            // verify required parameter 'interventionGroupIdsRequest' is not null or undefined
            assertParamExists('assignPatientToGroups', 'interventionGroupIdsRequest', interventionGroupIdsRequest)
            const localVarPath = `/api/location/{locationId}/scenario/{scenarioId}/yearplan/treatment-plans/{treatmentPlanId}/patients/{patientId}/intervention-groups`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"scenarioId"}}`, encodeURIComponent(String(scenarioId)))
                .replace(`{${"treatmentPlanId"}}`, encodeURIComponent(String(treatmentPlanId)))
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(interventionGroupIdsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {string} treatmentPlanId 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignPatientToPlan: async (locationId: string, scenarioId: string, treatmentPlanId: string, patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('assignPatientToPlan', 'locationId', locationId)
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('assignPatientToPlan', 'scenarioId', scenarioId)
            // verify required parameter 'treatmentPlanId' is not null or undefined
            assertParamExists('assignPatientToPlan', 'treatmentPlanId', treatmentPlanId)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('assignPatientToPlan', 'patientId', patientId)
            const localVarPath = `/api/location/{locationId}/scenario/{scenarioId}/yearplan/treatment-plans/{treatmentPlanId}/patients/{patientId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"scenarioId"}}`, encodeURIComponent(String(scenarioId)))
                .replace(`{${"treatmentPlanId"}}`, encodeURIComponent(String(treatmentPlanId)))
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {string} treatmentPlanId 
         * @param {string} interventionGroupId 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePatientFromGroup: async (locationId: string, scenarioId: string, treatmentPlanId: string, interventionGroupId: string, patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('removePatientFromGroup', 'locationId', locationId)
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('removePatientFromGroup', 'scenarioId', scenarioId)
            // verify required parameter 'treatmentPlanId' is not null or undefined
            assertParamExists('removePatientFromGroup', 'treatmentPlanId', treatmentPlanId)
            // verify required parameter 'interventionGroupId' is not null or undefined
            assertParamExists('removePatientFromGroup', 'interventionGroupId', interventionGroupId)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('removePatientFromGroup', 'patientId', patientId)
            const localVarPath = `/api/location/{locationId}/scenario/{scenarioId}/yearplan/treatment-plans/{treatmentPlanId}/intervention-groups/{interventionGroupId}/patients/{patientId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"scenarioId"}}`, encodeURIComponent(String(scenarioId)))
                .replace(`{${"treatmentPlanId"}}`, encodeURIComponent(String(treatmentPlanId)))
                .replace(`{${"interventionGroupId"}}`, encodeURIComponent(String(interventionGroupId)))
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {string} treatmentPlanId 
         * @param {string} patientId 
         * @param {InterventionGroupIdsRequest} interventionGroupIdsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePatientFromGroups: async (locationId: string, scenarioId: string, treatmentPlanId: string, patientId: string, interventionGroupIdsRequest: InterventionGroupIdsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('removePatientFromGroups', 'locationId', locationId)
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('removePatientFromGroups', 'scenarioId', scenarioId)
            // verify required parameter 'treatmentPlanId' is not null or undefined
            assertParamExists('removePatientFromGroups', 'treatmentPlanId', treatmentPlanId)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('removePatientFromGroups', 'patientId', patientId)
            // verify required parameter 'interventionGroupIdsRequest' is not null or undefined
            assertParamExists('removePatientFromGroups', 'interventionGroupIdsRequest', interventionGroupIdsRequest)
            const localVarPath = `/api/location/{locationId}/scenario/{scenarioId}/yearplan/treatment-plans/{treatmentPlanId}/patients/{patientId}/intervention-groups/remove`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"scenarioId"}}`, encodeURIComponent(String(scenarioId)))
                .replace(`{${"treatmentPlanId"}}`, encodeURIComponent(String(treatmentPlanId)))
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(interventionGroupIdsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {string} treatmentPlanId 
         * @param {PatientIdsRequest} patientIdsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePatientsFromPlan: async (locationId: string, scenarioId: string, treatmentPlanId: string, patientIdsRequest: PatientIdsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('removePatientsFromPlan', 'locationId', locationId)
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('removePatientsFromPlan', 'scenarioId', scenarioId)
            // verify required parameter 'treatmentPlanId' is not null or undefined
            assertParamExists('removePatientsFromPlan', 'treatmentPlanId', treatmentPlanId)
            // verify required parameter 'patientIdsRequest' is not null or undefined
            assertParamExists('removePatientsFromPlan', 'patientIdsRequest', patientIdsRequest)
            const localVarPath = `/api/location/{locationId}/scenario/{scenarioId}/yearplan/treatment-plans/{treatmentPlanId}/patients/remove`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"scenarioId"}}`, encodeURIComponent(String(scenarioId)))
                .replace(`{${"treatmentPlanId"}}`, encodeURIComponent(String(treatmentPlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientIdsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientAssignmentControllerApi - functional programming interface
 * @export
 */
export const PatientAssignmentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientAssignmentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {string} treatmentPlanId 
         * @param {string} interventionGroupId 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignPatientToGroup(locationId: string, scenarioId: string, treatmentPlanId: string, interventionGroupId: string, patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignPatientToGroup(locationId, scenarioId, treatmentPlanId, interventionGroupId, patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAssignmentControllerApi.assignPatientToGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {string} treatmentPlanId 
         * @param {string} patientId 
         * @param {InterventionGroupIdsRequest} interventionGroupIdsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignPatientToGroups(locationId: string, scenarioId: string, treatmentPlanId: string, patientId: string, interventionGroupIdsRequest: InterventionGroupIdsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignPatientToGroups(locationId, scenarioId, treatmentPlanId, patientId, interventionGroupIdsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAssignmentControllerApi.assignPatientToGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {string} treatmentPlanId 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignPatientToPlan(locationId: string, scenarioId: string, treatmentPlanId: string, patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignPatientToPlan(locationId, scenarioId, treatmentPlanId, patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAssignmentControllerApi.assignPatientToPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {string} treatmentPlanId 
         * @param {string} interventionGroupId 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removePatientFromGroup(locationId: string, scenarioId: string, treatmentPlanId: string, interventionGroupId: string, patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removePatientFromGroup(locationId, scenarioId, treatmentPlanId, interventionGroupId, patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAssignmentControllerApi.removePatientFromGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {string} treatmentPlanId 
         * @param {string} patientId 
         * @param {InterventionGroupIdsRequest} interventionGroupIdsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removePatientFromGroups(locationId: string, scenarioId: string, treatmentPlanId: string, patientId: string, interventionGroupIdsRequest: InterventionGroupIdsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removePatientFromGroups(locationId, scenarioId, treatmentPlanId, patientId, interventionGroupIdsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAssignmentControllerApi.removePatientFromGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {string} treatmentPlanId 
         * @param {PatientIdsRequest} patientIdsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removePatientsFromPlan(locationId: string, scenarioId: string, treatmentPlanId: string, patientIdsRequest: PatientIdsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removePatientsFromPlan(locationId, scenarioId, treatmentPlanId, patientIdsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAssignmentControllerApi.removePatientsFromPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientAssignmentControllerApi - factory interface
 * @export
 */
export const PatientAssignmentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientAssignmentControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {PatientAssignmentControllerApiAssignPatientToGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignPatientToGroup(requestParameters: PatientAssignmentControllerApiAssignPatientToGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignPatientToGroup(requestParameters.locationId, requestParameters.scenarioId, requestParameters.treatmentPlanId, requestParameters.interventionGroupId, requestParameters.patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PatientAssignmentControllerApiAssignPatientToGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignPatientToGroups(requestParameters: PatientAssignmentControllerApiAssignPatientToGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignPatientToGroups(requestParameters.locationId, requestParameters.scenarioId, requestParameters.treatmentPlanId, requestParameters.patientId, requestParameters.interventionGroupIdsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PatientAssignmentControllerApiAssignPatientToPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignPatientToPlan(requestParameters: PatientAssignmentControllerApiAssignPatientToPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignPatientToPlan(requestParameters.locationId, requestParameters.scenarioId, requestParameters.treatmentPlanId, requestParameters.patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PatientAssignmentControllerApiRemovePatientFromGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePatientFromGroup(requestParameters: PatientAssignmentControllerApiRemovePatientFromGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removePatientFromGroup(requestParameters.locationId, requestParameters.scenarioId, requestParameters.treatmentPlanId, requestParameters.interventionGroupId, requestParameters.patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PatientAssignmentControllerApiRemovePatientFromGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePatientFromGroups(requestParameters: PatientAssignmentControllerApiRemovePatientFromGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removePatientFromGroups(requestParameters.locationId, requestParameters.scenarioId, requestParameters.treatmentPlanId, requestParameters.patientId, requestParameters.interventionGroupIdsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PatientAssignmentControllerApiRemovePatientsFromPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePatientsFromPlan(requestParameters: PatientAssignmentControllerApiRemovePatientsFromPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removePatientsFromPlan(requestParameters.locationId, requestParameters.scenarioId, requestParameters.treatmentPlanId, requestParameters.patientIdsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientAssignmentControllerApi - interface
 * @export
 * @interface PatientAssignmentControllerApi
 */
export interface PatientAssignmentControllerApiInterface {
    /**
     * 
     * @param {PatientAssignmentControllerApiAssignPatientToGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAssignmentControllerApiInterface
     */
    assignPatientToGroup(requestParameters: PatientAssignmentControllerApiAssignPatientToGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {PatientAssignmentControllerApiAssignPatientToGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAssignmentControllerApiInterface
     */
    assignPatientToGroups(requestParameters: PatientAssignmentControllerApiAssignPatientToGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {PatientAssignmentControllerApiAssignPatientToPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAssignmentControllerApiInterface
     */
    assignPatientToPlan(requestParameters: PatientAssignmentControllerApiAssignPatientToPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {PatientAssignmentControllerApiRemovePatientFromGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAssignmentControllerApiInterface
     */
    removePatientFromGroup(requestParameters: PatientAssignmentControllerApiRemovePatientFromGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {PatientAssignmentControllerApiRemovePatientFromGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAssignmentControllerApiInterface
     */
    removePatientFromGroups(requestParameters: PatientAssignmentControllerApiRemovePatientFromGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {PatientAssignmentControllerApiRemovePatientsFromPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAssignmentControllerApiInterface
     */
    removePatientsFromPlan(requestParameters: PatientAssignmentControllerApiRemovePatientsFromPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for assignPatientToGroup operation in PatientAssignmentControllerApi.
 * @export
 * @interface PatientAssignmentControllerApiAssignPatientToGroupRequest
 */
export interface PatientAssignmentControllerApiAssignPatientToGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiAssignPatientToGroup
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiAssignPatientToGroup
     */
    readonly scenarioId: string

    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiAssignPatientToGroup
     */
    readonly treatmentPlanId: string

    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiAssignPatientToGroup
     */
    readonly interventionGroupId: string

    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiAssignPatientToGroup
     */
    readonly patientId: string
}

/**
 * Request parameters for assignPatientToGroups operation in PatientAssignmentControllerApi.
 * @export
 * @interface PatientAssignmentControllerApiAssignPatientToGroupsRequest
 */
export interface PatientAssignmentControllerApiAssignPatientToGroupsRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiAssignPatientToGroups
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiAssignPatientToGroups
     */
    readonly scenarioId: string

    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiAssignPatientToGroups
     */
    readonly treatmentPlanId: string

    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiAssignPatientToGroups
     */
    readonly patientId: string

    /**
     * 
     * @type {InterventionGroupIdsRequest}
     * @memberof PatientAssignmentControllerApiAssignPatientToGroups
     */
    readonly interventionGroupIdsRequest: InterventionGroupIdsRequest
}

/**
 * Request parameters for assignPatientToPlan operation in PatientAssignmentControllerApi.
 * @export
 * @interface PatientAssignmentControllerApiAssignPatientToPlanRequest
 */
export interface PatientAssignmentControllerApiAssignPatientToPlanRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiAssignPatientToPlan
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiAssignPatientToPlan
     */
    readonly scenarioId: string

    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiAssignPatientToPlan
     */
    readonly treatmentPlanId: string

    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiAssignPatientToPlan
     */
    readonly patientId: string
}

/**
 * Request parameters for removePatientFromGroup operation in PatientAssignmentControllerApi.
 * @export
 * @interface PatientAssignmentControllerApiRemovePatientFromGroupRequest
 */
export interface PatientAssignmentControllerApiRemovePatientFromGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiRemovePatientFromGroup
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiRemovePatientFromGroup
     */
    readonly scenarioId: string

    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiRemovePatientFromGroup
     */
    readonly treatmentPlanId: string

    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiRemovePatientFromGroup
     */
    readonly interventionGroupId: string

    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiRemovePatientFromGroup
     */
    readonly patientId: string
}

/**
 * Request parameters for removePatientFromGroups operation in PatientAssignmentControllerApi.
 * @export
 * @interface PatientAssignmentControllerApiRemovePatientFromGroupsRequest
 */
export interface PatientAssignmentControllerApiRemovePatientFromGroupsRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiRemovePatientFromGroups
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiRemovePatientFromGroups
     */
    readonly scenarioId: string

    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiRemovePatientFromGroups
     */
    readonly treatmentPlanId: string

    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiRemovePatientFromGroups
     */
    readonly patientId: string

    /**
     * 
     * @type {InterventionGroupIdsRequest}
     * @memberof PatientAssignmentControllerApiRemovePatientFromGroups
     */
    readonly interventionGroupIdsRequest: InterventionGroupIdsRequest
}

/**
 * Request parameters for removePatientsFromPlan operation in PatientAssignmentControllerApi.
 * @export
 * @interface PatientAssignmentControllerApiRemovePatientsFromPlanRequest
 */
export interface PatientAssignmentControllerApiRemovePatientsFromPlanRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiRemovePatientsFromPlan
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiRemovePatientsFromPlan
     */
    readonly scenarioId: string

    /**
     * 
     * @type {string}
     * @memberof PatientAssignmentControllerApiRemovePatientsFromPlan
     */
    readonly treatmentPlanId: string

    /**
     * 
     * @type {PatientIdsRequest}
     * @memberof PatientAssignmentControllerApiRemovePatientsFromPlan
     */
    readonly patientIdsRequest: PatientIdsRequest
}

/**
 * PatientAssignmentControllerApi - object-oriented interface
 * @export
 * @class PatientAssignmentControllerApi
 * @extends {BaseAPI}
 */
export class PatientAssignmentControllerApi extends BaseAPI implements PatientAssignmentControllerApiInterface {
    /**
     * 
     * @param {PatientAssignmentControllerApiAssignPatientToGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAssignmentControllerApi
     */
    public assignPatientToGroup(requestParameters: PatientAssignmentControllerApiAssignPatientToGroupRequest, options?: RawAxiosRequestConfig) {
        return PatientAssignmentControllerApiFp(this.configuration).assignPatientToGroup(requestParameters.locationId, requestParameters.scenarioId, requestParameters.treatmentPlanId, requestParameters.interventionGroupId, requestParameters.patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PatientAssignmentControllerApiAssignPatientToGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAssignmentControllerApi
     */
    public assignPatientToGroups(requestParameters: PatientAssignmentControllerApiAssignPatientToGroupsRequest, options?: RawAxiosRequestConfig) {
        return PatientAssignmentControllerApiFp(this.configuration).assignPatientToGroups(requestParameters.locationId, requestParameters.scenarioId, requestParameters.treatmentPlanId, requestParameters.patientId, requestParameters.interventionGroupIdsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PatientAssignmentControllerApiAssignPatientToPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAssignmentControllerApi
     */
    public assignPatientToPlan(requestParameters: PatientAssignmentControllerApiAssignPatientToPlanRequest, options?: RawAxiosRequestConfig) {
        return PatientAssignmentControllerApiFp(this.configuration).assignPatientToPlan(requestParameters.locationId, requestParameters.scenarioId, requestParameters.treatmentPlanId, requestParameters.patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PatientAssignmentControllerApiRemovePatientFromGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAssignmentControllerApi
     */
    public removePatientFromGroup(requestParameters: PatientAssignmentControllerApiRemovePatientFromGroupRequest, options?: RawAxiosRequestConfig) {
        return PatientAssignmentControllerApiFp(this.configuration).removePatientFromGroup(requestParameters.locationId, requestParameters.scenarioId, requestParameters.treatmentPlanId, requestParameters.interventionGroupId, requestParameters.patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PatientAssignmentControllerApiRemovePatientFromGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAssignmentControllerApi
     */
    public removePatientFromGroups(requestParameters: PatientAssignmentControllerApiRemovePatientFromGroupsRequest, options?: RawAxiosRequestConfig) {
        return PatientAssignmentControllerApiFp(this.configuration).removePatientFromGroups(requestParameters.locationId, requestParameters.scenarioId, requestParameters.treatmentPlanId, requestParameters.patientId, requestParameters.interventionGroupIdsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PatientAssignmentControllerApiRemovePatientsFromPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAssignmentControllerApi
     */
    public removePatientsFromPlan(requestParameters: PatientAssignmentControllerApiRemovePatientsFromPlanRequest, options?: RawAxiosRequestConfig) {
        return PatientAssignmentControllerApiFp(this.configuration).removePatientsFromPlan(requestParameters.locationId, requestParameters.scenarioId, requestParameters.treatmentPlanId, requestParameters.patientIdsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientControllerApi - axios parameter creator
 * @export
 */
export const PatientControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {PatientRequest} patientRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatient: async (locationId: string, patientRequest: PatientRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('createPatient', 'locationId', locationId)
            // verify required parameter 'patientRequest' is not null or undefined
            assertParamExists('createPatient', 'patientRequest', patientRequest)
            const localVarPath = `/api/location/{locationId}/patients`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatient: async (locationId: string, patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deletePatient', 'locationId', locationId)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('deletePatient', 'patientId', patientId)
            const localVarPath = `/api/location/{locationId}/patients/{patientId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePreview: async (locationId: string, patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deletePreview', 'locationId', locationId)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('deletePreview', 'patientId', patientId)
            const localVarPath = `/api/location/{locationId}/patients/{patientId}/delete-preview`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditLog: async (locationId: string, patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getAuditLog', 'locationId', locationId)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getAuditLog', 'patientId', patientId)
            const localVarPath = `/api/location/{locationId}/patients/{patientId}/audit-log`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatient: async (locationId: string, patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getPatient', 'locationId', locationId)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatient', 'patientId', patientId)
            const localVarPath = `/api/location/{locationId}/patients/{patientId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientDetails: async (locationId: string, patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getPatientDetails', 'locationId', locationId)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientDetails', 'patientId', patientId)
            const localVarPath = `/api/location/{locationId}/patients/{patientId}/details`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPatients: async (locationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('listPatients', 'locationId', locationId)
            const localVarPath = `/api/location/{locationId}/patients`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} patientId 
         * @param {PatientRequest} patientRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatient: async (locationId: string, patientId: string, patientRequest: PatientRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('updatePatient', 'locationId', locationId)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('updatePatient', 'patientId', patientId)
            // verify required parameter 'patientRequest' is not null or undefined
            assertParamExists('updatePatient', 'patientRequest', patientRequest)
            const localVarPath = `/api/location/{locationId}/patients/{patientId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientControllerApi - functional programming interface
 * @export
 */
export const PatientControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {PatientRequest} patientRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatient(locationId: string, patientRequest: PatientRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatient(locationId, patientRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.createPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePatient(locationId: string, patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePatient(locationId, patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.deletePatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePreview(locationId: string, patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssignedTreatmentPlanSummaryResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePreview(locationId, patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.deletePreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuditLog(locationId: string, patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditLogEntryResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuditLog(locationId, patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.getAuditLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatient(locationId: string, patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatient(locationId, patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.getPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientDetails(locationId: string, patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientDrawerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientDetails(locationId, patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.getPatientDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPatients(locationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPatients(locationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.listPatients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} patientId 
         * @param {PatientRequest} patientRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatient(locationId: string, patientId: string, patientRequest: PatientRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatient(locationId, patientId, patientRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.updatePatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientControllerApi - factory interface
 * @export
 */
export const PatientControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {PatientControllerApiCreatePatientRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatient(requestParameters: PatientControllerApiCreatePatientRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatientResponse> {
            return localVarFp.createPatient(requestParameters.locationId, requestParameters.patientRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PatientControllerApiDeletePatientRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatient(requestParameters: PatientControllerApiDeletePatientRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePatient(requestParameters.locationId, requestParameters.patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PatientControllerApiDeletePreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePreview(requestParameters: PatientControllerApiDeletePreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AssignedTreatmentPlanSummaryResponse>> {
            return localVarFp.deletePreview(requestParameters.locationId, requestParameters.patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PatientControllerApiGetAuditLogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditLog(requestParameters: PatientControllerApiGetAuditLogRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AuditLogEntryResponse>> {
            return localVarFp.getAuditLog(requestParameters.locationId, requestParameters.patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PatientControllerApiGetPatientRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatient(requestParameters: PatientControllerApiGetPatientRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatientResponse> {
            return localVarFp.getPatient(requestParameters.locationId, requestParameters.patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PatientControllerApiGetPatientDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientDetails(requestParameters: PatientControllerApiGetPatientDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatientDrawerResponse> {
            return localVarFp.getPatientDetails(requestParameters.locationId, requestParameters.patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PatientControllerApiListPatientsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPatients(requestParameters: PatientControllerApiListPatientsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PatientResponse>> {
            return localVarFp.listPatients(requestParameters.locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PatientControllerApiUpdatePatientRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatient(requestParameters: PatientControllerApiUpdatePatientRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatientResponse> {
            return localVarFp.updatePatient(requestParameters.locationId, requestParameters.patientId, requestParameters.patientRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientControllerApi - interface
 * @export
 * @interface PatientControllerApi
 */
export interface PatientControllerApiInterface {
    /**
     * 
     * @param {PatientControllerApiCreatePatientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApiInterface
     */
    createPatient(requestParameters: PatientControllerApiCreatePatientRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatientResponse>;

    /**
     * 
     * @param {PatientControllerApiDeletePatientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApiInterface
     */
    deletePatient(requestParameters: PatientControllerApiDeletePatientRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {PatientControllerApiDeletePreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApiInterface
     */
    deletePreview(requestParameters: PatientControllerApiDeletePreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AssignedTreatmentPlanSummaryResponse>>;

    /**
     * 
     * @param {PatientControllerApiGetAuditLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApiInterface
     */
    getAuditLog(requestParameters: PatientControllerApiGetAuditLogRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AuditLogEntryResponse>>;

    /**
     * 
     * @param {PatientControllerApiGetPatientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApiInterface
     */
    getPatient(requestParameters: PatientControllerApiGetPatientRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatientResponse>;

    /**
     * 
     * @param {PatientControllerApiGetPatientDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApiInterface
     */
    getPatientDetails(requestParameters: PatientControllerApiGetPatientDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatientDrawerResponse>;

    /**
     * 
     * @param {PatientControllerApiListPatientsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApiInterface
     */
    listPatients(requestParameters: PatientControllerApiListPatientsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PatientResponse>>;

    /**
     * 
     * @param {PatientControllerApiUpdatePatientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApiInterface
     */
    updatePatient(requestParameters: PatientControllerApiUpdatePatientRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatientResponse>;

}

/**
 * Request parameters for createPatient operation in PatientControllerApi.
 * @export
 * @interface PatientControllerApiCreatePatientRequest
 */
export interface PatientControllerApiCreatePatientRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientControllerApiCreatePatient
     */
    readonly locationId: string

    /**
     * 
     * @type {PatientRequest}
     * @memberof PatientControllerApiCreatePatient
     */
    readonly patientRequest: PatientRequest
}

/**
 * Request parameters for deletePatient operation in PatientControllerApi.
 * @export
 * @interface PatientControllerApiDeletePatientRequest
 */
export interface PatientControllerApiDeletePatientRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientControllerApiDeletePatient
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof PatientControllerApiDeletePatient
     */
    readonly patientId: string
}

/**
 * Request parameters for deletePreview operation in PatientControllerApi.
 * @export
 * @interface PatientControllerApiDeletePreviewRequest
 */
export interface PatientControllerApiDeletePreviewRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientControllerApiDeletePreview
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof PatientControllerApiDeletePreview
     */
    readonly patientId: string
}

/**
 * Request parameters for getAuditLog operation in PatientControllerApi.
 * @export
 * @interface PatientControllerApiGetAuditLogRequest
 */
export interface PatientControllerApiGetAuditLogRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientControllerApiGetAuditLog
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof PatientControllerApiGetAuditLog
     */
    readonly patientId: string
}

/**
 * Request parameters for getPatient operation in PatientControllerApi.
 * @export
 * @interface PatientControllerApiGetPatientRequest
 */
export interface PatientControllerApiGetPatientRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientControllerApiGetPatient
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof PatientControllerApiGetPatient
     */
    readonly patientId: string
}

/**
 * Request parameters for getPatientDetails operation in PatientControllerApi.
 * @export
 * @interface PatientControllerApiGetPatientDetailsRequest
 */
export interface PatientControllerApiGetPatientDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientControllerApiGetPatientDetails
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof PatientControllerApiGetPatientDetails
     */
    readonly patientId: string
}

/**
 * Request parameters for listPatients operation in PatientControllerApi.
 * @export
 * @interface PatientControllerApiListPatientsRequest
 */
export interface PatientControllerApiListPatientsRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientControllerApiListPatients
     */
    readonly locationId: string
}

/**
 * Request parameters for updatePatient operation in PatientControllerApi.
 * @export
 * @interface PatientControllerApiUpdatePatientRequest
 */
export interface PatientControllerApiUpdatePatientRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientControllerApiUpdatePatient
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof PatientControllerApiUpdatePatient
     */
    readonly patientId: string

    /**
     * 
     * @type {PatientRequest}
     * @memberof PatientControllerApiUpdatePatient
     */
    readonly patientRequest: PatientRequest
}

/**
 * PatientControllerApi - object-oriented interface
 * @export
 * @class PatientControllerApi
 * @extends {BaseAPI}
 */
export class PatientControllerApi extends BaseAPI implements PatientControllerApiInterface {
    /**
     * 
     * @param {PatientControllerApiCreatePatientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public createPatient(requestParameters: PatientControllerApiCreatePatientRequest, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).createPatient(requestParameters.locationId, requestParameters.patientRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PatientControllerApiDeletePatientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public deletePatient(requestParameters: PatientControllerApiDeletePatientRequest, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).deletePatient(requestParameters.locationId, requestParameters.patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PatientControllerApiDeletePreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public deletePreview(requestParameters: PatientControllerApiDeletePreviewRequest, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).deletePreview(requestParameters.locationId, requestParameters.patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PatientControllerApiGetAuditLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public getAuditLog(requestParameters: PatientControllerApiGetAuditLogRequest, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).getAuditLog(requestParameters.locationId, requestParameters.patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PatientControllerApiGetPatientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public getPatient(requestParameters: PatientControllerApiGetPatientRequest, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).getPatient(requestParameters.locationId, requestParameters.patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PatientControllerApiGetPatientDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public getPatientDetails(requestParameters: PatientControllerApiGetPatientDetailsRequest, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).getPatientDetails(requestParameters.locationId, requestParameters.patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PatientControllerApiListPatientsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public listPatients(requestParameters: PatientControllerApiListPatientsRequest, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).listPatients(requestParameters.locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PatientControllerApiUpdatePatientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public updatePatient(requestParameters: PatientControllerApiUpdatePatientRequest, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).updatePatient(requestParameters.locationId, requestParameters.patientId, requestParameters.patientRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientRoomControllerApi - axios parameter creator
 * @export
 */
export const PatientRoomControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {CreatePatientRoomRequest} createPatientRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientRoom: async (locationId: string, createPatientRoomRequest: CreatePatientRoomRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('createPatientRoom', 'locationId', locationId)
            // verify required parameter 'createPatientRoomRequest' is not null or undefined
            assertParamExists('createPatientRoom', 'createPatientRoomRequest', createPatientRoomRequest)
            const localVarPath = `/api/location/{locationId}/patient-rooms`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPatientRoomRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} patientRoomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientRoom: async (locationId: string, patientRoomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deletePatientRoom', 'locationId', locationId)
            // verify required parameter 'patientRoomId' is not null or undefined
            assertParamExists('deletePatientRoom', 'patientRoomId', patientRoomId)
            const localVarPath = `/api/location/{locationId}/patient-rooms/{patientRoomId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"patientRoomId"}}`, encodeURIComponent(String(patientRoomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPatientRooms: async (locationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('listPatientRooms', 'locationId', locationId)
            const localVarPath = `/api/location/{locationId}/patient-rooms`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} patientRoomId 
         * @param {UpdatePatientRoomRequest} updatePatientRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientRoom: async (locationId: string, patientRoomId: string, updatePatientRoomRequest: UpdatePatientRoomRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('updatePatientRoom', 'locationId', locationId)
            // verify required parameter 'patientRoomId' is not null or undefined
            assertParamExists('updatePatientRoom', 'patientRoomId', patientRoomId)
            // verify required parameter 'updatePatientRoomRequest' is not null or undefined
            assertParamExists('updatePatientRoom', 'updatePatientRoomRequest', updatePatientRoomRequest)
            const localVarPath = `/api/location/{locationId}/patient-rooms/{patientRoomId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"patientRoomId"}}`, encodeURIComponent(String(patientRoomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePatientRoomRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientRoomControllerApi - functional programming interface
 * @export
 */
export const PatientRoomControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientRoomControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {CreatePatientRoomRequest} createPatientRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientRoom(locationId: string, createPatientRoomRequest: CreatePatientRoomRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientRoomResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientRoom(locationId, createPatientRoomRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientRoomControllerApi.createPatientRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} patientRoomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePatientRoom(locationId: string, patientRoomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePatientRoom(locationId, patientRoomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientRoomControllerApi.deletePatientRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPatientRooms(locationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientRoomResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPatientRooms(locationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientRoomControllerApi.listPatientRooms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} patientRoomId 
         * @param {UpdatePatientRoomRequest} updatePatientRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientRoom(locationId: string, patientRoomId: string, updatePatientRoomRequest: UpdatePatientRoomRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientRoomResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientRoom(locationId, patientRoomId, updatePatientRoomRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientRoomControllerApi.updatePatientRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientRoomControllerApi - factory interface
 * @export
 */
export const PatientRoomControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientRoomControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {PatientRoomControllerApiCreatePatientRoomRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientRoom(requestParameters: PatientRoomControllerApiCreatePatientRoomRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatientRoomResponse> {
            return localVarFp.createPatientRoom(requestParameters.locationId, requestParameters.createPatientRoomRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PatientRoomControllerApiDeletePatientRoomRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientRoom(requestParameters: PatientRoomControllerApiDeletePatientRoomRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePatientRoom(requestParameters.locationId, requestParameters.patientRoomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PatientRoomControllerApiListPatientRoomsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPatientRooms(requestParameters: PatientRoomControllerApiListPatientRoomsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PatientRoomResponse>> {
            return localVarFp.listPatientRooms(requestParameters.locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PatientRoomControllerApiUpdatePatientRoomRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientRoom(requestParameters: PatientRoomControllerApiUpdatePatientRoomRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatientRoomResponse> {
            return localVarFp.updatePatientRoom(requestParameters.locationId, requestParameters.patientRoomId, requestParameters.updatePatientRoomRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientRoomControllerApi - interface
 * @export
 * @interface PatientRoomControllerApi
 */
export interface PatientRoomControllerApiInterface {
    /**
     * 
     * @param {PatientRoomControllerApiCreatePatientRoomRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientRoomControllerApiInterface
     */
    createPatientRoom(requestParameters: PatientRoomControllerApiCreatePatientRoomRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatientRoomResponse>;

    /**
     * 
     * @param {PatientRoomControllerApiDeletePatientRoomRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientRoomControllerApiInterface
     */
    deletePatientRoom(requestParameters: PatientRoomControllerApiDeletePatientRoomRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {PatientRoomControllerApiListPatientRoomsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientRoomControllerApiInterface
     */
    listPatientRooms(requestParameters: PatientRoomControllerApiListPatientRoomsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PatientRoomResponse>>;

    /**
     * 
     * @param {PatientRoomControllerApiUpdatePatientRoomRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientRoomControllerApiInterface
     */
    updatePatientRoom(requestParameters: PatientRoomControllerApiUpdatePatientRoomRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatientRoomResponse>;

}

/**
 * Request parameters for createPatientRoom operation in PatientRoomControllerApi.
 * @export
 * @interface PatientRoomControllerApiCreatePatientRoomRequest
 */
export interface PatientRoomControllerApiCreatePatientRoomRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientRoomControllerApiCreatePatientRoom
     */
    readonly locationId: string

    /**
     * 
     * @type {CreatePatientRoomRequest}
     * @memberof PatientRoomControllerApiCreatePatientRoom
     */
    readonly createPatientRoomRequest: CreatePatientRoomRequest
}

/**
 * Request parameters for deletePatientRoom operation in PatientRoomControllerApi.
 * @export
 * @interface PatientRoomControllerApiDeletePatientRoomRequest
 */
export interface PatientRoomControllerApiDeletePatientRoomRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientRoomControllerApiDeletePatientRoom
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof PatientRoomControllerApiDeletePatientRoom
     */
    readonly patientRoomId: string
}

/**
 * Request parameters for listPatientRooms operation in PatientRoomControllerApi.
 * @export
 * @interface PatientRoomControllerApiListPatientRoomsRequest
 */
export interface PatientRoomControllerApiListPatientRoomsRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientRoomControllerApiListPatientRooms
     */
    readonly locationId: string
}

/**
 * Request parameters for updatePatientRoom operation in PatientRoomControllerApi.
 * @export
 * @interface PatientRoomControllerApiUpdatePatientRoomRequest
 */
export interface PatientRoomControllerApiUpdatePatientRoomRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientRoomControllerApiUpdatePatientRoom
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof PatientRoomControllerApiUpdatePatientRoom
     */
    readonly patientRoomId: string

    /**
     * 
     * @type {UpdatePatientRoomRequest}
     * @memberof PatientRoomControllerApiUpdatePatientRoom
     */
    readonly updatePatientRoomRequest: UpdatePatientRoomRequest
}

/**
 * PatientRoomControllerApi - object-oriented interface
 * @export
 * @class PatientRoomControllerApi
 * @extends {BaseAPI}
 */
export class PatientRoomControllerApi extends BaseAPI implements PatientRoomControllerApiInterface {
    /**
     * 
     * @param {PatientRoomControllerApiCreatePatientRoomRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientRoomControllerApi
     */
    public createPatientRoom(requestParameters: PatientRoomControllerApiCreatePatientRoomRequest, options?: RawAxiosRequestConfig) {
        return PatientRoomControllerApiFp(this.configuration).createPatientRoom(requestParameters.locationId, requestParameters.createPatientRoomRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PatientRoomControllerApiDeletePatientRoomRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientRoomControllerApi
     */
    public deletePatientRoom(requestParameters: PatientRoomControllerApiDeletePatientRoomRequest, options?: RawAxiosRequestConfig) {
        return PatientRoomControllerApiFp(this.configuration).deletePatientRoom(requestParameters.locationId, requestParameters.patientRoomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PatientRoomControllerApiListPatientRoomsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientRoomControllerApi
     */
    public listPatientRooms(requestParameters: PatientRoomControllerApiListPatientRoomsRequest, options?: RawAxiosRequestConfig) {
        return PatientRoomControllerApiFp(this.configuration).listPatientRooms(requestParameters.locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PatientRoomControllerApiUpdatePatientRoomRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientRoomControllerApi
     */
    public updatePatientRoom(requestParameters: PatientRoomControllerApiUpdatePatientRoomRequest, options?: RawAxiosRequestConfig) {
        return PatientRoomControllerApiFp(this.configuration).updatePatientRoom(requestParameters.locationId, requestParameters.patientRoomId, requestParameters.updatePatientRoomRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientRoomPropertyControllerApi - axios parameter creator
 * @export
 */
export const PatientRoomPropertyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreatePatientRoomPropertyRequest} createPatientRoomPropertyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientRoomProperty: async (createPatientRoomPropertyRequest: CreatePatientRoomPropertyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPatientRoomPropertyRequest' is not null or undefined
            assertParamExists('createPatientRoomProperty', 'createPatientRoomPropertyRequest', createPatientRoomPropertyRequest)
            const localVarPath = `/api/account/patient-room-properties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPatientRoomPropertyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientRoomProperty: async (propertyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('deletePatientRoomProperty', 'propertyId', propertyId)
            const localVarPath = `/api/account/patient-room-properties/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPatientRoomProperties: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/patient-room-properties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPatientRoomPropertiesWithUsage: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/patient-room-properties/usage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} propertyId 
         * @param {UpdatePatientRoomPropertyRequest} updatePatientRoomPropertyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientRoomProperty: async (propertyId: string, updatePatientRoomPropertyRequest: UpdatePatientRoomPropertyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('updatePatientRoomProperty', 'propertyId', propertyId)
            // verify required parameter 'updatePatientRoomPropertyRequest' is not null or undefined
            assertParamExists('updatePatientRoomProperty', 'updatePatientRoomPropertyRequest', updatePatientRoomPropertyRequest)
            const localVarPath = `/api/account/patient-room-properties/{propertyId}`
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePatientRoomPropertyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientRoomPropertyControllerApi - functional programming interface
 * @export
 */
export const PatientRoomPropertyControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientRoomPropertyControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreatePatientRoomPropertyRequest} createPatientRoomPropertyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientRoomProperty(createPatientRoomPropertyRequest: CreatePatientRoomPropertyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientRoomPropertyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientRoomProperty(createPatientRoomPropertyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientRoomPropertyControllerApi.createPatientRoomProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePatientRoomProperty(propertyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePatientRoomProperty(propertyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientRoomPropertyControllerApi.deletePatientRoomProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPatientRoomProperties(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientRoomPropertyResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPatientRoomProperties(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientRoomPropertyControllerApi.listPatientRoomProperties']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPatientRoomPropertiesWithUsage(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientRoomPropertyUsageResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPatientRoomPropertiesWithUsage(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientRoomPropertyControllerApi.listPatientRoomPropertiesWithUsage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} propertyId 
         * @param {UpdatePatientRoomPropertyRequest} updatePatientRoomPropertyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientRoomProperty(propertyId: string, updatePatientRoomPropertyRequest: UpdatePatientRoomPropertyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientRoomPropertyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientRoomProperty(propertyId, updatePatientRoomPropertyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientRoomPropertyControllerApi.updatePatientRoomProperty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientRoomPropertyControllerApi - factory interface
 * @export
 */
export const PatientRoomPropertyControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientRoomPropertyControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {PatientRoomPropertyControllerApiCreatePatientRoomPropertyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientRoomProperty(requestParameters: PatientRoomPropertyControllerApiCreatePatientRoomPropertyRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatientRoomPropertyResponse> {
            return localVarFp.createPatientRoomProperty(requestParameters.createPatientRoomPropertyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PatientRoomPropertyControllerApiDeletePatientRoomPropertyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientRoomProperty(requestParameters: PatientRoomPropertyControllerApiDeletePatientRoomPropertyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePatientRoomProperty(requestParameters.propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPatientRoomProperties(options?: RawAxiosRequestConfig): AxiosPromise<Array<PatientRoomPropertyResponse>> {
            return localVarFp.listPatientRoomProperties(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPatientRoomPropertiesWithUsage(options?: RawAxiosRequestConfig): AxiosPromise<Array<PatientRoomPropertyUsageResponse>> {
            return localVarFp.listPatientRoomPropertiesWithUsage(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PatientRoomPropertyControllerApiUpdatePatientRoomPropertyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientRoomProperty(requestParameters: PatientRoomPropertyControllerApiUpdatePatientRoomPropertyRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatientRoomPropertyResponse> {
            return localVarFp.updatePatientRoomProperty(requestParameters.propertyId, requestParameters.updatePatientRoomPropertyRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientRoomPropertyControllerApi - interface
 * @export
 * @interface PatientRoomPropertyControllerApi
 */
export interface PatientRoomPropertyControllerApiInterface {
    /**
     * 
     * @param {PatientRoomPropertyControllerApiCreatePatientRoomPropertyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientRoomPropertyControllerApiInterface
     */
    createPatientRoomProperty(requestParameters: PatientRoomPropertyControllerApiCreatePatientRoomPropertyRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatientRoomPropertyResponse>;

    /**
     * 
     * @param {PatientRoomPropertyControllerApiDeletePatientRoomPropertyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientRoomPropertyControllerApiInterface
     */
    deletePatientRoomProperty(requestParameters: PatientRoomPropertyControllerApiDeletePatientRoomPropertyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientRoomPropertyControllerApiInterface
     */
    listPatientRoomProperties(options?: RawAxiosRequestConfig): AxiosPromise<Array<PatientRoomPropertyResponse>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientRoomPropertyControllerApiInterface
     */
    listPatientRoomPropertiesWithUsage(options?: RawAxiosRequestConfig): AxiosPromise<Array<PatientRoomPropertyUsageResponse>>;

    /**
     * 
     * @param {PatientRoomPropertyControllerApiUpdatePatientRoomPropertyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientRoomPropertyControllerApiInterface
     */
    updatePatientRoomProperty(requestParameters: PatientRoomPropertyControllerApiUpdatePatientRoomPropertyRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatientRoomPropertyResponse>;

}

/**
 * Request parameters for createPatientRoomProperty operation in PatientRoomPropertyControllerApi.
 * @export
 * @interface PatientRoomPropertyControllerApiCreatePatientRoomPropertyRequest
 */
export interface PatientRoomPropertyControllerApiCreatePatientRoomPropertyRequest {
    /**
     * 
     * @type {CreatePatientRoomPropertyRequest}
     * @memberof PatientRoomPropertyControllerApiCreatePatientRoomProperty
     */
    readonly createPatientRoomPropertyRequest: CreatePatientRoomPropertyRequest
}

/**
 * Request parameters for deletePatientRoomProperty operation in PatientRoomPropertyControllerApi.
 * @export
 * @interface PatientRoomPropertyControllerApiDeletePatientRoomPropertyRequest
 */
export interface PatientRoomPropertyControllerApiDeletePatientRoomPropertyRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientRoomPropertyControllerApiDeletePatientRoomProperty
     */
    readonly propertyId: string
}

/**
 * Request parameters for updatePatientRoomProperty operation in PatientRoomPropertyControllerApi.
 * @export
 * @interface PatientRoomPropertyControllerApiUpdatePatientRoomPropertyRequest
 */
export interface PatientRoomPropertyControllerApiUpdatePatientRoomPropertyRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientRoomPropertyControllerApiUpdatePatientRoomProperty
     */
    readonly propertyId: string

    /**
     * 
     * @type {UpdatePatientRoomPropertyRequest}
     * @memberof PatientRoomPropertyControllerApiUpdatePatientRoomProperty
     */
    readonly updatePatientRoomPropertyRequest: UpdatePatientRoomPropertyRequest
}

/**
 * PatientRoomPropertyControllerApi - object-oriented interface
 * @export
 * @class PatientRoomPropertyControllerApi
 * @extends {BaseAPI}
 */
export class PatientRoomPropertyControllerApi extends BaseAPI implements PatientRoomPropertyControllerApiInterface {
    /**
     * 
     * @param {PatientRoomPropertyControllerApiCreatePatientRoomPropertyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientRoomPropertyControllerApi
     */
    public createPatientRoomProperty(requestParameters: PatientRoomPropertyControllerApiCreatePatientRoomPropertyRequest, options?: RawAxiosRequestConfig) {
        return PatientRoomPropertyControllerApiFp(this.configuration).createPatientRoomProperty(requestParameters.createPatientRoomPropertyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PatientRoomPropertyControllerApiDeletePatientRoomPropertyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientRoomPropertyControllerApi
     */
    public deletePatientRoomProperty(requestParameters: PatientRoomPropertyControllerApiDeletePatientRoomPropertyRequest, options?: RawAxiosRequestConfig) {
        return PatientRoomPropertyControllerApiFp(this.configuration).deletePatientRoomProperty(requestParameters.propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientRoomPropertyControllerApi
     */
    public listPatientRoomProperties(options?: RawAxiosRequestConfig) {
        return PatientRoomPropertyControllerApiFp(this.configuration).listPatientRoomProperties(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientRoomPropertyControllerApi
     */
    public listPatientRoomPropertiesWithUsage(options?: RawAxiosRequestConfig) {
        return PatientRoomPropertyControllerApiFp(this.configuration).listPatientRoomPropertiesWithUsage(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PatientRoomPropertyControllerApiUpdatePatientRoomPropertyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientRoomPropertyControllerApi
     */
    public updatePatientRoomProperty(requestParameters: PatientRoomPropertyControllerApiUpdatePatientRoomPropertyRequest, options?: RawAxiosRequestConfig) {
        return PatientRoomPropertyControllerApiFp(this.configuration).updatePatientRoomProperty(requestParameters.propertyId, requestParameters.updatePatientRoomPropertyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ScenarioControllerApi - axios parameter creator
 * @export
 */
export const ScenarioControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentScenario: async (locationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getCurrentScenario', 'locationId', locationId)
            const localVarPath = `/api/location/{locationId}/scenario/current`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScenarioForYear: async (locationId: string, year: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getScenarioForYear', 'locationId', locationId)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getScenarioForYear', 'year', year)
            const localVarPath = `/api/location/{locationId}/scenario/year/{year}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScenarioControllerApi - functional programming interface
 * @export
 */
export const ScenarioControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScenarioControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentScenario(locationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScenarioResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentScenario(locationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScenarioControllerApi.getCurrentScenario']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScenarioForYear(locationId: string, year: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScenarioResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScenarioForYear(locationId, year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScenarioControllerApi.getScenarioForYear']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ScenarioControllerApi - factory interface
 * @export
 */
export const ScenarioControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScenarioControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ScenarioControllerApiGetCurrentScenarioRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentScenario(requestParameters: ScenarioControllerApiGetCurrentScenarioRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScenarioResponse> {
            return localVarFp.getCurrentScenario(requestParameters.locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ScenarioControllerApiGetScenarioForYearRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScenarioForYear(requestParameters: ScenarioControllerApiGetScenarioForYearRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScenarioResponse> {
            return localVarFp.getScenarioForYear(requestParameters.locationId, requestParameters.year, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScenarioControllerApi - interface
 * @export
 * @interface ScenarioControllerApi
 */
export interface ScenarioControllerApiInterface {
    /**
     * 
     * @param {ScenarioControllerApiGetCurrentScenarioRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenarioControllerApiInterface
     */
    getCurrentScenario(requestParameters: ScenarioControllerApiGetCurrentScenarioRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScenarioResponse>;

    /**
     * 
     * @param {ScenarioControllerApiGetScenarioForYearRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenarioControllerApiInterface
     */
    getScenarioForYear(requestParameters: ScenarioControllerApiGetScenarioForYearRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScenarioResponse>;

}

/**
 * Request parameters for getCurrentScenario operation in ScenarioControllerApi.
 * @export
 * @interface ScenarioControllerApiGetCurrentScenarioRequest
 */
export interface ScenarioControllerApiGetCurrentScenarioRequest {
    /**
     * 
     * @type {string}
     * @memberof ScenarioControllerApiGetCurrentScenario
     */
    readonly locationId: string
}

/**
 * Request parameters for getScenarioForYear operation in ScenarioControllerApi.
 * @export
 * @interface ScenarioControllerApiGetScenarioForYearRequest
 */
export interface ScenarioControllerApiGetScenarioForYearRequest {
    /**
     * 
     * @type {string}
     * @memberof ScenarioControllerApiGetScenarioForYear
     */
    readonly locationId: string

    /**
     * 
     * @type {number}
     * @memberof ScenarioControllerApiGetScenarioForYear
     */
    readonly year: number
}

/**
 * ScenarioControllerApi - object-oriented interface
 * @export
 * @class ScenarioControllerApi
 * @extends {BaseAPI}
 */
export class ScenarioControllerApi extends BaseAPI implements ScenarioControllerApiInterface {
    /**
     * 
     * @param {ScenarioControllerApiGetCurrentScenarioRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenarioControllerApi
     */
    public getCurrentScenario(requestParameters: ScenarioControllerApiGetCurrentScenarioRequest, options?: RawAxiosRequestConfig) {
        return ScenarioControllerApiFp(this.configuration).getCurrentScenario(requestParameters.locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ScenarioControllerApiGetScenarioForYearRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenarioControllerApi
     */
    public getScenarioForYear(requestParameters: ScenarioControllerApiGetScenarioForYearRequest, options?: RawAxiosRequestConfig) {
        return ScenarioControllerApiFp(this.configuration).getScenarioForYear(requestParameters.locationId, requestParameters.year, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ScenarioLockControllerApi - axios parameter creator
 * @export
 */
export const ScenarioLockControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acquire: async (locationId: string, scenarioId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('acquire', 'locationId', locationId)
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('acquire', 'scenarioId', scenarioId)
            const localVarPath = `/api/location/{locationId}/scenario/{scenarioId}/lock`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"scenarioId"}}`, encodeURIComponent(String(scenarioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus: async (locationId: string, scenarioId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getStatus', 'locationId', locationId)
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('getStatus', 'scenarioId', scenarioId)
            const localVarPath = `/api/location/{locationId}/scenario/{scenarioId}/lock`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"scenarioId"}}`, encodeURIComponent(String(scenarioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        release: async (locationId: string, scenarioId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('release', 'locationId', locationId)
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('release', 'scenarioId', scenarioId)
            const localVarPath = `/api/location/{locationId}/scenario/{scenarioId}/lock`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"scenarioId"}}`, encodeURIComponent(String(scenarioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScenarioLockControllerApi - functional programming interface
 * @export
 */
export const ScenarioLockControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScenarioLockControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acquire(locationId: string, scenarioId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LockResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acquire(locationId, scenarioId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScenarioLockControllerApi.acquire']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatus(locationId: string, scenarioId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LockStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatus(locationId, scenarioId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScenarioLockControllerApi.getStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async release(locationId: string, scenarioId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.release(locationId, scenarioId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScenarioLockControllerApi.release']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ScenarioLockControllerApi - factory interface
 * @export
 */
export const ScenarioLockControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScenarioLockControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ScenarioLockControllerApiAcquireRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acquire(requestParameters: ScenarioLockControllerApiAcquireRequest, options?: RawAxiosRequestConfig): AxiosPromise<LockResponse> {
            return localVarFp.acquire(requestParameters.locationId, requestParameters.scenarioId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ScenarioLockControllerApiGetStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus(requestParameters: ScenarioLockControllerApiGetStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<LockStatusResponse> {
            return localVarFp.getStatus(requestParameters.locationId, requestParameters.scenarioId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ScenarioLockControllerApiReleaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        release(requestParameters: ScenarioLockControllerApiReleaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.release(requestParameters.locationId, requestParameters.scenarioId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScenarioLockControllerApi - interface
 * @export
 * @interface ScenarioLockControllerApi
 */
export interface ScenarioLockControllerApiInterface {
    /**
     * 
     * @param {ScenarioLockControllerApiAcquireRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenarioLockControllerApiInterface
     */
    acquire(requestParameters: ScenarioLockControllerApiAcquireRequest, options?: RawAxiosRequestConfig): AxiosPromise<LockResponse>;

    /**
     * 
     * @param {ScenarioLockControllerApiGetStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenarioLockControllerApiInterface
     */
    getStatus(requestParameters: ScenarioLockControllerApiGetStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<LockStatusResponse>;

    /**
     * 
     * @param {ScenarioLockControllerApiReleaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenarioLockControllerApiInterface
     */
    release(requestParameters: ScenarioLockControllerApiReleaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for acquire operation in ScenarioLockControllerApi.
 * @export
 * @interface ScenarioLockControllerApiAcquireRequest
 */
export interface ScenarioLockControllerApiAcquireRequest {
    /**
     * 
     * @type {string}
     * @memberof ScenarioLockControllerApiAcquire
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof ScenarioLockControllerApiAcquire
     */
    readonly scenarioId: string
}

/**
 * Request parameters for getStatus operation in ScenarioLockControllerApi.
 * @export
 * @interface ScenarioLockControllerApiGetStatusRequest
 */
export interface ScenarioLockControllerApiGetStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof ScenarioLockControllerApiGetStatus
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof ScenarioLockControllerApiGetStatus
     */
    readonly scenarioId: string
}

/**
 * Request parameters for release operation in ScenarioLockControllerApi.
 * @export
 * @interface ScenarioLockControllerApiReleaseRequest
 */
export interface ScenarioLockControllerApiReleaseRequest {
    /**
     * 
     * @type {string}
     * @memberof ScenarioLockControllerApiRelease
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof ScenarioLockControllerApiRelease
     */
    readonly scenarioId: string
}

/**
 * ScenarioLockControllerApi - object-oriented interface
 * @export
 * @class ScenarioLockControllerApi
 * @extends {BaseAPI}
 */
export class ScenarioLockControllerApi extends BaseAPI implements ScenarioLockControllerApiInterface {
    /**
     * 
     * @param {ScenarioLockControllerApiAcquireRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenarioLockControllerApi
     */
    public acquire(requestParameters: ScenarioLockControllerApiAcquireRequest, options?: RawAxiosRequestConfig) {
        return ScenarioLockControllerApiFp(this.configuration).acquire(requestParameters.locationId, requestParameters.scenarioId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ScenarioLockControllerApiGetStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenarioLockControllerApi
     */
    public getStatus(requestParameters: ScenarioLockControllerApiGetStatusRequest, options?: RawAxiosRequestConfig) {
        return ScenarioLockControllerApiFp(this.configuration).getStatus(requestParameters.locationId, requestParameters.scenarioId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ScenarioLockControllerApiReleaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenarioLockControllerApi
     */
    public release(requestParameters: ScenarioLockControllerApiReleaseRequest, options?: RawAxiosRequestConfig) {
        return ScenarioLockControllerApiFp(this.configuration).release(requestParameters.locationId, requestParameters.scenarioId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SchedulingJobControllerApi - axios parameter creator
 * @export
 */
export const SchedulingJobControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {number} weekNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentResult: async (locationId: string, scenarioId: string, weekNumber: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getCurrentResult', 'locationId', locationId)
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('getCurrentResult', 'scenarioId', scenarioId)
            // verify required parameter 'weekNumber' is not null or undefined
            assertParamExists('getCurrentResult', 'weekNumber', weekNumber)
            const localVarPath = `/api/scheduling-jobs/locations/{locationId}/scenarios/{scenarioId}/weeks/{weekNumber}/current-result`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"scenarioId"}}`, encodeURIComponent(String(scenarioId)))
                .replace(`{${"weekNumber"}}`, encodeURIComponent(String(weekNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {number} weekNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestJob: async (locationId: string, scenarioId: string, weekNumber: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getLatestJob', 'locationId', locationId)
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('getLatestJob', 'scenarioId', scenarioId)
            // verify required parameter 'weekNumber' is not null or undefined
            assertParamExists('getLatestJob', 'weekNumber', weekNumber)
            const localVarPath = `/api/scheduling-jobs/locations/{locationId}/scenarios/{scenarioId}/weeks/{weekNumber}/latest`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"scenarioId"}}`, encodeURIComponent(String(scenarioId)))
                .replace(`{${"weekNumber"}}`, encodeURIComponent(String(weekNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeekStatuses: async (locationId: string, scenarioId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getWeekStatuses', 'locationId', locationId)
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('getWeekStatuses', 'scenarioId', scenarioId)
            const localVarPath = `/api/scheduling-jobs/locations/{locationId}/scenarios/{scenarioId}/weeks/statuses`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"scenarioId"}}`, encodeURIComponent(String(scenarioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {number} weekNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewInput: async (locationId: string, scenarioId: string, weekNumber: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('previewInput', 'locationId', locationId)
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('previewInput', 'scenarioId', scenarioId)
            // verify required parameter 'weekNumber' is not null or undefined
            assertParamExists('previewInput', 'weekNumber', weekNumber)
            const localVarPath = `/api/scheduling-jobs/locations/{locationId}/scenarios/{scenarioId}/weeks/{weekNumber}/input-preview`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"scenarioId"}}`, encodeURIComponent(String(scenarioId)))
                .replace(`{${"weekNumber"}}`, encodeURIComponent(String(weekNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {number} weekNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerCalculation: async (locationId: string, scenarioId: string, weekNumber: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('triggerCalculation', 'locationId', locationId)
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('triggerCalculation', 'scenarioId', scenarioId)
            // verify required parameter 'weekNumber' is not null or undefined
            assertParamExists('triggerCalculation', 'weekNumber', weekNumber)
            const localVarPath = `/api/scheduling-jobs/locations/{locationId}/scenarios/{scenarioId}/weeks/{weekNumber}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"scenarioId"}}`, encodeURIComponent(String(scenarioId)))
                .replace(`{${"weekNumber"}}`, encodeURIComponent(String(weekNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchedulingJobControllerApi - functional programming interface
 * @export
 */
export const SchedulingJobControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchedulingJobControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {number} weekNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentResult(locationId: string, scenarioId: string, weekNumber: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchedulingJobResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentResult(locationId, scenarioId, weekNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulingJobControllerApi.getCurrentResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {number} weekNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestJob(locationId: string, scenarioId: string, weekNumber: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchedulingJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestJob(locationId, scenarioId, weekNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulingJobControllerApi.getLatestJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeekStatuses(locationId: string, scenarioId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SchedulingJobWeekStatusResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeekStatuses(locationId, scenarioId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulingJobControllerApi.getWeekStatuses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {number} weekNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewInput(locationId: string, scenarioId: string, weekNumber: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewInput(locationId, scenarioId, weekNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulingJobControllerApi.previewInput']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {number} weekNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerCalculation(locationId: string, scenarioId: string, weekNumber: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchedulingJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerCalculation(locationId, scenarioId, weekNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulingJobControllerApi.triggerCalculation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SchedulingJobControllerApi - factory interface
 * @export
 */
export const SchedulingJobControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchedulingJobControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {SchedulingJobControllerApiGetCurrentResultRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentResult(requestParameters: SchedulingJobControllerApiGetCurrentResultRequest, options?: RawAxiosRequestConfig): AxiosPromise<SchedulingJobResultResponse> {
            return localVarFp.getCurrentResult(requestParameters.locationId, requestParameters.scenarioId, requestParameters.weekNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SchedulingJobControllerApiGetLatestJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestJob(requestParameters: SchedulingJobControllerApiGetLatestJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<SchedulingJobResponse> {
            return localVarFp.getLatestJob(requestParameters.locationId, requestParameters.scenarioId, requestParameters.weekNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SchedulingJobControllerApiGetWeekStatusesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeekStatuses(requestParameters: SchedulingJobControllerApiGetWeekStatusesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SchedulingJobWeekStatusResponse>> {
            return localVarFp.getWeekStatuses(requestParameters.locationId, requestParameters.scenarioId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SchedulingJobControllerApiPreviewInputRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewInput(requestParameters: SchedulingJobControllerApiPreviewInputRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.previewInput(requestParameters.locationId, requestParameters.scenarioId, requestParameters.weekNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SchedulingJobControllerApiTriggerCalculationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerCalculation(requestParameters: SchedulingJobControllerApiTriggerCalculationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SchedulingJobResponse> {
            return localVarFp.triggerCalculation(requestParameters.locationId, requestParameters.scenarioId, requestParameters.weekNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SchedulingJobControllerApi - interface
 * @export
 * @interface SchedulingJobControllerApi
 */
export interface SchedulingJobControllerApiInterface {
    /**
     * 
     * @param {SchedulingJobControllerApiGetCurrentResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulingJobControllerApiInterface
     */
    getCurrentResult(requestParameters: SchedulingJobControllerApiGetCurrentResultRequest, options?: RawAxiosRequestConfig): AxiosPromise<SchedulingJobResultResponse>;

    /**
     * 
     * @param {SchedulingJobControllerApiGetLatestJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulingJobControllerApiInterface
     */
    getLatestJob(requestParameters: SchedulingJobControllerApiGetLatestJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<SchedulingJobResponse>;

    /**
     * 
     * @param {SchedulingJobControllerApiGetWeekStatusesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulingJobControllerApiInterface
     */
    getWeekStatuses(requestParameters: SchedulingJobControllerApiGetWeekStatusesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SchedulingJobWeekStatusResponse>>;

    /**
     * 
     * @param {SchedulingJobControllerApiPreviewInputRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulingJobControllerApiInterface
     */
    previewInput(requestParameters: SchedulingJobControllerApiPreviewInputRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {SchedulingJobControllerApiTriggerCalculationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulingJobControllerApiInterface
     */
    triggerCalculation(requestParameters: SchedulingJobControllerApiTriggerCalculationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SchedulingJobResponse>;

}

/**
 * Request parameters for getCurrentResult operation in SchedulingJobControllerApi.
 * @export
 * @interface SchedulingJobControllerApiGetCurrentResultRequest
 */
export interface SchedulingJobControllerApiGetCurrentResultRequest {
    /**
     * 
     * @type {string}
     * @memberof SchedulingJobControllerApiGetCurrentResult
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof SchedulingJobControllerApiGetCurrentResult
     */
    readonly scenarioId: string

    /**
     * 
     * @type {number}
     * @memberof SchedulingJobControllerApiGetCurrentResult
     */
    readonly weekNumber: number
}

/**
 * Request parameters for getLatestJob operation in SchedulingJobControllerApi.
 * @export
 * @interface SchedulingJobControllerApiGetLatestJobRequest
 */
export interface SchedulingJobControllerApiGetLatestJobRequest {
    /**
     * 
     * @type {string}
     * @memberof SchedulingJobControllerApiGetLatestJob
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof SchedulingJobControllerApiGetLatestJob
     */
    readonly scenarioId: string

    /**
     * 
     * @type {number}
     * @memberof SchedulingJobControllerApiGetLatestJob
     */
    readonly weekNumber: number
}

/**
 * Request parameters for getWeekStatuses operation in SchedulingJobControllerApi.
 * @export
 * @interface SchedulingJobControllerApiGetWeekStatusesRequest
 */
export interface SchedulingJobControllerApiGetWeekStatusesRequest {
    /**
     * 
     * @type {string}
     * @memberof SchedulingJobControllerApiGetWeekStatuses
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof SchedulingJobControllerApiGetWeekStatuses
     */
    readonly scenarioId: string
}

/**
 * Request parameters for previewInput operation in SchedulingJobControllerApi.
 * @export
 * @interface SchedulingJobControllerApiPreviewInputRequest
 */
export interface SchedulingJobControllerApiPreviewInputRequest {
    /**
     * 
     * @type {string}
     * @memberof SchedulingJobControllerApiPreviewInput
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof SchedulingJobControllerApiPreviewInput
     */
    readonly scenarioId: string

    /**
     * 
     * @type {number}
     * @memberof SchedulingJobControllerApiPreviewInput
     */
    readonly weekNumber: number
}

/**
 * Request parameters for triggerCalculation operation in SchedulingJobControllerApi.
 * @export
 * @interface SchedulingJobControllerApiTriggerCalculationRequest
 */
export interface SchedulingJobControllerApiTriggerCalculationRequest {
    /**
     * 
     * @type {string}
     * @memberof SchedulingJobControllerApiTriggerCalculation
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof SchedulingJobControllerApiTriggerCalculation
     */
    readonly scenarioId: string

    /**
     * 
     * @type {number}
     * @memberof SchedulingJobControllerApiTriggerCalculation
     */
    readonly weekNumber: number
}

/**
 * SchedulingJobControllerApi - object-oriented interface
 * @export
 * @class SchedulingJobControllerApi
 * @extends {BaseAPI}
 */
export class SchedulingJobControllerApi extends BaseAPI implements SchedulingJobControllerApiInterface {
    /**
     * 
     * @param {SchedulingJobControllerApiGetCurrentResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulingJobControllerApi
     */
    public getCurrentResult(requestParameters: SchedulingJobControllerApiGetCurrentResultRequest, options?: RawAxiosRequestConfig) {
        return SchedulingJobControllerApiFp(this.configuration).getCurrentResult(requestParameters.locationId, requestParameters.scenarioId, requestParameters.weekNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SchedulingJobControllerApiGetLatestJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulingJobControllerApi
     */
    public getLatestJob(requestParameters: SchedulingJobControllerApiGetLatestJobRequest, options?: RawAxiosRequestConfig) {
        return SchedulingJobControllerApiFp(this.configuration).getLatestJob(requestParameters.locationId, requestParameters.scenarioId, requestParameters.weekNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SchedulingJobControllerApiGetWeekStatusesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulingJobControllerApi
     */
    public getWeekStatuses(requestParameters: SchedulingJobControllerApiGetWeekStatusesRequest, options?: RawAxiosRequestConfig) {
        return SchedulingJobControllerApiFp(this.configuration).getWeekStatuses(requestParameters.locationId, requestParameters.scenarioId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SchedulingJobControllerApiPreviewInputRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulingJobControllerApi
     */
    public previewInput(requestParameters: SchedulingJobControllerApiPreviewInputRequest, options?: RawAxiosRequestConfig) {
        return SchedulingJobControllerApiFp(this.configuration).previewInput(requestParameters.locationId, requestParameters.scenarioId, requestParameters.weekNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SchedulingJobControllerApiTriggerCalculationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulingJobControllerApi
     */
    public triggerCalculation(requestParameters: SchedulingJobControllerApiTriggerCalculationRequest, options?: RawAxiosRequestConfig) {
        return SchedulingJobControllerApiFp(this.configuration).triggerCalculation(requestParameters.locationId, requestParameters.scenarioId, requestParameters.weekNumber, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StaffControllerApi - axios parameter creator
 * @export
 */
export const StaffControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {CreateStaffRequest} createStaffRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStaff: async (locationId: string, createStaffRequest: CreateStaffRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('createStaff', 'locationId', locationId)
            // verify required parameter 'createStaffRequest' is not null or undefined
            assertParamExists('createStaff', 'createStaffRequest', createStaffRequest)
            const localVarPath = `/api/location/{locationId}/staff`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStaffRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStaff: async (locationId: string, staffId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deleteStaff', 'locationId', locationId)
            // verify required parameter 'staffId' is not null or undefined
            assertParamExists('deleteStaff', 'staffId', staffId)
            const localVarPath = `/api/location/{locationId}/staff/{staffId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"staffId"}}`, encodeURIComponent(String(staffId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaff: async (locationId: string, staffId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getStaff', 'locationId', locationId)
            // verify required parameter 'staffId' is not null or undefined
            assertParamExists('getStaff', 'staffId', staffId)
            const localVarPath = `/api/location/{locationId}/staff/{staffId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"staffId"}}`, encodeURIComponent(String(staffId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStaff: async (locationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('listStaff', 'locationId', locationId)
            const localVarPath = `/api/location/{locationId}/staff`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} staffId 
         * @param {UpdateStaffRequest} updateStaffRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStaff: async (locationId: string, staffId: string, updateStaffRequest: UpdateStaffRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('updateStaff', 'locationId', locationId)
            // verify required parameter 'staffId' is not null or undefined
            assertParamExists('updateStaff', 'staffId', staffId)
            // verify required parameter 'updateStaffRequest' is not null or undefined
            assertParamExists('updateStaff', 'updateStaffRequest', updateStaffRequest)
            const localVarPath = `/api/location/{locationId}/staff/{staffId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"staffId"}}`, encodeURIComponent(String(staffId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateStaffRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StaffControllerApi - functional programming interface
 * @export
 */
export const StaffControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StaffControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {CreateStaffRequest} createStaffRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStaff(locationId: string, createStaffRequest: CreateStaffRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StaffResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStaff(locationId, createStaffRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StaffControllerApi.createStaff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStaff(locationId: string, staffId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStaff(locationId, staffId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StaffControllerApi.deleteStaff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} staffId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStaff(locationId: string, staffId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StaffResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStaff(locationId, staffId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StaffControllerApi.getStaff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStaff(locationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StaffResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStaff(locationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StaffControllerApi.listStaff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} staffId 
         * @param {UpdateStaffRequest} updateStaffRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStaff(locationId: string, staffId: string, updateStaffRequest: UpdateStaffRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StaffResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStaff(locationId, staffId, updateStaffRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StaffControllerApi.updateStaff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StaffControllerApi - factory interface
 * @export
 */
export const StaffControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StaffControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {StaffControllerApiCreateStaffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStaff(requestParameters: StaffControllerApiCreateStaffRequest, options?: RawAxiosRequestConfig): AxiosPromise<StaffResponse> {
            return localVarFp.createStaff(requestParameters.locationId, requestParameters.createStaffRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StaffControllerApiDeleteStaffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStaff(requestParameters: StaffControllerApiDeleteStaffRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteStaff(requestParameters.locationId, requestParameters.staffId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StaffControllerApiGetStaffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaff(requestParameters: StaffControllerApiGetStaffRequest, options?: RawAxiosRequestConfig): AxiosPromise<StaffResponse> {
            return localVarFp.getStaff(requestParameters.locationId, requestParameters.staffId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StaffControllerApiListStaffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStaff(requestParameters: StaffControllerApiListStaffRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<StaffResponse>> {
            return localVarFp.listStaff(requestParameters.locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StaffControllerApiUpdateStaffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStaff(requestParameters: StaffControllerApiUpdateStaffRequest, options?: RawAxiosRequestConfig): AxiosPromise<StaffResponse> {
            return localVarFp.updateStaff(requestParameters.locationId, requestParameters.staffId, requestParameters.updateStaffRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StaffControllerApi - interface
 * @export
 * @interface StaffControllerApi
 */
export interface StaffControllerApiInterface {
    /**
     * 
     * @param {StaffControllerApiCreateStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffControllerApiInterface
     */
    createStaff(requestParameters: StaffControllerApiCreateStaffRequest, options?: RawAxiosRequestConfig): AxiosPromise<StaffResponse>;

    /**
     * 
     * @param {StaffControllerApiDeleteStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffControllerApiInterface
     */
    deleteStaff(requestParameters: StaffControllerApiDeleteStaffRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {StaffControllerApiGetStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffControllerApiInterface
     */
    getStaff(requestParameters: StaffControllerApiGetStaffRequest, options?: RawAxiosRequestConfig): AxiosPromise<StaffResponse>;

    /**
     * 
     * @param {StaffControllerApiListStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffControllerApiInterface
     */
    listStaff(requestParameters: StaffControllerApiListStaffRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<StaffResponse>>;

    /**
     * 
     * @param {StaffControllerApiUpdateStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffControllerApiInterface
     */
    updateStaff(requestParameters: StaffControllerApiUpdateStaffRequest, options?: RawAxiosRequestConfig): AxiosPromise<StaffResponse>;

}

/**
 * Request parameters for createStaff operation in StaffControllerApi.
 * @export
 * @interface StaffControllerApiCreateStaffRequest
 */
export interface StaffControllerApiCreateStaffRequest {
    /**
     * 
     * @type {string}
     * @memberof StaffControllerApiCreateStaff
     */
    readonly locationId: string

    /**
     * 
     * @type {CreateStaffRequest}
     * @memberof StaffControllerApiCreateStaff
     */
    readonly createStaffRequest: CreateStaffRequest
}

/**
 * Request parameters for deleteStaff operation in StaffControllerApi.
 * @export
 * @interface StaffControllerApiDeleteStaffRequest
 */
export interface StaffControllerApiDeleteStaffRequest {
    /**
     * 
     * @type {string}
     * @memberof StaffControllerApiDeleteStaff
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof StaffControllerApiDeleteStaff
     */
    readonly staffId: string
}

/**
 * Request parameters for getStaff operation in StaffControllerApi.
 * @export
 * @interface StaffControllerApiGetStaffRequest
 */
export interface StaffControllerApiGetStaffRequest {
    /**
     * 
     * @type {string}
     * @memberof StaffControllerApiGetStaff
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof StaffControllerApiGetStaff
     */
    readonly staffId: string
}

/**
 * Request parameters for listStaff operation in StaffControllerApi.
 * @export
 * @interface StaffControllerApiListStaffRequest
 */
export interface StaffControllerApiListStaffRequest {
    /**
     * 
     * @type {string}
     * @memberof StaffControllerApiListStaff
     */
    readonly locationId: string
}

/**
 * Request parameters for updateStaff operation in StaffControllerApi.
 * @export
 * @interface StaffControllerApiUpdateStaffRequest
 */
export interface StaffControllerApiUpdateStaffRequest {
    /**
     * 
     * @type {string}
     * @memberof StaffControllerApiUpdateStaff
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof StaffControllerApiUpdateStaff
     */
    readonly staffId: string

    /**
     * 
     * @type {UpdateStaffRequest}
     * @memberof StaffControllerApiUpdateStaff
     */
    readonly updateStaffRequest: UpdateStaffRequest
}

/**
 * StaffControllerApi - object-oriented interface
 * @export
 * @class StaffControllerApi
 * @extends {BaseAPI}
 */
export class StaffControllerApi extends BaseAPI implements StaffControllerApiInterface {
    /**
     * 
     * @param {StaffControllerApiCreateStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffControllerApi
     */
    public createStaff(requestParameters: StaffControllerApiCreateStaffRequest, options?: RawAxiosRequestConfig) {
        return StaffControllerApiFp(this.configuration).createStaff(requestParameters.locationId, requestParameters.createStaffRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StaffControllerApiDeleteStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffControllerApi
     */
    public deleteStaff(requestParameters: StaffControllerApiDeleteStaffRequest, options?: RawAxiosRequestConfig) {
        return StaffControllerApiFp(this.configuration).deleteStaff(requestParameters.locationId, requestParameters.staffId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StaffControllerApiGetStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffControllerApi
     */
    public getStaff(requestParameters: StaffControllerApiGetStaffRequest, options?: RawAxiosRequestConfig) {
        return StaffControllerApiFp(this.configuration).getStaff(requestParameters.locationId, requestParameters.staffId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StaffControllerApiListStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffControllerApi
     */
    public listStaff(requestParameters: StaffControllerApiListStaffRequest, options?: RawAxiosRequestConfig) {
        return StaffControllerApiFp(this.configuration).listStaff(requestParameters.locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StaffControllerApiUpdateStaffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffControllerApi
     */
    public updateStaff(requestParameters: StaffControllerApiUpdateStaffRequest, options?: RawAxiosRequestConfig) {
        return StaffControllerApiFp(this.configuration).updateStaff(requestParameters.locationId, requestParameters.staffId, requestParameters.updateStaffRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StaffProfessionControllerApi - axios parameter creator
 * @export
 */
export const StaffProfessionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} professionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archivePreview: async (professionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'professionId' is not null or undefined
            assertParamExists('archivePreview', 'professionId', professionId)
            const localVarPath = `/api/account/staff-professions/{professionId}/archive-preview`
                .replace(`{${"professionId"}}`, encodeURIComponent(String(professionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} professionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveStaffProfession: async (professionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'professionId' is not null or undefined
            assertParamExists('archiveStaffProfession', 'professionId', professionId)
            const localVarPath = `/api/account/staff-professions/{professionId}/archive`
                .replace(`{${"professionId"}}`, encodeURIComponent(String(professionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateStaffProfessionRequest} createStaffProfessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStaffProfession: async (createStaffProfessionRequest: CreateStaffProfessionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createStaffProfessionRequest' is not null or undefined
            assertParamExists('createStaffProfession', 'createStaffProfessionRequest', createStaffProfessionRequest)
            const localVarPath = `/api/account/staff-professions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStaffProfessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStaffProfessions: async (includeArchived?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/staff-professions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} professionId 
         * @param {UpdateStaffProfessionRequest} updateStaffProfessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStaffProfession: async (professionId: string, updateStaffProfessionRequest: UpdateStaffProfessionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'professionId' is not null or undefined
            assertParamExists('updateStaffProfession', 'professionId', professionId)
            // verify required parameter 'updateStaffProfessionRequest' is not null or undefined
            assertParamExists('updateStaffProfession', 'updateStaffProfessionRequest', updateStaffProfessionRequest)
            const localVarPath = `/api/account/staff-professions/{professionId}`
                .replace(`{${"professionId"}}`, encodeURIComponent(String(professionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateStaffProfessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StaffProfessionControllerApi - functional programming interface
 * @export
 */
export const StaffProfessionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StaffProfessionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} professionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archivePreview(professionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InterventionTemplateResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archivePreview(professionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StaffProfessionControllerApi.archivePreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} professionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveStaffProfession(professionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveStaffProfession(professionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StaffProfessionControllerApi.archiveStaffProfession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateStaffProfessionRequest} createStaffProfessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStaffProfession(createStaffProfessionRequest: CreateStaffProfessionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StaffProfessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStaffProfession(createStaffProfessionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StaffProfessionControllerApi.createStaffProfession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStaffProfessions(includeArchived?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StaffProfessionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStaffProfessions(includeArchived, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StaffProfessionControllerApi.listStaffProfessions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} professionId 
         * @param {UpdateStaffProfessionRequest} updateStaffProfessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStaffProfession(professionId: string, updateStaffProfessionRequest: UpdateStaffProfessionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StaffProfessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStaffProfession(professionId, updateStaffProfessionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StaffProfessionControllerApi.updateStaffProfession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StaffProfessionControllerApi - factory interface
 * @export
 */
export const StaffProfessionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StaffProfessionControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {StaffProfessionControllerApiArchivePreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archivePreview(requestParameters: StaffProfessionControllerApiArchivePreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<InterventionTemplateResponse>> {
            return localVarFp.archivePreview(requestParameters.professionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StaffProfessionControllerApiArchiveStaffProfessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveStaffProfession(requestParameters: StaffProfessionControllerApiArchiveStaffProfessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.archiveStaffProfession(requestParameters.professionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StaffProfessionControllerApiCreateStaffProfessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStaffProfession(requestParameters: StaffProfessionControllerApiCreateStaffProfessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<StaffProfessionResponse> {
            return localVarFp.createStaffProfession(requestParameters.createStaffProfessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StaffProfessionControllerApiListStaffProfessionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStaffProfessions(requestParameters: StaffProfessionControllerApiListStaffProfessionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<StaffProfessionResponse>> {
            return localVarFp.listStaffProfessions(requestParameters.includeArchived, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StaffProfessionControllerApiUpdateStaffProfessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStaffProfession(requestParameters: StaffProfessionControllerApiUpdateStaffProfessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<StaffProfessionResponse> {
            return localVarFp.updateStaffProfession(requestParameters.professionId, requestParameters.updateStaffProfessionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StaffProfessionControllerApi - interface
 * @export
 * @interface StaffProfessionControllerApi
 */
export interface StaffProfessionControllerApiInterface {
    /**
     * 
     * @param {StaffProfessionControllerApiArchivePreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffProfessionControllerApiInterface
     */
    archivePreview(requestParameters: StaffProfessionControllerApiArchivePreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<InterventionTemplateResponse>>;

    /**
     * 
     * @param {StaffProfessionControllerApiArchiveStaffProfessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffProfessionControllerApiInterface
     */
    archiveStaffProfession(requestParameters: StaffProfessionControllerApiArchiveStaffProfessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {StaffProfessionControllerApiCreateStaffProfessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffProfessionControllerApiInterface
     */
    createStaffProfession(requestParameters: StaffProfessionControllerApiCreateStaffProfessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<StaffProfessionResponse>;

    /**
     * 
     * @param {StaffProfessionControllerApiListStaffProfessionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffProfessionControllerApiInterface
     */
    listStaffProfessions(requestParameters?: StaffProfessionControllerApiListStaffProfessionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<StaffProfessionResponse>>;

    /**
     * 
     * @param {StaffProfessionControllerApiUpdateStaffProfessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffProfessionControllerApiInterface
     */
    updateStaffProfession(requestParameters: StaffProfessionControllerApiUpdateStaffProfessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<StaffProfessionResponse>;

}

/**
 * Request parameters for archivePreview operation in StaffProfessionControllerApi.
 * @export
 * @interface StaffProfessionControllerApiArchivePreviewRequest
 */
export interface StaffProfessionControllerApiArchivePreviewRequest {
    /**
     * 
     * @type {string}
     * @memberof StaffProfessionControllerApiArchivePreview
     */
    readonly professionId: string
}

/**
 * Request parameters for archiveStaffProfession operation in StaffProfessionControllerApi.
 * @export
 * @interface StaffProfessionControllerApiArchiveStaffProfessionRequest
 */
export interface StaffProfessionControllerApiArchiveStaffProfessionRequest {
    /**
     * 
     * @type {string}
     * @memberof StaffProfessionControllerApiArchiveStaffProfession
     */
    readonly professionId: string
}

/**
 * Request parameters for createStaffProfession operation in StaffProfessionControllerApi.
 * @export
 * @interface StaffProfessionControllerApiCreateStaffProfessionRequest
 */
export interface StaffProfessionControllerApiCreateStaffProfessionRequest {
    /**
     * 
     * @type {CreateStaffProfessionRequest}
     * @memberof StaffProfessionControllerApiCreateStaffProfession
     */
    readonly createStaffProfessionRequest: CreateStaffProfessionRequest
}

/**
 * Request parameters for listStaffProfessions operation in StaffProfessionControllerApi.
 * @export
 * @interface StaffProfessionControllerApiListStaffProfessionsRequest
 */
export interface StaffProfessionControllerApiListStaffProfessionsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof StaffProfessionControllerApiListStaffProfessions
     */
    readonly includeArchived?: boolean
}

/**
 * Request parameters for updateStaffProfession operation in StaffProfessionControllerApi.
 * @export
 * @interface StaffProfessionControllerApiUpdateStaffProfessionRequest
 */
export interface StaffProfessionControllerApiUpdateStaffProfessionRequest {
    /**
     * 
     * @type {string}
     * @memberof StaffProfessionControllerApiUpdateStaffProfession
     */
    readonly professionId: string

    /**
     * 
     * @type {UpdateStaffProfessionRequest}
     * @memberof StaffProfessionControllerApiUpdateStaffProfession
     */
    readonly updateStaffProfessionRequest: UpdateStaffProfessionRequest
}

/**
 * StaffProfessionControllerApi - object-oriented interface
 * @export
 * @class StaffProfessionControllerApi
 * @extends {BaseAPI}
 */
export class StaffProfessionControllerApi extends BaseAPI implements StaffProfessionControllerApiInterface {
    /**
     * 
     * @param {StaffProfessionControllerApiArchivePreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffProfessionControllerApi
     */
    public archivePreview(requestParameters: StaffProfessionControllerApiArchivePreviewRequest, options?: RawAxiosRequestConfig) {
        return StaffProfessionControllerApiFp(this.configuration).archivePreview(requestParameters.professionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StaffProfessionControllerApiArchiveStaffProfessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffProfessionControllerApi
     */
    public archiveStaffProfession(requestParameters: StaffProfessionControllerApiArchiveStaffProfessionRequest, options?: RawAxiosRequestConfig) {
        return StaffProfessionControllerApiFp(this.configuration).archiveStaffProfession(requestParameters.professionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StaffProfessionControllerApiCreateStaffProfessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffProfessionControllerApi
     */
    public createStaffProfession(requestParameters: StaffProfessionControllerApiCreateStaffProfessionRequest, options?: RawAxiosRequestConfig) {
        return StaffProfessionControllerApiFp(this.configuration).createStaffProfession(requestParameters.createStaffProfessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StaffProfessionControllerApiListStaffProfessionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffProfessionControllerApi
     */
    public listStaffProfessions(requestParameters: StaffProfessionControllerApiListStaffProfessionsRequest = {}, options?: RawAxiosRequestConfig) {
        return StaffProfessionControllerApiFp(this.configuration).listStaffProfessions(requestParameters.includeArchived, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StaffProfessionControllerApiUpdateStaffProfessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaffProfessionControllerApi
     */
    public updateStaffProfession(requestParameters: StaffProfessionControllerApiUpdateStaffProfessionRequest, options?: RawAxiosRequestConfig) {
        return StaffProfessionControllerApiFp(this.configuration).updateStaffProfession(requestParameters.professionId, requestParameters.updateStaffProfessionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TreatmentPlanTemplateControllerApi - axios parameter creator
 * @export
 */
export const TreatmentPlanTemplateControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateTreatmentPlanTemplateRequest} createTreatmentPlanTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTreatmentPlanTemplate: async (createTreatmentPlanTemplateRequest: CreateTreatmentPlanTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTreatmentPlanTemplateRequest' is not null or undefined
            assertParamExists('createTreatmentPlanTemplate', 'createTreatmentPlanTemplateRequest', createTreatmentPlanTemplateRequest)
            const localVarPath = `/api/account/treatment-plan-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTreatmentPlanTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} treatmentPlanTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTreatmentPlanTemplate: async (treatmentPlanTemplateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treatmentPlanTemplateId' is not null or undefined
            assertParamExists('deleteTreatmentPlanTemplate', 'treatmentPlanTemplateId', treatmentPlanTemplateId)
            const localVarPath = `/api/account/treatment-plan-templates/{treatmentPlanTemplateId}`
                .replace(`{${"treatmentPlanTemplateId"}}`, encodeURIComponent(String(treatmentPlanTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentPlanTemplates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/treatment-plan-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} treatmentPlanTemplateId 
         * @param {UpdateTreatmentPlanTemplateRequest} updateTreatmentPlanTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTreatmentPlanTemplate: async (treatmentPlanTemplateId: string, updateTreatmentPlanTemplateRequest: UpdateTreatmentPlanTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treatmentPlanTemplateId' is not null or undefined
            assertParamExists('updateTreatmentPlanTemplate', 'treatmentPlanTemplateId', treatmentPlanTemplateId)
            // verify required parameter 'updateTreatmentPlanTemplateRequest' is not null or undefined
            assertParamExists('updateTreatmentPlanTemplate', 'updateTreatmentPlanTemplateRequest', updateTreatmentPlanTemplateRequest)
            const localVarPath = `/api/account/treatment-plan-templates/{treatmentPlanTemplateId}`
                .replace(`{${"treatmentPlanTemplateId"}}`, encodeURIComponent(String(treatmentPlanTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTreatmentPlanTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TreatmentPlanTemplateControllerApi - functional programming interface
 * @export
 */
export const TreatmentPlanTemplateControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TreatmentPlanTemplateControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateTreatmentPlanTemplateRequest} createTreatmentPlanTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTreatmentPlanTemplate(createTreatmentPlanTemplateRequest: CreateTreatmentPlanTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TreatmentPlanTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTreatmentPlanTemplate(createTreatmentPlanTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TreatmentPlanTemplateControllerApi.createTreatmentPlanTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} treatmentPlanTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTreatmentPlanTemplate(treatmentPlanTemplateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTreatmentPlanTemplate(treatmentPlanTemplateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TreatmentPlanTemplateControllerApi.deleteTreatmentPlanTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreatmentPlanTemplates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TreatmentPlanTemplateResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreatmentPlanTemplates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TreatmentPlanTemplateControllerApi.getTreatmentPlanTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} treatmentPlanTemplateId 
         * @param {UpdateTreatmentPlanTemplateRequest} updateTreatmentPlanTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTreatmentPlanTemplate(treatmentPlanTemplateId: string, updateTreatmentPlanTemplateRequest: UpdateTreatmentPlanTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TreatmentPlanTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTreatmentPlanTemplate(treatmentPlanTemplateId, updateTreatmentPlanTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TreatmentPlanTemplateControllerApi.updateTreatmentPlanTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TreatmentPlanTemplateControllerApi - factory interface
 * @export
 */
export const TreatmentPlanTemplateControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TreatmentPlanTemplateControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {TreatmentPlanTemplateControllerApiCreateTreatmentPlanTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTreatmentPlanTemplate(requestParameters: TreatmentPlanTemplateControllerApiCreateTreatmentPlanTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TreatmentPlanTemplateResponse> {
            return localVarFp.createTreatmentPlanTemplate(requestParameters.createTreatmentPlanTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TreatmentPlanTemplateControllerApiDeleteTreatmentPlanTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTreatmentPlanTemplate(requestParameters: TreatmentPlanTemplateControllerApiDeleteTreatmentPlanTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTreatmentPlanTemplate(requestParameters.treatmentPlanTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentPlanTemplates(options?: RawAxiosRequestConfig): AxiosPromise<Array<TreatmentPlanTemplateResponse>> {
            return localVarFp.getTreatmentPlanTemplates(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TreatmentPlanTemplateControllerApiUpdateTreatmentPlanTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTreatmentPlanTemplate(requestParameters: TreatmentPlanTemplateControllerApiUpdateTreatmentPlanTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TreatmentPlanTemplateResponse> {
            return localVarFp.updateTreatmentPlanTemplate(requestParameters.treatmentPlanTemplateId, requestParameters.updateTreatmentPlanTemplateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TreatmentPlanTemplateControllerApi - interface
 * @export
 * @interface TreatmentPlanTemplateControllerApi
 */
export interface TreatmentPlanTemplateControllerApiInterface {
    /**
     * 
     * @param {TreatmentPlanTemplateControllerApiCreateTreatmentPlanTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentPlanTemplateControllerApiInterface
     */
    createTreatmentPlanTemplate(requestParameters: TreatmentPlanTemplateControllerApiCreateTreatmentPlanTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TreatmentPlanTemplateResponse>;

    /**
     * 
     * @param {TreatmentPlanTemplateControllerApiDeleteTreatmentPlanTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentPlanTemplateControllerApiInterface
     */
    deleteTreatmentPlanTemplate(requestParameters: TreatmentPlanTemplateControllerApiDeleteTreatmentPlanTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentPlanTemplateControllerApiInterface
     */
    getTreatmentPlanTemplates(options?: RawAxiosRequestConfig): AxiosPromise<Array<TreatmentPlanTemplateResponse>>;

    /**
     * 
     * @param {TreatmentPlanTemplateControllerApiUpdateTreatmentPlanTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentPlanTemplateControllerApiInterface
     */
    updateTreatmentPlanTemplate(requestParameters: TreatmentPlanTemplateControllerApiUpdateTreatmentPlanTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TreatmentPlanTemplateResponse>;

}

/**
 * Request parameters for createTreatmentPlanTemplate operation in TreatmentPlanTemplateControllerApi.
 * @export
 * @interface TreatmentPlanTemplateControllerApiCreateTreatmentPlanTemplateRequest
 */
export interface TreatmentPlanTemplateControllerApiCreateTreatmentPlanTemplateRequest {
    /**
     * 
     * @type {CreateTreatmentPlanTemplateRequest}
     * @memberof TreatmentPlanTemplateControllerApiCreateTreatmentPlanTemplate
     */
    readonly createTreatmentPlanTemplateRequest: CreateTreatmentPlanTemplateRequest
}

/**
 * Request parameters for deleteTreatmentPlanTemplate operation in TreatmentPlanTemplateControllerApi.
 * @export
 * @interface TreatmentPlanTemplateControllerApiDeleteTreatmentPlanTemplateRequest
 */
export interface TreatmentPlanTemplateControllerApiDeleteTreatmentPlanTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentPlanTemplateControllerApiDeleteTreatmentPlanTemplate
     */
    readonly treatmentPlanTemplateId: string
}

/**
 * Request parameters for updateTreatmentPlanTemplate operation in TreatmentPlanTemplateControllerApi.
 * @export
 * @interface TreatmentPlanTemplateControllerApiUpdateTreatmentPlanTemplateRequest
 */
export interface TreatmentPlanTemplateControllerApiUpdateTreatmentPlanTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentPlanTemplateControllerApiUpdateTreatmentPlanTemplate
     */
    readonly treatmentPlanTemplateId: string

    /**
     * 
     * @type {UpdateTreatmentPlanTemplateRequest}
     * @memberof TreatmentPlanTemplateControllerApiUpdateTreatmentPlanTemplate
     */
    readonly updateTreatmentPlanTemplateRequest: UpdateTreatmentPlanTemplateRequest
}

/**
 * TreatmentPlanTemplateControllerApi - object-oriented interface
 * @export
 * @class TreatmentPlanTemplateControllerApi
 * @extends {BaseAPI}
 */
export class TreatmentPlanTemplateControllerApi extends BaseAPI implements TreatmentPlanTemplateControllerApiInterface {
    /**
     * 
     * @param {TreatmentPlanTemplateControllerApiCreateTreatmentPlanTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentPlanTemplateControllerApi
     */
    public createTreatmentPlanTemplate(requestParameters: TreatmentPlanTemplateControllerApiCreateTreatmentPlanTemplateRequest, options?: RawAxiosRequestConfig) {
        return TreatmentPlanTemplateControllerApiFp(this.configuration).createTreatmentPlanTemplate(requestParameters.createTreatmentPlanTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentPlanTemplateControllerApiDeleteTreatmentPlanTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentPlanTemplateControllerApi
     */
    public deleteTreatmentPlanTemplate(requestParameters: TreatmentPlanTemplateControllerApiDeleteTreatmentPlanTemplateRequest, options?: RawAxiosRequestConfig) {
        return TreatmentPlanTemplateControllerApiFp(this.configuration).deleteTreatmentPlanTemplate(requestParameters.treatmentPlanTemplateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentPlanTemplateControllerApi
     */
    public getTreatmentPlanTemplates(options?: RawAxiosRequestConfig) {
        return TreatmentPlanTemplateControllerApiFp(this.configuration).getTreatmentPlanTemplates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentPlanTemplateControllerApiUpdateTreatmentPlanTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentPlanTemplateControllerApi
     */
    public updateTreatmentPlanTemplate(requestParameters: TreatmentPlanTemplateControllerApiUpdateTreatmentPlanTemplateRequest, options?: RawAxiosRequestConfig) {
        return TreatmentPlanTemplateControllerApiFp(this.configuration).updateTreatmentPlanTemplate(requestParameters.treatmentPlanTemplateId, requestParameters.updateTreatmentPlanTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserControllerApi - axios parameter creator
 * @export
 */
export const UserControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateUserRequest} createUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (createUserRequest: CreateUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserRequest' is not null or undefined
            assertParamExists('createUser', 'createUserRequest', createUserRequest)
            const localVarPath = `/api/account/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUser', 'userId', userId)
            const localVarPath = `/api/account/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserGlobalAdmin: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/users/current/global-admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserPermissions: async (locationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getCurrentUserPermissions', 'locationId', locationId)
            const localVarPath = `/api/account/users/current/permissions/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUser', 'userId', userId)
            const localVarPath = `/api/account/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {UpdateUserRequest} updateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (userId: string, updateUserRequest: UpdateUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUser', 'userId', userId)
            // verify required parameter 'updateUserRequest' is not null or undefined
            assertParamExists('updateUser', 'updateUserRequest', updateUserRequest)
            const localVarPath = `/api/account/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserControllerApi - functional programming interface
 * @export
 */
export const UserControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateUserRequest} createUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(createUserRequest: CreateUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(createUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.createUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.deleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUsers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDetailResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUsers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getAllUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUserGlobalAdmin(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlobalAdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUserGlobalAdmin(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getCurrentUserGlobalAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUserPermissions(locationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationPermissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUserPermissions(locationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getCurrentUserPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {UpdateUserRequest} updateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(userId: string, updateUserRequest: UpdateUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(userId, updateUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.updateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserControllerApi - factory interface
 * @export
 */
export const UserControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {UserControllerApiCreateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(requestParameters: UserControllerApiCreateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.createUser(requestParameters.createUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserControllerApiDeleteUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(requestParameters: UserControllerApiDeleteUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUser(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserDetailResponse>> {
            return localVarFp.getAllUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserGlobalAdmin(options?: RawAxiosRequestConfig): AxiosPromise<GlobalAdminResponse> {
            return localVarFp.getCurrentUserGlobalAdmin(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserControllerApiGetCurrentUserPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserPermissions(requestParameters: UserControllerApiGetCurrentUserPermissionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<LocationPermissionsResponse> {
            return localVarFp.getCurrentUserPermissions(requestParameters.locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserControllerApiGetUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(requestParameters: UserControllerApiGetUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDetailResponse> {
            return localVarFp.getUser(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserControllerApiUpdateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(requestParameters: UserControllerApiUpdateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDetailResponse> {
            return localVarFp.updateUser(requestParameters.userId, requestParameters.updateUserRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserControllerApi - interface
 * @export
 * @interface UserControllerApi
 */
export interface UserControllerApiInterface {
    /**
     * 
     * @param {UserControllerApiCreateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    createUser(requestParameters: UserControllerApiCreateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse>;

    /**
     * 
     * @param {UserControllerApiDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    deleteUser(requestParameters: UserControllerApiDeleteUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    getAllUsers(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserDetailResponse>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    getCurrentUserGlobalAdmin(options?: RawAxiosRequestConfig): AxiosPromise<GlobalAdminResponse>;

    /**
     * 
     * @param {UserControllerApiGetCurrentUserPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    getCurrentUserPermissions(requestParameters: UserControllerApiGetCurrentUserPermissionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<LocationPermissionsResponse>;

    /**
     * 
     * @param {UserControllerApiGetUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    getUser(requestParameters: UserControllerApiGetUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDetailResponse>;

    /**
     * 
     * @param {UserControllerApiUpdateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    updateUser(requestParameters: UserControllerApiUpdateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDetailResponse>;

}

/**
 * Request parameters for createUser operation in UserControllerApi.
 * @export
 * @interface UserControllerApiCreateUserRequest
 */
export interface UserControllerApiCreateUserRequest {
    /**
     * 
     * @type {CreateUserRequest}
     * @memberof UserControllerApiCreateUser
     */
    readonly createUserRequest: CreateUserRequest
}

/**
 * Request parameters for deleteUser operation in UserControllerApi.
 * @export
 * @interface UserControllerApiDeleteUserRequest
 */
export interface UserControllerApiDeleteUserRequest {
    /**
     * 
     * @type {string}
     * @memberof UserControllerApiDeleteUser
     */
    readonly userId: string
}

/**
 * Request parameters for getCurrentUserPermissions operation in UserControllerApi.
 * @export
 * @interface UserControllerApiGetCurrentUserPermissionsRequest
 */
export interface UserControllerApiGetCurrentUserPermissionsRequest {
    /**
     * 
     * @type {string}
     * @memberof UserControllerApiGetCurrentUserPermissions
     */
    readonly locationId: string
}

/**
 * Request parameters for getUser operation in UserControllerApi.
 * @export
 * @interface UserControllerApiGetUserRequest
 */
export interface UserControllerApiGetUserRequest {
    /**
     * 
     * @type {string}
     * @memberof UserControllerApiGetUser
     */
    readonly userId: string
}

/**
 * Request parameters for updateUser operation in UserControllerApi.
 * @export
 * @interface UserControllerApiUpdateUserRequest
 */
export interface UserControllerApiUpdateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof UserControllerApiUpdateUser
     */
    readonly userId: string

    /**
     * 
     * @type {UpdateUserRequest}
     * @memberof UserControllerApiUpdateUser
     */
    readonly updateUserRequest: UpdateUserRequest
}

/**
 * UserControllerApi - object-oriented interface
 * @export
 * @class UserControllerApi
 * @extends {BaseAPI}
 */
export class UserControllerApi extends BaseAPI implements UserControllerApiInterface {
    /**
     * 
     * @param {UserControllerApiCreateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public createUser(requestParameters: UserControllerApiCreateUserRequest, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).createUser(requestParameters.createUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserControllerApiDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public deleteUser(requestParameters: UserControllerApiDeleteUserRequest, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).deleteUser(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public getAllUsers(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getAllUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public getCurrentUserGlobalAdmin(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getCurrentUserGlobalAdmin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserControllerApiGetCurrentUserPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public getCurrentUserPermissions(requestParameters: UserControllerApiGetCurrentUserPermissionsRequest, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getCurrentUserPermissions(requestParameters.locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserControllerApiGetUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public getUser(requestParameters: UserControllerApiGetUserRequest, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getUser(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserControllerApiUpdateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public updateUser(requestParameters: UserControllerApiUpdateUserRequest, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).updateUser(requestParameters.userId, requestParameters.updateUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * YearPlanControllerApi - axios parameter creator
 * @export
 */
export const YearPlanControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getYearPlan: async (locationId: string, scenarioId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getYearPlan', 'locationId', locationId)
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('getYearPlan', 'scenarioId', scenarioId)
            const localVarPath = `/api/location/{locationId}/scenario/{scenarioId}/yearplan`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"scenarioId"}}`, encodeURIComponent(String(scenarioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {UpdateTreatmentPlansRequest} updateTreatmentPlansRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTreatmentPlans: async (locationId: string, scenarioId: string, updateTreatmentPlansRequest: UpdateTreatmentPlansRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('updateTreatmentPlans', 'locationId', locationId)
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('updateTreatmentPlans', 'scenarioId', scenarioId)
            // verify required parameter 'updateTreatmentPlansRequest' is not null or undefined
            assertParamExists('updateTreatmentPlans', 'updateTreatmentPlansRequest', updateTreatmentPlansRequest)
            const localVarPath = `/api/location/{locationId}/scenario/{scenarioId}/yearplan/treatmentplans`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"scenarioId"}}`, encodeURIComponent(String(scenarioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTreatmentPlansRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * YearPlanControllerApi - functional programming interface
 * @export
 */
export const YearPlanControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = YearPlanControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getYearPlan(locationId: string, scenarioId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YearPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getYearPlan(locationId, scenarioId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YearPlanControllerApi.getYearPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} scenarioId 
         * @param {UpdateTreatmentPlansRequest} updateTreatmentPlansRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTreatmentPlans(locationId: string, scenarioId: string, updateTreatmentPlansRequest: UpdateTreatmentPlansRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YearPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTreatmentPlans(locationId, scenarioId, updateTreatmentPlansRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YearPlanControllerApi.updateTreatmentPlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * YearPlanControllerApi - factory interface
 * @export
 */
export const YearPlanControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = YearPlanControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {YearPlanControllerApiGetYearPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getYearPlan(requestParameters: YearPlanControllerApiGetYearPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<YearPlanResponse> {
            return localVarFp.getYearPlan(requestParameters.locationId, requestParameters.scenarioId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YearPlanControllerApiUpdateTreatmentPlansRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTreatmentPlans(requestParameters: YearPlanControllerApiUpdateTreatmentPlansRequest, options?: RawAxiosRequestConfig): AxiosPromise<YearPlanResponse> {
            return localVarFp.updateTreatmentPlans(requestParameters.locationId, requestParameters.scenarioId, requestParameters.updateTreatmentPlansRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * YearPlanControllerApi - interface
 * @export
 * @interface YearPlanControllerApi
 */
export interface YearPlanControllerApiInterface {
    /**
     * 
     * @param {YearPlanControllerApiGetYearPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YearPlanControllerApiInterface
     */
    getYearPlan(requestParameters: YearPlanControllerApiGetYearPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<YearPlanResponse>;

    /**
     * 
     * @param {YearPlanControllerApiUpdateTreatmentPlansRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YearPlanControllerApiInterface
     */
    updateTreatmentPlans(requestParameters: YearPlanControllerApiUpdateTreatmentPlansRequest, options?: RawAxiosRequestConfig): AxiosPromise<YearPlanResponse>;

}

/**
 * Request parameters for getYearPlan operation in YearPlanControllerApi.
 * @export
 * @interface YearPlanControllerApiGetYearPlanRequest
 */
export interface YearPlanControllerApiGetYearPlanRequest {
    /**
     * 
     * @type {string}
     * @memberof YearPlanControllerApiGetYearPlan
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof YearPlanControllerApiGetYearPlan
     */
    readonly scenarioId: string
}

/**
 * Request parameters for updateTreatmentPlans operation in YearPlanControllerApi.
 * @export
 * @interface YearPlanControllerApiUpdateTreatmentPlansRequest
 */
export interface YearPlanControllerApiUpdateTreatmentPlansRequest {
    /**
     * 
     * @type {string}
     * @memberof YearPlanControllerApiUpdateTreatmentPlans
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof YearPlanControllerApiUpdateTreatmentPlans
     */
    readonly scenarioId: string

    /**
     * 
     * @type {UpdateTreatmentPlansRequest}
     * @memberof YearPlanControllerApiUpdateTreatmentPlans
     */
    readonly updateTreatmentPlansRequest: UpdateTreatmentPlansRequest
}

/**
 * YearPlanControllerApi - object-oriented interface
 * @export
 * @class YearPlanControllerApi
 * @extends {BaseAPI}
 */
export class YearPlanControllerApi extends BaseAPI implements YearPlanControllerApiInterface {
    /**
     * 
     * @param {YearPlanControllerApiGetYearPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YearPlanControllerApi
     */
    public getYearPlan(requestParameters: YearPlanControllerApiGetYearPlanRequest, options?: RawAxiosRequestConfig) {
        return YearPlanControllerApiFp(this.configuration).getYearPlan(requestParameters.locationId, requestParameters.scenarioId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YearPlanControllerApiUpdateTreatmentPlansRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YearPlanControllerApi
     */
    public updateTreatmentPlans(requestParameters: YearPlanControllerApiUpdateTreatmentPlansRequest, options?: RawAxiosRequestConfig) {
        return YearPlanControllerApiFp(this.configuration).updateTreatmentPlans(requestParameters.locationId, requestParameters.scenarioId, requestParameters.updateTreatmentPlansRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



